export default {
  // "View history" button next to a field (showHistory in the model definition)
  fieldHistory: {
    button: "View history",
    title: "{field} history",
    loading: "Loading history…",
    empty: "No saved changes yet.",
    error: "The history could not be loaded.",
    original: "Original",
    current: "Current",
    empty_value: "(empty)",
    system: "System",
    days: "{n} days",
    sinceOriginal: "{diff} from the original",
  },
  Pay: "Pay",
  "Edit payment details": "Edit payment details",
  // "On the web" on the profile: contacts and products (searched once)
  webProfile: {
    title: "More info",
    searching: "Searching the web…",
    notFound: "No reliable information was found on the web.",
    noKey: "A DeepSeek API key is needed in Settings to search for information.",
    noName: "It has no name, so there is nothing to search for.",
    error: "Information could not be searched.",
    founded: "Founded in {year}",
    products: "Products and services",
    markets: "Markets",
    links: "Links",
    otherNames: "Other names",
    origin: "Origin",
    presentations: "Presentations",
    uses: "Uses",
    searched: "Searched {date}",
    sources: "{n} sources",
    searchAgain: "Search again",
    addAll: "Add all",
    inProduct: "Already in the product",
    addToProduct: "Add to the product",
    applyError: "Could not add it to the product.",
  },
  // "Insights" tab of a product's profile (widgets)
  productWidgets: {
    catalogTitle: "Product profile widgets",
    catalogSubtitle: "Choose what to see on product profiles: it applies to all of them. Amounts only appear with finance permission; the \"Market\" ones search the web only if you add one.",
    empty: "Choose what you want to see about this product.",
    truncated: "Showing the first 5000 lines per source.",
    resetConfirmText: "The default widgets will be shown again on every product profile.",
    noSources: "There are no operations with this product that you can see.",
    noOperations: "No operations on this side.",
    noData: "No data to show.",
    noUnit: "no unit",
    first: "First",
    last: "Last",
    buyersCount: "Buyers",
    sellersCount: "Suppliers",
    qty: "Quantity",
    total: "Total",
    showingLast: "Last {n} of {total}.",
    others: "Others",
    sources: { contract: "Contracts", shipping: "Shipments", proform: "Proformas" },
    kinds: { sale: "Sale", purchase: "Purchase", trade: "Brokerage" },
    measure: { qty: "Quantity", operations: "Operations" },
    menu: {
      source: "Operations",
      side: "Side",
      period: "Period",
      months: "Last {n} months",
      allTime: "All time",
      show: "Show",
      top: "Top {n}",
      measure: "Measure by",
      unit: "Unit",
    },
    items: {
      product_summary: { title: "Summary", description: "Operations, first and last, buyers, suppliers, quantity and total." },
      product_operations: { title: "Latest operations", description: "Where the product appears, with whom, how much and for how much." },
      product_by_month: { title: "By month", description: "Quantity or operations per month." },
      product_buyers: { title: "Buyers", description: "Who bought the most, by quantity or operations." },
      product_sellers: { title: "Suppliers", description: "Who it was bought from the most, by quantity or operations." },
      product_volume: { title: "Volume by month", description: "Amount per month, in one currency." },
      product_price: { title: "Average price", description: "Price per unit each month: amount over quantity." },
      product_market: { title: "Market: summary", description: "How the product's market looks, according to the web. It only searches if you add a market widget." },
      product_market_exporters: { title: "Market: exporters", description: "Top exporting countries, with figures when the web has them." },
      product_market_importers: { title: "Market: importers", description: "Top importing countries, with figures when the web has them." },
      product_market_prices: { title: "Market: prices", description: "Prices published on the web, with date and currency." },
      product_market_trends: { title: "Market: trends", description: "What is changing in the product's market." },
      product_market_companies: { title: "Market: companies", description: "Companies that trade it, according to the web." },
    },
    market: {
      searching: "Searching the web for market data…",
      notFound: "No reliable market data was found for this product.",
      emptySection: "The search found nothing for this part.",
      fromWeb: "From the web, {date}: check the sources",
    },
  },
  // "Insights" tab of a contact's profile (widgets)
  contactWidgets: {
    catalogTitle: "Contact profile widgets",
    catalogSubtitle: "Choose what to see on contact profiles: it applies to all of them. Amounts only show with finance permission.",
    tab: "Insights",
    empty: "Choose what you want to see about this contact.",
    truncated: "Showing the first 3000 operations.",
    resetConfirmText: "The default widgets will be shown again on every contact's profile.",
    noSources: "There are no operations you can see for this contact.",
    noOperations: "This contact is not part of any operation yet.",
    noData: "No data to show.",
    first: "First",
    last: "Last",
    productsCount: "Products",
    counterpartsCount: "Counterparts",
    total: "Total",
    showingLast: "Last {n} of {total}.",
    others: "Others",
    with: "with {names}",
    sources: { contract: "Contracts", shipping: "Shipments", proform: "Proformas" },
    roles: {
      buyer: "Buyer",
      seller: "Seller",
      administrator: "Administration",
      client: "Client",
      supplier: "Supplier",
      forwarder: "Forwarder",
      shippingLine: "Shipping line",
    },
    measure: { qty: "Quantity", operations: "Operations" },
    flow: { collected: "Collected", paid: "Paid" },
    menu: {
      source: "Operations",
      period: "Period",
      months: "Last {n} months",
      allTime: "All time",
      show: "Show",
      top: "Top {n}",
      measure: "Measure by",
      flow: "Movements",
    },
    items: {
      contact_summary: { title: "Summary", description: "How many operations, the first and the last, products and counterparts." },
      contact_operations: { title: "Operations", description: "The contact's latest operations, with its role and counterpart." },
      contact_by_month: { title: "Operations per month", description: "How many operations each month." },
      contact_by_role: { title: "By role", description: "In how many operations it was client, supplier, buyer, seller…" },
      contact_products: { title: "Products", description: "Which products it trades, by quantity or by number of operations." },
      contact_counterparts: { title: "Who it trades with", description: "The counterparts with the most operations." },
      contact_volume: { title: "Volume per month", description: "Amount of each month's operations, in one currency." },
      contact_products_amount: { title: "Products by amount", description: "Which products add up to the most money, in one currency." },
      contact_money_flow: { title: "Collections and payments", description: "What was collected from or paid to it each month." },
    },
  },
  itemProfile: {
    tabProfile: "Overview",
    outgoing: "Outgoing payment",
    incoming: "Incoming collection",
    statusPaid: "Paid",
    statusReceived: "Received",
    partyMissing: "Not set",
    files: "Files",
    noteGiving: "Issued note",
    noteReceiving: "Received note",
    balances: "Balances",
    copy: "Copy",
    editHint: "Click a field to edit it. Each change is saved when you confirm it.",
    doneEditing: "Done",
    addValue: "Add…",
    addRow: "Add row",
    addAnother: "Add another",
    moreInfo: "More info",
    unlockField: "Locked field: click to edit it",
    classicView: "Previous view",
    newView: "New view",
    classicViewHint: "If you don't like this view, you can go back to the previous one from here.",
    classicViewHintOk: "Got it",
    generateNumber: "Generate number",
    general: "General",
    details: "Details",
    saveError: "The field could not be saved",
  },
  // Required fields left empty on a record (list and profile, #473)
  missingRequired: {
    summary: "Missing required data",
    tooltip: "Missing required data: {fields}",
    field: "Required: please fill in",
  },
  calendarLegend: {
    fieldTooltip:
      "Comes from the «{field}» field of the {model} model ({path}). The number counts the records with that date in the month you are viewing. Which dates go to the calendar is set in the model definition (the field's calendar option).",
    shippingStatusTooltip:
      "Shipments with status «{status}»: the color is the shipment status, not the date type. The number counts their dates this month shown in the calendar.",
    groupCount: "{count} events",
    groupExpand: "{count} «{field}» events on this day. Click to see them.",
    groupCollapse: "Click to group them again.",
    toggleHide: "Click to hide them from the calendar.",
    toggleShow: "Hidden: click to show them again.",
  },
  dateInput: {
    placeholder: "dd/mm/yyyy",
    openCalendar: "Open calendar",
    invalid: "Invalid date: use dd/mm/yyyy",
  },
  listMerge: {
    button: "Merge terms",
    buttonTitle: "Merge duplicate or similar terms into one, updating every record that uses them",
    title: "Merge terms",
    intro: "Build groups of terms that mean the same thing. Each group keeps a single term: every record using the others switches to it, and the others are removed from the list.",
    sameName: "Same name",
    similarName: "Similar names",
    similarityTitle: "How similar the names must be",
    pickByHand: "Pick by hand",
    toolbarHint: "Suggestions only group terms under the same parent. Review each group before continuing.",
    searchPlaceholder: "Search term…",
    createGroup: "Create group ({count})",
    addToGroup: "Add to group ({count})",
    destinationNew: "New group",
    destinationGroup: "Group {n}: {label}",
    alreadyInGroup: "already grouped",
    noTermsFound: "No matching terms.",
    noGroups: "No groups yet. Use the buttons above to suggest groups or pick terms by hand.",
    groupN: "Group {n}",
    editGroup: "Edit",
    doneEditing: "Done",
    removeFromGroup: "Remove from group",
    editingHint: "Remove terms with ⊖. To add, pick them above in «Pick by hand»: this group is already set as the destination.",
    discardGroup: "Discard group",
    keeps: "Keep",
    include: "Include",
    term: "Term",
    uses: "Uses",
    keepsBadge: "kept",
    mergedBadge: "merged",
    finalName: "Final name of the kept term (optional)",
    groupNeedsTwo: "This group has no term to merge: it will not be applied.",
    origin: {
      same: "Suggested: same name",
      similar: "Suggested: similar name",
      manual: "Picked by hand",
    },
    suggestionsAdded: "{count} suggested groups added.",
    noSuggestions: "No new groups to suggest.",
    buildFooter: "{groups} groups ready, {terms} terms to merge",
    review: "Review before merging",
    confirmHeadline: "You are about to merge <strong>{groups}</strong> groups: <strong>{terms}</strong> terms will be removed and <strong>{records}</strong> records updated. Review the details.",
    renamedFrom: "renamed, was «{label}»",
    legacyCopy: "old copy in the database, not shown in the app",
    nRecords: "1 record | {count} records",
    noRecords: "No record uses these terms.",
    includesTrash: "{count} records in the trash will also be updated.",
    childrenMoved: "Moved under the kept term: {children}",
    none: "none",
    warnAccountingCode: "Different accounting code. The kept term's one stays ({target}); lost: {list}.",
    warnConversionRate: "Different conversion rate. The kept term's one stays ({target}); lost: {list}.",
    warnColor: "Different color. The kept term's one stays ({target}); lost: {list}.",
    warnParent: "The terms have different parents. The kept one stays under «{target}»; the others were under: {list}.",
    warnDefinitionDefault: "It is the default value or filter of: {fields}. It gets updated, but anyone with the app open keeps the old definition until the next deploy: better do it after hours or keep that term.",
    noteUndo: "It can be undone with the «Undo merge» button as long as it is the last merge of this list.",
    noteOpenForms: "A form someone has open right now with a removed term may save it again: warn people first.",
    acknowledge: "I understand that {terms} terms will be removed and {records} records modified.",
    back: "Back",
    confirm: "Merge",
    doneTitle: "Merge completed",
    doneBody: "{terms} terms removed and {fields} fields updated.",
    doneSkipped: "{count} fields were not touched because someone changed them meanwhile.",
    doneUndoHint: "If something went wrong, use «Undo merge» on the list page.",
    close: "Close",
    undoButton: "Undo merge",
    undoTitle: "Undo the last merge of this list",
    undoConfirmTitle: "Undo the last merge?",
    undoConfirmWho: "Done on {when} by {who}:",
    undoConfirmNote: "Merged terms come back to the list and every record goes back to its previous term, except those changed afterwards.",
    undoConfirmButton: "Yes, undo",
    undoDoneTitle: "Merge undone",
    undoDone: "{restored} fields restored.",
    undoDoneWithConflicts: "{restored} fields restored. {conflicts} were not touched because they changed after the merge.",
  },
  quickSearch: {
    placeholder: "Search everything…",
    hint: "Type at least 2 characters.",
    searching: "Searching…",
    noResults: "No results.",
    error: "Search failed. Please try again.",
    current: "Current",
  },
  myProfile: "My Profile",
  billing: "Billing",
  "Technical support": "Technical support",
  success: "Success",
  error: "Error",
  ok: "OK",
  accountStatementFilesCount: "{count} file | {count} files",
  accountStatementExpandAll: "Expand all",
  accountStatementCollapseAll: "Collapse all",
  Between: "Between",
  "On or after": "On or after",
  "On or before": "On or before",
  "Clear dates": "Clear dates",
  validationSaveFailedTitle: "Validation error",
  validationSaveFailedIntro:
    "The record could not be saved because of the following:",
  validationSaveAnyway: "Save anyway",
  validationUnderstood: "OK",
  validationPendingAmountToApply: "You still have an amount pending to apply",
  expenseFileMissingTitle: "No Related File attached",
  expenseFileMissingText:
    "You are saving without attaching the Related File. Do you want to proceed anyway?",
  expenseFileMissingCancel: "Cancel",
  contactOutsideOperationTitle: "Contact outside the operation",
  shippingIncoherenceTitle: "Inconsistencies in this shipment",
  contactOutsideOperationText:
    "{contact} does not take part in {operations}: it is not the client, the supplier or the contact of any expense. Fine if a third party pays or collects; otherwise, check the contact.",
  contactOutsideOperationCancel: "Review",
  contactOutsideOperationBanner:
    "This record is applied to {operations}, but {contact} does not take part in that operation (not the client, the supplier or the contact of any expense). Check that the contact is correct.",
  collectContactNotClientTitle: "The collection is not from the client",
  collectContactNotClientText:
    "{contact} is not the client of {operations}. Fine if a third party pays on behalf of the client; otherwise, check the contact.",
  collectOverPendingTitle: "The collect is above the pending amount",
  collectOverPendingLine:
    "{applied} is applied to {shipping}, which has {pending} pending: the excess is {excess}.",
  collectOverPendingFooter:
    "If you save anyway, it is applied up to the pending amount and the excess stays unapplied, as a credit for the contact.",
  collectOverPendingAlsoNoFile: "Also, the collect has no file.",
  collectContactNotClientBanner:
    "This collection is applied to {operations}, but {contact} is not the client of that operation. Check that the contact is correct.",
  validationForceSaveSessionTitle: "Session expired",
  validationForceSaveSessionText:
    "Could not save anyway because your session expired. Refresh the page or sign in again, then retry.",
  validationForceSaveGenericText:
    "Could not complete the forced save. Check your connection and try again.",
  "Error accessing file.": "Could not open the file.",
  "Error accessing receipt file": "Could not open the receipt",
  fileNotFoundInStorage:
    "The file was not found in storage. It may have been deleted or never uploaded.",
  routerNavLoading: "Loading…",
  testEnvironmentBanner: "Test version — local environment",
  testEnvironmentBannerHosted:
    "Test version — you are viewing a test copy (not production)",
  "systemFeaturesPermissionDeniedTitle": "Permission required",
  "systemFeaturesPermissionDeniedText":
    "You do not have permission to enable or disable system features. Ask an administrator to grant «Access system features» (systemfeatures.access) on your role.",
  "emailModulePermissionDeniedTitle": "Permission required",
  "emailModulePermissionDeniedText":
    "You do not have permission to enable or disable the email module. Ask an administrator to grant «Automatic emails» (email.module.manage) on your role.",
  registerSuccessLogin: "Account created. You can sign in now.",
  registerConfirmEmailSent:
    "We have sent a link to your email ({email}) to confirm your account. If you have not received it, check your spam folder. Click the link to confirm your account.",
  forgotPassword: "Forgot your password?",
  passwordResetEmail: "Enter your email and we'll send you a link to set a new password.",
  passwordResetContinue: "Continue",
  emailSent: "Reset password",
  correctEmail: "We'll send the password reset link to {email}. Is that correct?",
  sendEmail: "Send email",
  pleaseinsertemail: "Enter the email you used to sign up to be redirected to your app.",
  goToMyApp: "Go to my app",
  seeDemo: "See demo",
  incorrectUserOrPassword: "Incorrect user or password",
  loginLocked: "Too many attempts with a wrong password. The account is locked; try again in {minutes} minutes.",
  accountconfirm: "Your account has been confirmed, you can log in now.",
  getStarted: "Get started",
  "Search fields...": "Search fields...",
  'No fields found for "{query}"': 'No fields found for "{query}"',
  "Type to search records...": "Type to search records...",
  "Type to search a record...": "Type to search a record...",
  "Manual stock calculation": "Manual stock calculation",

  // Register.vue (root keys for $t)
  name: "Name",
  email: "Email",
  password: "Password",
  businessName: "Business name",
  login: "Log in",
  confirmEmailText: "Check your email to confirm your account",
  nameAlreadyTaken: "This name is already in use",
  errorCheckingRestaurantName: "Could not verify name availability",
  nameRequired: "Name is required",
  countryRequired: "Country is required",
  restaurantNameRequired: "Business name is required",
  emailRequired: "Email is required",
  emailInvalid: "Please enter a valid email address",
  passwordRequired: "Password is required",
  userExists: "An account with this email already exists",
  registerCompanyLinkPlaceholder: "Your business link (optional)",
  registerHelpBusinessUrl:
    "We use your business name in the URL your customers will use to access the app.",
  registerHelpDedicatedDbConfirm:
    "After you confirm your email, a dedicated database is created for your business (same user on this instance and the new one).",
  registerHelpDedicatedDbImmediate:
    "A dedicated database for your business is created right away (same user on this instance and the new one).",
  registerHelpCompanyLink:
    "Add your Instagram, Facebook, or website link so we can include you in marketing campaigns.",
  registerHelpEmailConfirmBusiness:
    "We will send an email with a link to confirm your account; your business database is created when you confirm.",
  registerHelpEmailConfirmAny:
    "We will send an email with a link to confirm your account; you cannot sign in until you confirm.",
  registerConfirmSpamP1:
    "If you cannot find the email, check your spam folder. If you did not receive the message with the code, contact us so we can activate your account manually. Email us at contact@gotake.it or reach technical support on WhatsApp, tap here:",
  registerConfirmWhatsapp: "WhatsApp",

  nothingtosee: "Nothing to see here",

  // Billing / overdue (root keys — same strings exist under emails.* but $t('…') only sees root)
  "Billing overdue days":
    "Overdue: {days} day(s) past your monthly due date (day {dueDay} of each month, from service start; no paid month record).",
  "Billing overdue due from first":
    "No paid month record yet. This month's payment is due on day {dueDay} (same calendar day each month as your service start).",
  "Billing tab intro":
    "Charges by calendar month. Download PDF invoices for closed months (available from the 1st of the next month; trial features stay free until the trial ends). The current month is last, with a provisional total; print/PDF is enabled after the month closes.",
  "Billing pending from period title":
    "Current month usage (invoiced next month)",
  "Billing pending from period hint":
    'Indicative running total for this month for items outside the prepaid monthly fee (for example smart email, container tracking, or development work). It is not part of the settlement total in the table below; it is billed when the month closes and may appear as "Deferred" on the next statement. Each row shows the full charge, how much of this month\'s recorded payment was applied to these deferred items (after settlement lines), and what remains for the next period.',
  "Billing pending from period col gross": "Full charge",
  "Billing pending from period col paid": "Paid this month (deferred)",
  "Billing pending from period col remaining": "Remaining (next period)",
  "Billing pending from period footer totals": "Totals",
  "Billing pending from period footer explain":
    "Full charge is the list amount for each deferred item this month. Paid this month is the portion of your recorded payment applied here after settlement lines. Remaining is what still carries to the next statement if unpaid.",
  "Billing pending from period subtotal": "Estimated subtotal (this box)",
  "Billing outstanding from prior": "Outstanding balance from",
  "Billing carry brought forward total":
    "Total brought forward from prior period(s) (before this month's payments)",
  "Billing carry payments applied this month":
    "Payments recorded for this month applied to that balance",
  "Billing carry remaining in settlement":
    "Remaining from that balance in this statement",
  "Billing settlement concepts hint":
    "Unpaid from a month: what was still owed on the prior settlement, broken down line by line. Deferred: specific usage from a prepaid month billed on the next statement (e.g. each development task).",
  "Billing unpaid from period title": "Unpaid from {period}",
  "Billing unpaid from period breakdown":
    "Breakdown of what was still unpaid on that month's settlement:",
  "Billing advance group paid at": "Payment on {date}",
  "Billing outstanding balance line hint":
    "Unpaid remainder from that month's settlement after recorded payments. Not new usage in the current month.",
  "Billing pending included in balance hint":
    'This balance includes usage outside the prepaid fee (see "Current month usage" below). If it stays unpaid, it will usually be invoiced when the month closes.',
  "Billing future prepaid header note":
    "Prepaid for a future month — settlement and any balance due will show when that month is current.",
  "Billing advance no prior deferred":
    "No deferred amounts from earlier months on this card.",
  "Billing overdue top alert message":
    "Our records show the service payment is {days} day(s) late (due on day {dueDay} of each month). Please settle the payment to reactivate your subscription and avoid service suspension in {daysLeft} day(s).",
  "Billing overdue top alert message suspension":
    "Overdue {days} day(s): 10-day grace ended — service may be suspended. Pay in Billing now.",
  "Billing overdue top alert link": "View billing",
  "Billing suspension nag title":
    "Reminder: your service payment is more than 10 days overdue.",
  "Billing suspension swal ok": "OK",
  "Billing overdue reminder title": "Overdue payment email reminders",
  "Billing overdue reminder enable": "Send daily reminder email at 14:00 when there is unpaid overdue debt",
  "Billing overdue reminder users placeholder": "Select users who will receive the reminder",
  "Billing overdue reminder placeholders hint":
    "Placeholders: {{overdueDays}}, {{dueDay}}, {{daysLeft}}, {{year}}, {{month}}. Below the text, the invoice HTML is included (same settlement as in Billing).",
  "Billing overdue reminder last sent": "Last reminder sent",
  "Billing overdue reminder send now": "Send now",
  "Billing overdue reminder preview": "Preview",
  "Billing overdue reminder preview error": "Could not build the preview",
  "Billing overdue reminder preview would not send":
    "With the current state a real send would be skipped (no unpaid overdue or no recipients).",
  "Billing overdue reminder send now confirm title": "Send reminder now?",
  "Billing overdue reminder send now confirm text":
    "Current settings will be saved and the email will be sent to the selected users (includes the pending balance summary in the body).",
  "Billing overdue reminder send now success": "Reminder sent",
  "Billing overdue reminder send now success with invoice":
    "Reminder sent with the pending balance summary",
  "Billing overdue reminder send now error": "Could not send the reminder",
  "Billing overdue reminder send now skipped": "Reminder was not sent",
  "Billing overdue reminder send now no overdue":
    "There is no unpaid overdue debt; the email was not sent",
  "Billing overdue reminder send now no recipients":
    "Select at least one recipient user with an email",

  uiZoom: {
    title: "Screen zoom",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    reset: "Reset to 100%",
  },

  userMenu: {
    title: "My menu",
    intro:
      "Drag entries to reorder them or drop them into containers. You can remove any link (models, active modules, reports) from the menu; removed items do not come back on their own — the section below lists what is still missing from the system menu, and you can bring each link back with “Restore” when you need it. You can add your own links (https URL, an internal path starting with /, mailto, or tel). You can also add containers (folders). Containers belong to your menu only; they are not shared with other users unless an administrator uses “Apply to all users”.",
    newContainer: "New container",
    containerName: "Name",
    containerPlaceholder: "e.g. Operations",
    addContainer: "Add container",
    yourMenu: "Menu structure",
    dragHint:
      "Use the handle to drag. You can move items between the root and any container.",
    save: "Save menu",
    resetFromServer: "Reload",
    saved: "Menu saved",
    saveError: "Could not save the menu",
    loadError: "Could not load menu settings",
    folderCreateError: "Could not create the container",
    deleteFolder: "Delete",
    deleteFolderHint: "Empty the container before deleting",
    folderNotEmpty: "Remove all items from this container before deleting it.",
    confirmDeleteFolder: "Delete this container? It must be empty.",
    deleteError: "Could not delete the container",
    fixedTopNote:
      "Dashboard and Settings always stay at the top of the sidebar and are not listed here.",
    reportsHint:
      "Saved reports appear as separate entries: you can reorder them, put them in containers, or drag them under their model (indented) so they open as a submenu.",
    modelSubmenuHint:
      "Drag links here to group them under this model in the sidebar (reports, other models, modules, etc.). If you don’t see the drop area, expand the row with the chevron.",
    reportsTag: "Reports",

    editMenuLabel: "Edit sidebar title",
    editFolderName: "Rename container",
    folderNamePlaceholder: "Container name",
    folderRenameError: "Could not rename the container",
    menuLabelPlaceholder: "Empty = default name from the system",
    menuLabelHint:
      "For each model or module link you can set a custom title in the sidebar without changing the model definition. Report names always come from the report itself. Drag module links (Stock, MEV, etc.) together with models to change their order.",
    removeFromMenu: "Remove from menu",
    removeFromMenuHint:
      "Hide this entry in your sidebar. You can add it again with “Restore” next to that item in the section below.",
    notInMenuTitle: "Not in your menu",
    notInMenuHint:
      "System links (active modules, models you can access, reports) that are not in your layout yet. Each “Restore” adds only that link at the end without changing the order of existing items.",
    notInMenuEmpty: "Nothing missing — everything is already in your layout.",
    notInMenuSearch: "Search what is missing…",
    notInMenuNoResults: "Nothing matches the search.",
    groupModules: "Modules",
    groupModels: "Models",
    groupReports: "Reports",
    groupReportsOf: "{model} reports",
    groupSettings: "Settings",
    groupOther: "Other",
    unknownReport: "Deleted or inaccessible report",
    dropHere: "Drop here to group",
    restoreMissing: "Restore",
    restoreMissingOne: "Restore {name}",
    hideAddNew:
      "Hide “Add new” for this model in the sidebar (list access is unchanged).",
    hideAddNewShort: "No “Add new”",
    modelSubmenuHintShort: "Drop links here to group them under this model.",
    applyToAllUsers: "Apply this menu to all users",
    applyToAllConfirmTitle: "Overwrite every user’s menu?",
    applyToAllConfirmHtml:
      '<p>This will replace the saved menu layout for <strong>all active users</strong> in this instance with the structure you see in the editor (after server validation).</p><ul class="text-start small"><li>Each user will still only <strong>see</strong> items they are allowed to access (models, modules, reports).</li><li>Each user gets their <strong>own copy</strong> of your containers (same names and structure).</li><li>Previous copies from a past “apply to all” are replaced on each run.</li></ul>',
    applyToAllConfirmYes: "Yes, apply to everyone",
    applyToAllConfirmCancel: "Cancel",
    applyToAllSuccess: "Menu applied to {count} users.",
    applyToAllCustomizedHint:
      "<strong>{count} user(s) built their own menu</strong> and would lose it. Uncheck anyone who should keep theirs.",
    applyToAllForbidden:
      "You need the “My menu — apply to all users” role permission, or be a system administrator.",
    applyToAllError: "Could not apply the menu to all users.",
    editUserMenuTitle: "Another user's menu",
    editUserMenuHint:
      "As an administrator you can choose whose menu you are arranging. What you save is written to that user's menu, not yours.",
    editUserMenuField: "User",
    editUserMenuOwn: "My own menu",
    editUserMenuActive:
      "You are editing {name}'s menu: saving, creating containers and “Restore” all affect that user.",
    savedForUser: "{name}'s menu saved",
    restoreForAll: "Restore for all users",
    restoreForAllHint:
      "Adds just this link at the end of every user's menu, leaving the rest of their structure untouched.",
    restoreForAllOne: "Restore {name} for all users",
    restoreForAllConfirmTitle: "Add “{name}” to everyone's menu?",
    restoreForAllConfirmHtml:
      '<p><strong>Only that link</strong> is appended to the end of each active user\'s saved menu. Their order and the rest of their entries stay as they are.</p><ul class="text-start small"><li>Users who already have it are not given a duplicate.</li><li>Users who never customised their menu see the full system menu, so nothing needs to change for them.</li><li>Each user only sees it if their permissions allow it.</li></ul>',
    restoreForAllConfirmYes: "Yes, add it for everyone",
    restoreForAllSuccess: "“{name}” added to {count} users' menus.",
    restoreForAllSuccessHint:
      "The rest already had it or use the system menu without customising it.",
    restoreForAllError: "Could not add the link to everyone's menu.",
    applyLabelToAll: "Name for everyone",
    applyLabelToAllHint:
      "Applies just this name to that entry in every user's menu, leaving the rest of their structure untouched.",
    applyLabelToAllConfirmTitle:
      "Rename that entry to “{name}” for everyone?",
    applyLabelToAllResetConfirmTitle:
      "Reset “{name}” to its default name for everyone?",
    applyLabelToAllConfirmHtml:
      '<p><strong>Only the name of that entry</strong> changes in each active user\'s saved menu. Their order and the rest of their entries stay as they are.</p><ul class="text-start small"><li>It applies right away — no need to save the menu.</li><li>Users without that entry in their menu are not affected.</li><li>Users who never customised their menu see the system one, so they keep the default name.</li></ul>',
    applyLabelToAllConfirmYes: "Yes, rename for everyone",
    applyLabelToAllSuccess: "Name applied in {count} users' menus.",
    applyLabelToAllSuccessHint:
      "The rest already showed it that way, do not have that entry, or use the system menu without customising it.",
    applyLabelToAllEmpty: "Type the new name first.",
    applyLabelToAllError: "Could not rename the entry in everyone's menu.",
    customLinkSectionTitle: "Custom link",
    addCustomLink: "Add link",
    customLinkBadge: "Custom",
    editCustomLink: "Edit link",
    removeCustomLinkHint: "Remove this link from the menu",
    customLinkLabelField: "Menu label",
    customLinkLabelPlaceholder: "e.g. Documentation",
    customLinkUrlField: "URL or path",
    customLinkUrlPlaceholder:
      "https://… , /internal/path , mailto:… or tel:…",
    customLinkIconField: "Icon (optional)",
    customLinkInvalidUrl:
      "Invalid URL. Use https://, a path starting with /, mailto:, or tel:",
  },

  migrations: {
    menu: "Migrations",
    title: "System migrations",
    description:
      "Structure or data changes shipped with a new version that must be applied to this database. They run once: when one finishes, it stops showing up here.",
    refresh: "Refresh",
    run: "Run",
    runAll: "Run all {count}",
    confirm: "This changes data for this company. Run it now?",
    confirmAll: "They run one after another, in order. If one fails, the rest are not run.",
    nonePending: "No pending migrations for this database.",
    loading: "Loading…",
    failed: "The migration failed.",
    stillRunning: "The migration is still running. Come back in a few minutes to see how it ended.",
    lastRunTitle: "Just executed",
    noChanges: "Finished with no changes to apply.",
    historyTitle: "History",
    show: "Show",
    hide: "Hide",
    noHistory: "No migration has been run on this database yet.",
    colMigration: "Migration",
    colVersion: "Version",
    colStatus: "Status",
    colDate: "Date",
    colBy: "Run by",
  },
  refIntegrityAdmin: {
    menu: "Reference integrity (appliedto)",
    title: "OID string cleanup (ModelDefinitions)",
    subtitle:
      "Builds targets from all ModelDefinitions: each root collection (reference, list, audit IDs), every group subcollection, and array fields that hold references. Converts invalid 24-char hex strings to ObjectIds.",
    fieldsChecked: "OID fields scanned on collection",
    fallback: "Fallback list",
    modelDefs: "definitions",
    targets: "targets",
    kindCollection: "Collection",
    kindArray: "Embedded array",
    embeddedPath: "Array path",
    sampleDocIds: "Sample document ids",
    showAllTargets: "Show all targets (including clean)",
    filteredEmpty:
      "No targets with issues or missing collections in this view. Enable “Show all targets” to list every scanned collection.",
    docsUpdated: "Documents updated",
    scan: "Scan",
    fix: "Fix",
    cancel: "Cancel",
    ok: "OK",
    totalDocsWithIssue: "Documents with at least one string reference",
    missingCollection: "missing",
    docsAffected: "Affected documents",
    noIssues: "No string references found.",
    field: "Field",
    count: "Count",
    samples: "Samples (_id → value)",
    error: "Could not complete the operation.",
    fixConfirmTitle: "Convert string references to ObjectIds?",
    fixConfirmText:
      "This updates the current tenant database only. Run on a backup if unsure.",
    fixDone: "Update completed",
    fixSummaryEmpty: "No changes reported.",
    skipped: "skipped (collection missing)",
    modified: "Documents updated",
    collection: "Collection",
  },

  "Support ticket attachments hint":
    "You can upload multiple files: images, videos, PDF, or Excel (.xls, .xlsx). Maximum 20 MB per file.",
  "Support ticket attachments hint short":
    "Images, videos, PDF, or Excel — max 20 MB per file.",
  "Support attachment type not allowed":
    "File {name} is not an allowed type (images, videos, PDF, or Excel).",
  "Document upload type not allowed":
    "File type not allowed. Use PDF, Word (DOC, DOCX), or Excel (XLS, XLSX).",
  "Only images PDF or Excel are allowed":
    "Only images, videos, PDF, or Excel files are allowed.",
  "Request entity too large": "Request entity too large",
  "File {name} is too large. Maximum size is {mb}MB":
    "File {name} is too large. Maximum size is {mb} MB.",
  "Search tickets by keywords":
    "Search tickets (title, description, notes, replies…)",
  "Pending questions": "Pending questions",
  "Developer weekly activity": "Developer weekly activity",
  "Meetings": "Meetings",
  "Notices and support language": "Notices and support language",
  "App language": "App language",
  "Same as notices and support": "Same as notices and support",
  "Menu, buttons, fields and columns: everything except notices and support.": "Menu, buttons, fields and columns: everything except notices and support.",
  "Notification email": "Notification email",
  "Job title": "Job title",
  "Shown under the name in the document signature.": "Shown under the name in the document signature.",
  "Notices by email arrive here. Empty = your login email.": "Notices by email arrive here. Empty = your login email.",
  "Alerts, notifications, validations and technical support.": "Alerts, notifications, validations and technical support.",
  "Tutorials": "Tutorials",
  "Tutorial": "Tutorial",
  "Request a new tutorial": "Request a new tutorial",
  "Requested tutorials": "Requested tutorials",
  "There are no tutorials yet.": "There are no tutorials yet.",
  "Export to PDF": "Export to PDF",
  "Other": "Other",
  "Book a meeting": "Book a meeting",
  "Your plan includes {count} one-hour meetings per month. Unused meetings do not carry over.": "Your plan includes {count} one-hour meetings per month. Unused meetings do not carry over.",
  "{left} of {limit} left": "{left} of {limit} left",
  "The meetings calendar is temporarily unavailable. Please try again later.": "The meetings calendar is temporarily unavailable. Please try again later.",
  "Meeting booking is not available yet.": "Meeting booking is not available yet.",
  "Connect Google Calendar in the agenda settings below.": "Connect Google Calendar in the agenda settings below.",
  "Times shown in your local time ({tz})": "Times shown in your local time ({tz})",
  "There are no free times in the next {days} days.": "There are no free times in the next {days} days.",
  "No meetings left that month": "No meetings left that month",
  "What do you want to talk about? (optional)": "What do you want to talk about? (optional)",
  "Invite users": "Invite users",
  "You are invited automatically. Google Calendar sends the invitation with the Meet link.": "You are invited automatically. Google Calendar sends the invitation with the Meet link.",
  "Search users": "Search users",
  "No users found": "No users found",
  "Another email": "Another email",
  "Add": "Add",
  "Confirm meeting": "Confirm meeting",
  "Your meetings": "Your meetings",
  "You have not booked any meetings yet.": "You have not booked any meetings yet.",
  "Booked by {name}": "Booked by {name}",
  "Join": "Join",
  "Upcoming meetings, all clients": "Upcoming meetings, all clients",
  "No upcoming meetings.": "No upcoming meetings.",
  "Agenda settings": "Agenda settings",
  "Google Calendar": "Google Calendar",
  "Google Calendar is not configured on the server (GOOGLE_CALENDAR_CLIENT_ID / SECRET / REDIRECT_URI).": "Google Calendar is not configured on the server (GOOGLE_CALENDAR_CLIENT_ID / SECRET / REDIRECT_URI).",
  "Reconnect required": "Reconnect required",
  "Connected": "Connected",
  "Reconnect": "Reconnect",
  "Disconnect": "Disconnect",
  "Connect Google Calendar": "Connect Google Calendar",
  "Free times are your default hours minus whatever is busy in that calendar, including meetings booked from other clients.": "Free times are your default hours minus whatever is busy in that calendar, including meetings booked from other clients.",
  "Default availability": "Default availability",
  "Time zone of these hours": "Time zone of these hours",
  "Meetings last one hour. Each client sees these times converted to their own time zone.": "Meetings last one hour. Each client sees these times converted to their own time zone.",
  "Your browser is in {tz}.": "Your browser is in {tz}.",
  "Add hours": "Add hours",
  "Save availability": "Save availability",
  "Google Calendar connected": "Google Calendar connected",
  "Could not connect Google Calendar": "Could not connect Google Calendar",
  "Allow access to the calendar on the Google screen and try again.": "Allow access to the calendar on the Google screen and try again.",
  "Done": "Done",
  "Scheduled": "Scheduled",
  "Cancelled (counted)": "Cancelled (counted)",
  "Cancelled": "Cancelled",
  "Invalid email": "Invalid email",
  "Meeting booked. The invitation was sent by email.": "Meeting booked. The invitation was sent by email.",
  "Could not book the meeting": "Could not book the meeting",
  "Cancel the meeting?": "Cancel the meeting?",
  "Less than {hours} hours remain: the meeting will still count for this month.": "Less than {hours} hours remain: the meeting will still count for this month.",
  "Guests will be notified by email.": "Guests will be notified by email.",
  "Cancel meeting": "Cancel meeting",
  "Back": "Back",
  "Form columns": "Form columns",
  "Columns": "Columns",
  "col.": "col.",
  "Automatic": "Automatic",
  "Share with other users": "Share with other users",
  "Layouts from other users": "Layouts from other users",
  "No shared layouts yet": "No shared layouts yet",
  "Adjust column widths": "Adjust column widths",
  "Column width": "Column width",
  "Fill the whole width": "Fill the whole width",
  "Show earlier days": "Show earlier days",
  "Show all": "Show all",
  "Meeting cancelled": "Meeting cancelled",
  "Availability saved": "Availability saved",
  "Disconnect Google Calendar?": "Disconnect Google Calendar?",
  "Clients will not be able to book meetings until a calendar is connected again.": "Clients will not be able to book meetings until a calendar is connected again.",
  "Error": "Error",
  "Loading...": "Loading...",
  "Week navigation": "Week navigation",
  "This week": "This week",
  "Next week": "Next week",
  Later: "Later",
  "No support programmers configured": "No support programmers configured",
  "Configure board programmers to track weekly activity":
    "Configure board programmers in ticket settings to track weekly activity.",
  "No activity this week": "No activity this week",
  "Status changes": "Status changes",
  Tickets: "Tickets",
  "Error loading developer weekly activity": "Error loading developer weekly activity",
  "No pending questions": "No pending questions",
  "Pending questions scope": "Pending questions scope",
  "From others": "From others",
  "No pending questions help others":
    "No unanswered questions from other users on Waiting for answer tickets (open topics).",
  "No pending questions help all":
    "No unanswered questions on Waiting for answer tickets (open topics).",
  "View ticket": "View ticket",
  "Unread mentions": "Unread mentions",
  "Private report": "Private report",
  "You were mentioned in ticket {label}. Don't forget to reply.":
    "You were mentioned in ticket {label}. Don't forget to reply.",
  "You were mentioned in {count} tickets. Don't forget to reply.":
    "You were mentioned in {count} tickets. Don't forget to reply.",
  "Initial message": "Initial message",
  "Topic comment": "Topic comment",
  "No tickets match your search": "No tickets match your search.",
  "Assigned to": "Assigned to",
  "Unassigned": "Unassigned",
  paymentCollectResponsable: {
    assignedSuccess: "You have taken responsibility{name}.",
    alreadyAssigned: "You are already responsible for this record.",
    assignFailed: "Could not assign responsable.",
    claimLinkShortcode: "Claim responsibility link (responsableClaimLink)",
  },
  "All assignees": "All assignees",
  "Board programmers": "Board programmers",
  "Board programmers help":
    "Select users who appear as columns on the support board. Set an hourly rate ($/h) to auto-calculate development prices from estimated hours. Empty columns show a dashed area for drag-and-drop assignment.",
  "Hourly rate": "Hourly rate",
  "Development price auto hint": "Calculated: {hours}h × ${rate}/h = ${price}",
  "Development price locked hint": "Price locked at ${rate}/h when saved",
  "Development price needs hours": "Enter estimated hours to calculate the price.",
  "Development price needs assignee": "Assign the ticket to a board programmer to calculate the price.",
  "Development price needs programmer rate":
    "The assignee has no $/h rate. Configure it in Board programmers (Pending / In Progress / Resolved tab).",
  "Resolved tickets assignee locked":
    "Resolved tickets cannot be reassigned. Reopen the ticket first if you need to change the assignee.",
  "Tickets in progress or resolved cannot be deleted":
    "Tickets in progress or resolved cannot be deleted.",
  Timeline: "Timeline",
  Category: "Category",
  Flags: "Flags",
  "No category": "No category",
  "Details": "Details",
  migrationsPendingIntro:
    "{count} pending updates. All of them run, in this order.",
  "Set category on selected": "Set category on selected",
  "Apply category": "Apply category",
  "Flags are created and edited in the flags list": "Flags are created and edited in the flags list",
  "Add ticket": "Add ticket",
  "Category name already exists": "A category with that name already exists",
  "Saved successfully": "Saved successfully",
  "Filter by categories": "Filter by categories",
  "Dashboard": "Dashboard",
  "dashboardRefresh": "Refresh",
  "dashboardRetry": "Retry",
  "dashboardTicketLoadError": "Could not load the ticket",
  "dashboardLoadError": "Could not load the dashboard",
  "dashboardYourTurn": "Your turn",
  "dashboardWaitingOnOthers": "You are waiting on others",
  "dashboardNothingPending": "Nothing pending",
  "dashboardNothingPendingHelp": "When someone is waiting for you on a ticket, or you are waiting for someone, you will see it here.",
  "dashboardWaitingForYou": "{name} is waiting for your answer on ticket {ticket}",
  "dashboardWaitingForYouNoName": "Support is waiting for your answer on ticket {ticket}",
  "dashboardTestForYou": "{name} left ticket {ticket} ready for you to test",
  "dashboardTestForYouNoName": "Ticket {ticket} is ready for you to test",
  "dashboardUnanswered": "{name} wrote on ticket {ticket} and nobody has answered yet",
  "dashboardUnansweredNoName": "Someone wrote on ticket {ticket} and nobody has answered yet",
  "dashboardNewTicket": "{name} created ticket {ticket} and nobody has answered yet",
  "dashboardNewTicketNoName": "Ticket {ticket} was created and nobody has answered yet",
  "dashboardMention": "You were mentioned on ticket {ticket} and have not replied yet",
  "dashboardYouAreWaiting": "You are waiting for an answer from {name} on ticket {ticket}",
  "dashboardYouAreWaitingNoName": "You are waiting for an answer on ticket {ticket}",
  "dashboardClientTesting": "You are waiting for {name} to test ticket {ticket}",
  "dashboardClientTestingNoName": "You are waiting for ticket {ticket} to be tested",
  "dashboardWaitingForSupport": "You are waiting for support to answer you on ticket {ticket}",
  "dashboardOldest": "oldest {since}",
  "dashboardOpenTickets": "Board: {count} open tickets",
  "dashboardYourTurnEmpty": "Nothing on your plate right now.",
  "dashboardWaitingOnOthersEmpty": "You are not waiting on anyone.",
  "dashboardKpiWaitingForYou": "To answer",
  "dashboardKpiTestForYou": "To test",
  "dashboardKpiUnanswered": "Unanswered",
  "dashboardKpiNewTicket": "New, no answer",
  "dashboardKpiMention": "Unanswered mentions",
  "dashboardKpiYouAreWaiting": "Waiting for answer",
  "dashboardKpiClientTesting": "Waiting for test",
  "dashboardKpiWaitingForSupport": "Waiting for support",
  "dashboardReadyTitle": "Ready tickets",
  "dashboardReadyHelp": "Tickets that are done but, just in case, stay open for comments before being closed for good.",
  "dashboardReadyEmpty": "No ready tickets.",
  "dashboardReadyBy": "Marked ready by {name}",
  "dashboardReadyForTestTitle": "To test",
  "dashboardReadyForTestHelp": "Tickets waiting for your test. On the right, how long they have been waiting.",
  "dashboardReadyForTestEmpty": "No tickets waiting for a test.",
  "dashboardReadyForTestBy": "Left for testing by {name}",
  "Ticket categories": "Ticket categories",
  "Ticket categories help":
    "Define category names for the timeline and board (e.g. Finance module). Anyone can create categories and assign them to tickets.",
  "Category name": "Category name",
  "Report comment": "Report comment",
  "No categories configured": "No categories configured yet.",
  "No timeline categories yet": "No timeline data yet",
  "Timeline empty help":
    "Assign a category to tickets, or configure categories with the button above.",
  "Bug resolved": "Bug resolved",
  "Development resolved": "Development resolved",
  "Filter by assignee": "Filter by assignee",
  "Drag to reorder": "Drag to reorder",
  "Select all on page": "Select all on page",
  "Select ticket": "Select ticket",
  "{count} tickets selected": "{count} tickets selected",
  "Move selected to Development": "Move selected to Development",
  "Move selected to Bug": "Move selected to Bug",
  unread: "unread",
  "Next": "Next",
  "Skip": "Skip",
  "optional": "optional",
  "ticketWizardStepOf": "Question {current} of {total}",
  "ticketWizardTypeQuestion": "What kind of ticket is it?",
  "ticketWizardTypeBugHint": "Something that used to work and stopped, or shows an error",
  "ticketWizardTypeDevelopmentHint": "Something new the system doesn't do yet",
  "ticketWizardTypeTutorialHint": "A guide explaining how to do a task",
  "ticketWizardProblemQuestion": "What is the problem?",
  "ticketWizardProblemPlaceholder": "Tell us what you were doing and what happened.",
  "ticketWizardExpectedQuestion": "How should it work?",
  "ticketWizardExpectedPlaceholder": "Tell us what should happen or what result you expected to see.",
  "ticketWizardNeedQuestion": "What do you need the system to do?",
  "ticketWizardNeedPlaceholder": "Describe the new feature or the change you want.",
  "ticketWizardResultQuestion": "What result do you expect to see?",
  "ticketWizardResultHint": "You can choose more than one option.",
  "ticketWizardResultList": "A list",
  "ticketWizardResultScreen": "A new screen",
  "ticketWizardResultButton": "A new button",
  "ticketWizardResultField": "A new field in a form",
  "ticketWizardResultCalculation": "An automatic calculation",
  "ticketWizardResultReport": "A report or chart",
  "ticketWizardResultFile": "A file (Excel, PDF)",
  "ticketWizardResultNotification": "A notification or email",
  "ticketWizardResultRemoveSaved": "Remove this saved option",
  "ticketWizardResultRemoveError": "The option could not be removed",
  "ticketWizardResultOther": "Other",
  "ticketWizardResultOtherPlaceholder": "Tell us what result you expect",
  "ticketWizardResultRequired": "Choose at least one option",
  "ticketWizardResultOtherRequired": "Tell us what other result you expect",
  "ticketWizardTaskQuestion": "Which task do you want us to explain?",
  "ticketWizardTaskPlaceholder": "For example: how to record a partial collection for a shipment.",
  "ticketWizardLinkQuestionBug": "Link to the screen where the problem happens",
  "ticketWizardLinkQuestion": "Link to the related screen",
  "ticketWizardLinkHint": "Open the screen, copy the address from the browser bar and paste it here.",
  "ticketWizardScreenshotsQuestionBug": "Attach screenshots that help us understand the problem",
  "ticketWizardScreenshotsQuestionDevelopment": "Attach screenshots, spreadsheets or examples that help us understand what you need",
  "ticketWizardScreenshotsQuestionTutorial": "Attach screenshots of the screen you want the tutorial about",
  "ticketWizardScreenshotsUrlWarning": "Every screenshot must show the page address (URL), so we know which screen it is.",
  "ticketWizardPriorityQuestion": "How urgent is it?",
  "ticketWizardTitleQuestion": "Finally, give it a short title",
  "ticketWizardSummary": "Review your answers before sending",
  "ticketWizardAnswerRequired": "This question is required",
  "ticketWizardLinkRequired": "Paste the link to the screen where the problem happens",
  "ticketWizardScreenshotsRequired": "Attach at least one screenshot",
  "ticketWizardPriorityRequired": "Choose the urgency",
  "Brief description of the issue": "E.g.: error 500 when saving the shipment",
  "Please enter a valid URL": "Please enter a valid URL",
  "Title is required": "Title is required",
  "Title must be less than 200 characters": "Title must be less than 200 characters",
  "Bug ticket created notice":
    "Your request will be handled according to the urgency and priority you set. If we determine this is not a bug, it will be moved to development and priced accordingly.",
  "Assign selected to": "Assign selected to",
  "Assign": "Assign",
  "Clear selection": "Clear selection",
  Confirm: "Confirm",
  "Drag files here to attach": "Drag and drop files here to attach them",
  "or use the button to choose files from your device":
    "or use the button to choose files from your device",

  // Payment ↔ shipping_expense backlink issues (Settings > Orphans); root keys for $t()
  "Payment expense mismatch description":
    "Payment ↔ expense: a payment_appliedto row links a payment to a shipping_expense, but that expense does not include the payment in payments[], or the expense document no longer exists.",
  "Payment expense link issues": "Payment / shipping expense link issues",
  issues: "issues",
  "Fix expense payment backlinks": "Fix expense payment backlinks",
  "Expense missing": "Expense missing",
  "Payment not on expense": "Payment not on expense",
  "Orphans expense payment label Payment": "Payment",
  "Orphans expense payment label Expense": "Expense",
  "Current expense payments ids": "Current expense payments[]",
  "View payment": "View payment",
  "View expense": "View expense",
  "View applied row": "View applied row",
  "Confirm fix expense payment links":
    "Add each missing payment id to shipping_expenses.payments for the linked expense? This matches the back-link expected by hooks.",
  "Orphans fixed label": "Fixed",
  "expense payment links": "expense payment links",
  "Failed to sync links": "Failed to sync expense payment links.",
  Containertrackingpricingtitle: "How pricing works",
  "Container tracking pricing description":
    "You are charged $2.10 each time you activate a tracking (every successful search). If that tracking stays active for more than 24 hours, an additional 20% is charged. Your total depends on how many trackings you activate and how many of them remain active for 24+ hours.",
  "System Features developments title": "Developments",
  "System Features developments intro":
    "New developments requested by the Client will be billed when they meet at least one of the following criteria:",
  "System Features developments 1.1 title": "1.1 Specific development",
  "System Features developments 1.1 text":
    "That the Client's request does not constitute a general scope improvement applicable to all system users.",
  "System Features developments 1.2 title": "1.2 Deadline imposition",
  "System Features developments 1.2 text":
    "That the Client requires the development to be completed within a specific deadline for their own needs.",
  "System Features developments terms hint": " to understand the full terms.",
  "System Features developments current month": "Current month",
  "System Features developments current month hint":
    "Total for developments resolved this month.",
  "System Features developments link support": "View developments in Support",
  "System Features total current month": "Current month total",
  "System Features developments label": "Developments (this month)",
  "System Features container tracking current month": "Current month",
  "System Features trackings": "trackings",
  "System Features container tracking activated": "activated",
  "System Features container tracking 24h": "active ≥24h",
  "System Features container tracking current month hint":
    "$2.10 per tracking each time you activate one; an extra 20% is added for each tracking that stays active for at least 24 hours.",
  "System Features container tracking plus 24h": "for ≥24h",
  "System Features container tracking link": "View Container Tracking",
  "System Features container tracking trial": "1-week free trial.",
  "System Features container tracking billing starts": "Billing starts on",
  "System Features container tracking activate trial":
    "Activate with 1-week free trial",
  "System Features container tracking activated message":
    "Container Tracking activated. Billing starts after the 1-week trial.",
  "System Features container tracking deactivated message":
    "Container Tracking deactivated.",
  "System Features container tracking swal title":
    "Activate Container Tracking",
  "System Features container tracking swal trial":
    "For 7 days you can use Container Tracking at no cost. No charge until the billing start date.",
  "System Features container tracking swal pricing":
    "From that date you will be charged $2.10 each time you activate a tracking, plus 20% for each tracking that stays active for 24+ hours. You can see the exact calculation in this same block.",
  "System Features container tracking swal deactivate":
    "If you deactivate the feature later, you will still be charged for any usage in the current month.",
  "System Features container tracking swal confirm": "Activate",
  logout: "Logout",

  // Tutorial translations

  // TutorialButton translations
  tutorialButton: {},

  // Duntower field translations
  AccountNumber: "Account Number",
  "Additional costs": "Additional Costs",
  Address: "Address",
  Amount: "Amount",
  Applied: "Applied",
  "Applied to": "Applied to",
  "Auto load packing list": "Auto Load Packing List",
  "Autoload expenses": "Autoload Expenses",
  "Autoload invoice supplier": "Autoload Invoice Supplier",
  paymentOrderRequiresExpense:
    "To generate a payment order you must first create the invoice supplier / proforma supplier in Expenses. You can use the autoload expense button.",
  paymentOrderRequiresExpenseTitle: "Attention",
  "BL Number": "BL Number",
  Balance: "Balance",
  "Bank account": "Bank Account",
  "Bank account (from)": "Bank account (from)",
  "Bank account (to)": "Bank account (to)",
  "Bank account (from) and Bank account (to) cannot be the same":
    "Bank account (from) and Bank account (to) cannot be the same",
  "Bank name": "Bank Name",
  "Billing Address": "Billing Address",
  "Billing address": "Billing Address",
  "Booking Number": "Booking Number",
  "Buyer refererence": "Buyer Reference",
  Cartons: "Cartons",
  Category: "Category",
  City: "City",
  Client: "Client",
  Responsable: "Responsible",
  "Collect from": "Collect From",
  Collection: "Collection",
  "Collection Number": "Collection Number",
  "Collection date": "Collection Date",
  Collections: "Collections",
  "Collect situation": "Collect situation",
  cases: "cases",
  "No collect situations found": "No collect situations found",
  Collects: "Collects",
  "All Collects": "All Collects",
  "Add Collection": "Add Collection",
  Comment: "Comment",
  deleteCommentPlaceholder: "Explain why you are deleting this record",
  Comments: "Comments",
  "Send document by email": "Send document by email",
  "Send export by email": "Send export by email",
  "System Users": "System Users",
  "Document Emails": "Document Emails",
  "Manual Email": "Manual Email",
  "Loading recipients...": "Loading recipients...",
  "Enter email address": "Enter email address",
  "Selected Recipients": "Selected Recipients",
  "Add a comment to include in the email":
    "Add a comment to include in the email",
  "Email Subject": "Email Subject",
  "Email Body": "Email Body",
  "Enter email subject": "Enter email subject",
  "Enter email body": "Enter email body",
  "Email sent successfully": "Email sent successfully",
  "The email has been sent to {count} recipient(s)":
    "The email has been sent to {count} recipient(s)",
  Contact: "Contact",
  Container: "Container",
  "Containers Involved": "Containers Involved",
  Country: "Country",
  "Country of final destination": "Country of Final Destination",
  "Country of origin": "Country of Origin",
  CountryOfOrigin: "Country of Origin",
  Origin: "Origin",
  Presentation: "Presentation",
  Uses: "Uses",
  "Credit note": "Credit Note",
  "Credit notes amount": "Credit Notes Amount",
  Currency: "Currency",
  "Currency IN": "Currency IN",
  "Currency IS": "Currency IS",
  "Currency PS": "Currency PS",
  "Customer's commercial": "Customer's Commercial",
  "Cut off documents": "Cut Off Documents",
  "Cut off physical": "Cut Off Physical",
  "DHL date": "DHL Date",
  "DHL number": "DHL Number",
  Date: "Date",
  "Date Released": "Date Released",
  "Debit note": "Debit Note",
  "Debit notes amount": "Debit Notes Amount",
  Description: "Description",
  Documentation: "Documentation",
  "Done payments amount": "Done Payments Amount",
  Drafts: "Drafts",
  Emails: "Emails",
  "Estimated time of arrival (ETA)": "Estimated Time of Arrival (ETA)",
  "Estimated time of departure (ETD)": "Estimated Time of Departure (ETD)",
  Expense: "Expense",
  Expenses: "Expenses",
  "Expiration of import permit": "Expiration of Import Permit",
  "FR Comments": "FR Comments",
  File: "File",
  Forwarder: "Forwarder",
  "Forwarding agent": "Forwarding Agent",
  "Gate Out": "Gate Out",
  "Gross weight": "Gross Weight",
  Holder: "Holder",
  "IN Comments": "IN Comments",
  "IP applicable": "IP Applicable",
  Iban: "IBAN",
  Imagen: "Image",
  "Import permit file": "Import Permit File",
  "Import permit number": "Import Permit Number",
  "In stock": "In Stock",
  Incoterm: "Incoterm",
  "Incoterm IS": "Incoterm IS",
  "Incoterm PS": "Incoterm PS",
  "Instr Comments": "Instructions Comments",
  "Instr Consignee": "Instructions Consignee",
  "Instr Consignee in certificate": "Instructions Consignee in Certificate",
  "Instr Invoice to": "Instructions Invoice to",
  "Instr Labelling": "Instructions Labelling",
  "Instr Notify": "Instructions Notify",
  "Instr Product": "Instructions Product",
  "Instr Shipper": "Instructions Shipper",
  "Intermediate port": "Intermediate Port",
  Invoice: "Invoice",
  "See more columns": "See more columns",
  "See fewer columns": "See fewer columns",
  "Invoice Date": "Invoice Date",
  "Invoice Number": "Invoice Number",
  "Invoice products": "Invoice Products",
  Language: "Language",
  "Letter of credit": "Letter of Credit",
  "Loading date": "Loading Date",
  Logo: "Logo",
  "Means of Convey": "Means of Conveyance",
  "Means of convey": "Means of Conveyance",
  Name: "Name",
  "Name of Vessel": "Name of Vessel",
  "Número factura vendedor": "Seller invoice number",
  "Factura del vendedor": "Seller invoice",
  "Fecha de pago": "Payment date",
  "Peso neto": "Net weight",
  "Cantidad de contenedores": "Container quantity",
  "Toneladas por contenedor": "Tons per container",
  "Net weight": "Net Weight",
  Nombre: "Name",
  Notify: "Notify",
  Observations: "Observations",
  "Offer validity": "Offer Validity",
  "Original documents": "Original Documents",
  "PF Number": "PF Number",
  "PL Comments": "PL Comments",
  "Packing List": "Packing List",
  Paid: "Paid",
  "Fully collected": "Fully collected",
  "Applied / requested": "Applied / requested",
  "Bank payment date": "Bank payment date",
  "Not paid yet": "Not paid yet",
  "Unpaid payment excluded hint":
    "Not included in balance or totals until this payment is marked paid.",
  "Excluded from totals hint":
    "Not included in balance or totals (e.g. unpaid payment or collection not marked received).",
  "Filtered by proforma": "Filtered by proforma",
  "Exclude balance 0": "Exclude balance 0",
  accountStatementShowingRange: "Showing {from}–{to} of {total}",
  accountStatementGeneralTitle: "General Account Statement",
  accountStatementGeneralSubtitle: "Financial transactions across all contacts",
  accountStatementAllContacts: "All contacts",
  accountStatementByContactSubtitle:
    "Balance per contact. Open a contact to see its operations.",
  accountStatementNoContacts: "No contacts with movements",
  accountStatementWithoutContact: "No contact",
  contactBalanceAsOf: "Balance as of",
  contactShippingEtd: "ETD",
  contactShippingEta: "ETA",
  contactShippingDate: "Shipping date",
  listColumnAsOf: "as of {date}",
  balanceDateRangeInvalid: "From must be on or before To",
  contactBalanceFrom: "From",
  contactBalanceTo: "To",
  accountStatementFromHint:
    "With From you see only the period's movements: debits, credits and net, without the previous balance",
  accountStatementPeriodNet: "Period net",
  contactBalanceAsOfHint:
    "Each contact's balance at the end of this day (undated movements count from when they were created)",
  accountStatementTabMovements: "Movements",
  accountStatementTabArchived: "Archived",
  accountStatementTabAll: "All",
  accountStatementActions: "Actions",
  accountStatementArchiveOperation: "Archive operation",
  accountStatementArchiveConfirmTitle: "Archive this proforma operation?",
  accountStatementArchiveConfirmText:
    "All lines linked to this proforma will be hidden from the account statement. You can open them again from the Archived tab.",
  accountStatementArchivedOk: "Operation archived",
  accountStatementRestoreOperation: "Restore operation",
  accountStatementRestoreConfirmTitle: "Restore this proforma operation?",
  accountStatementRestoreConfirmText:
    "All lines linked to this proforma will appear again in the main account statement.",
  accountStatementRestoredOk: "Operation restored",
  accountStatementSelectInvoiceToPay:
    "Select at least one pending invoice from the list.",
  accountStatementAlreadyRequestedHint: "Payment requested already ({amount})",
  accountStatementHiddenByExcludeBalanceZero:
    "Exclude balance 0 is hiding all movements because each operation nets to zero. Turn off the switch to see pending payments.",
  accountStatementProformSupplierTitle: "Proform supplier (provisional)",
  accountStatementProformSupplierHint:
    "Not invoices yet: these lines stay out of debit, credit and balance. Tick them to request the advance payment.",
  accountStatementProformSupplierRequestHint: "To request: {amount}",
  accountStatementProformAdvanceCoveredHint:
    "Advance already requested or paid: the rest is requested with the invoice.",
  accountStatementBalanceReadingHint:
    "Newest first: the top Balance is the current balance; lower rows go back to the initial balance.",
  "Pending prepayment": "Pending prepayment",
  "Sin prepayment asociado": "No associated prepayment",
  "Invoice Client": "Invoice Client",
  "Invoice Shipper": "Invoice Shipper",
  "Initial Balance": "Initial Balance",
  "Accumulated Balance": "Accumulated Balance",
  TOTALS: "TOTALS",
  Yes: "Yes",
  "No proforma linked for account statement":
    "No proforma is linked to this record, so the account statement cannot be filtered.",
  "Payment conditions": "Payment Conditions",
  "Payment date": "Payment Date",
  "Payment supplier": "Payment Supplier",
  "Payment to": "Payment to",
  Payments: "Payments",
  Payment: "Payment",
  "Add Payment": "Add Payment",
  "Add Expense": "Add Expense",
  "Payment not found": "Payment not found",
  "Invalid payment id": "Invalid payment id",
  paymentAppliedToIncompleteLoad:
    "This payment's applications could not be fully loaded. Reload the page and open it again before editing them.",
  Copied: "Copied",
  Copy: "Copy",
  "Copy shareable link": "Copy link",
  "Open shareable payment page": "Open shareable payment page",
  "Link copied to clipboard": "Link copied",
  "Could not copy share link": "Could not copy link",
  Attachments: "Attachments",
  "Pending payments amount": "Pending Payments Amount",
  Phone: "Phone",
  "Port Of Delivery": "Port of Delivery",
  "Port Of Origin": "Port of Origin",
  "Port of delivery": "Port of Delivery",
  "Port of incoterm": "Port of Incoterm",
  "Port of incoterm IS": "Port of Incoterm IS",
  "Port of incoterm PS": "Port of Incoterm PS",
  "Port of origin": "Port of Origin",
  "Postal code": "Postal Code",
  Price: "Price",
  Product: "Product",
  "Product and price": "Product and Price",
  Products: "Products",
  Contracts: "Contracts",
  Proform: "Proforma",
  "Proform file": "Proforma File",
  "Proform number": "Proforma Number",
  "Proform number Date": "Proforma Number Date",
  "Qty containers": "Quantity Containers",
  "Qty of Cont": "Quantity of Containers",
  "Quantity of Containers": "Quantity of Containers",
  "Raw Weight": "Raw Weight",
  "Reference number": "Reference Number",
  ReferenceNumber: "Reference Number",
  "Related file": "Related File",
  "Release Method": "Release Method",
  "Release method": "Release Method",
  Remaining: "Remaining",
  "Request Date of Payment": "Request Date of Payment",
  "Seal Number": "Seal Number",
  "Shipper's commercial": "Shipper's Commercial",
  Shipping: "Shipping",
  "Shipping Line": "Shipping Line",
  ShippingLine: "Shipping Line",
  Signature: "Signature",
  "Sizing ref": "Sizing Reference",
  Status: "Status",
  Supplier: "Supplier",
  "Supplier Invoice number": "Supplier Invoice Number",
  "Supplier invoice date": "Supplier Invoice Date",
  "Supplier products": "Supplier Products",
  Swift: "SWIFT",
  Title: "Title",
  "To apply": "To Apply",
  Total: "Total",
  "Total (USD)": "Total (USD)",
  "Total Additional Cost": "Total Additional Cost",
  "Total Net Weight": "Total Net Weight",
  "Total Price": "Total Price",
  "PRECIO por tonelada": "PRICE per ton",
  Peso: "Weight",
  "Cantidad de Bolsas": "Number of bags",
  "Total Price Cont.": "Total Price Cont.",
  "Total Products and price": "Total Products and Price",
  "Total Qty Cont.": "Total Quantity Cont.",
  "Total Qty.": "Total Quantity",
  "Total Qty. Cont.": "Total Quantity Cont.",
  "Total Quantity": "Total Quantity",
  "Total Raw Weight": "Total Raw Weight",
  "Total add cost": "Total Additional Cost",
  "Total amount invoiced": "Total Amount Invoiced",
  "Total amount": "Total amount",
  "Total billed": "Total Billed",
  "Total containers": "Total Containers",
  "Total credit note": "Total Credit Note",
  "Total debit note": "Total Debit Note",
  "Total expenses": "Total Expenses",
  "Total invoice supplier": "Total Invoice Supplier",
  "Total net weight": "Total Net Weight",
  "Total product price": "Total Product Price",
  "Total proform": "Total Proforma",
  "Total qty": "Total Quantity",
  "Total quantity": "Total Quantity",
  TransitTime: "Transit Time",
  "Transit days": "Transit days",
  "Transit days": "Transit days",
  "Certificate type": "Certificate type",
  Type: "Type",
  "Type of Cont": "Type of Container",
  "Type of cont": "Type of Container",
  "Type of container": "Type of Container",
  "Type of document": "Type of Document",
  TypeOfContainer: "Type of Container",
  "Unit price": "Unit Price",
  "Unit qty": "Unit Quantity",
  "Validation date": "Validation Date",
  Website: "Website",

  shipping: "Shipping",
  etd: "ETD",
  eta: "ETA",
  shippingDate: "Shipping date",

  "unit price": "Unit Price",
  "unit qty": "Unit Quantity",
  "Credit/Debit notes": "Credit/Debit Notes",
  Documents: "Documents",
  Expenses: "Expenses",
  Finance: "Finance",
  "Financial Overview": "Financial Overview",
  Concept: "Concept",
  "Concept search placeholder": "Type several words separated by spaces…",
  "Concept search hint":
    "Searches plain-text content (textPlainVersion) of related records; every word must appear somewhere.",
  Remove: "Remove",
  "Credit Notes": "Credit Notes",
  "Debit Notes": "Debit Notes",
  "Credit Notes Analysis": "Credit Notes Analysis",
  "Debit Notes Analysis": "Debit Notes Analysis",
  "credit notes": "credit notes",
  "debit notes": "debit notes",
  "No credit notes to display": "No credit notes to display",
  "No debit notes to display": "No debit notes to display",
  "Income - Expenses - Credit Notes + Debit Notes":
    "Income - Expenses - Credit Notes + Debit Notes",
  "Original Amount": "Original Amount",
  "Expected Amount": "Expected Amount",
  "Credit Notes": "Credit Notes",
  "Debit Notes": "Debit Notes",
  Adjusted: "Adjusted",
  Freight: "Freight",
  "Freight Price": "Freight Price",
  "Freight Price 2": "Freight Price 2",
  General: "General",
  "Import Permit": "Import Permit",
  "Invoice (IN)": "Invoice (IN)",
  "Invoice Supplier (IS)": "Invoice Supplier (IS)",
  Location: "Location",
  "Packing List (PL)": "Packing List (PL)",
  "Proform Shipper": "Proforma Shipper",
  "Proform Supplier (PS)": "Proforma Supplier (PS)",
  Proforma: "Proforma",
  "Shipping Instructions": "Shipping Instructions",
  Shippings: "Shippings",
  Totals: "Totals",

  // Auto-save translations
  unsavedChanges: "Unsaved Changes",
  unsavedChangesMessage:
    "You have pending modifications that have not been saved",
  newRecordNotSavedYet:
    "This form has not been saved yet: press «Save» to create the record",
  savingIn: "Saving in",
  saving: "Saving",
  disableAutoSave: "Disable autosave",

  // Calendar translations
  calendar: {
    weekDays: {
      sunday: "Sun",
      monday: "Mon",
      tuesday: "Tue",
      wednesday: "Wed",
      thursday: "Thu",
      friday: "Fri",
      saturday: "Sat",
    },
    todayEvents: {},

    noEventsForDate: "No events for this date",
    createEvent: "Create event",
    // Ayuda (?) de cada ítem del engranaje del calendario del dashboard.
    fieldHelp: {
      shipping_etd: "Shows each shipment on the day the vessel is estimated to depart (ETD).",
      shipping_eta: "Shows the shipments arriving in 20 days or less that haven't had gate out yet, on their estimated arrival day (ETA).",
      shipping_shipping_date: "Shows each shipment on the day the goods are loaded.",
      shipping_gate_out: "Shows each shipment on the day the cargo left the port (gate out).",
      payment_payment_date: "Shows the payments already made, on the day they were paid.",
      collect_date: "Shows the collections from clients, on their collection date.",
      shipping_status_1: "Shipments that don't have a loading date yet. Unchecking it hides all their dates.",
      shipping_status_2: "Shipments with a loading date set for today or later. Unchecking it hides all their dates.",
      shipping_status_3: "Shipments already loaded that haven't reached their ETD yet. Unchecking it hides all their dates.",
    },
  },

  // Events Analyzer translations
  eventsAnalyzer: {
    today: {
      title: "Today's Events",
      noEvents: "No events for today",
      criteria:
        "Events happening exactly today: loadings, payments, collections, ETAs, Gate Out, etc.",
    },
    thisWeek: {
      title: "This Week",
      noEvents: "No events this week",
      criteria:
        "Events in the next 7 days: all important dates that expire this week",
    },
    nextEvents: {
      title: "Next Events",
      noEvents: "No upcoming events",
      criteria:
        "Events in the next 30 days (excluding this week): medium-term planning",
    },
    urgent: {
      title: "Urgent Events",
      noEvents: "No urgent events",
      criteria:
        "Events requiring immediate action: upcoming ETAs (3 days), unpaid overdue payments, incomplete overdue ETAs/Gate Out (status ≠ 6)",
    },
    criteria: {
      title: "Classification Criteria",
      close: "Close",
    },
    pendingPayment: "Pending payment",
    viewDetails: "View Details",
  },

  // Operations Summary translations
  operationsSummary: {
    title: "Operations Summary",
    noOperations: "No upcoming operations",
    help: "Help about export dates",
    close: "Close",
    helpText: {
      title: "Classification Criteria",
      sections: {
        mainDates: {
          title: "Main Shipping Dates",
          eta: "ETA (Estimated Time of Arrival): Estimated arrival date of the vessel/aircraft at the destination port. Important for coordinating customs clearance and cargo pickup.",
          etd: "ETD (Estimated Time of Departure): Estimated departure date of the vessel/aircraft from the origin port. Marks the beginning of international transit.",
        },
        cutOffs: {
          title: "Cut Offs",
          documents:
            "Cut Off Documents: Deadline for presenting export documentation. If not met, the shipment may be left out of the voyage.",
          physical:
            "Cut Off Physical: Deadline for physically delivering cargo to the terminal. After this point, the container can no longer be accepted.",
        },
        cargoMovements: {
          title: "Cargo Movements",
          loading:
            "Loading Date: Day when cargo is loaded onto the vessel/aircraft. Coincides with stevedoring operations at port.",
          gateOut:
            "Gate Out: Date when the container leaves the depot for the port terminal. Marks the beginning of custody by the carrier.",
        },
        documentation: {
          title: "Commercial Documentation",
          dateReleased:
            "Date Released: Date when shipping documents are released. From here, the importer can manage pickup at destination.",
        },
        importPermits: {
          title: "Import Permits",
          expiration:
            "Import Permit Expiration: Expiration date of the permit. If it expires before cargo arrival, it cannot be nationalized.",
        },
        payments: {
          title: "Payment Dates",
          paymentDate:
            "Payment Date: Date when something needs to be paid. Critical for maintaining cash flow and avoiding penalties.",
        },
      },
    },
    messages: {
      eta: {
        today:
          "🚢 <strong>Arrival today!</strong> {count} {vessel} {verb} today at the destination port. Time to coordinate customs clearance and cargo pickup.",
        tomorrow:
          "🚢 <strong>Arrival tomorrow:</strong> {count} {vessel} {verb} tomorrow. Get ready for customs clearance.",
        thisWeek:
          "🚢 <strong>This week:</strong> {count} {vessel} {verb} this week. Coordinate with the importer for pickup.",
      },
      etd: {
        today:
          "⚓ <strong>Departure today:</strong> {count} {vessel} {verb} today from the origin port. International transit has begun.",
        tomorrow:
          "⚓ <strong>Departure tomorrow:</strong> {count} {vessel} {verb} tomorrow. Last chance to complete documentation.",
        thisWeek:
          "⚓ <strong>This week:</strong> {count} {vessel} {verb} this week from the origin port.",
      },
      loading: {
        today:
          "📦 <strong>Loading today:</strong> {count} {container} {verb} today on the vessel. Stevedoring operations at port.",
        tomorrow:
          "📦 <strong>Loading tomorrow:</strong> {count} {container} {verb} tomorrow.",
        thisWeek:
          "📦 <strong>This week:</strong> {count} {container} {verb} this week.",
      },
      gateOut: {
        today:
          "🚛 <strong>Gate Out today:</strong> {count} {container} {verb} today from the depot to the port terminal.",
        tomorrow:
          "🚛 <strong>Gate Out tomorrow:</strong> {count} {container} {verb} tomorrow to the port.",
        thisWeek:
          "🚛 <strong>This week:</strong> {count} {container} {verb} this week to the terminal.",
      },
      payment: {
        today:
          "💰 <strong>Payment today:</strong> {count} {payment} {verb} today. Attention! Check the status of pending payments.",
        tomorrow:
          "💰 <strong>Payment tomorrow:</strong> {count} {payment} {verb} tomorrow. Get ready to make payments.",
        thisWeek:
          "💰 <strong>This week:</strong> {count} {payment} {verb} this week.",
      },
      cutOffDocs: {
        today:
          "📄 <strong>Cut Off documents today:</strong> {count} {operation} {verb} document closure today. Last chance!",
        tomorrow:
          "📄 <strong>Cut Off documents tomorrow:</strong> {count} {operation} {verb} document closure tomorrow.",
        thisWeek:
          "📄 <strong>This week:</strong> {count} {operation} {verb} document closure this week.",
      },
      cutOffPhysical: {
        today:
          "📦 <strong>Cut Off physical today:</strong> {count} {operation} {verb} physical closure today. Last chance!",
        tomorrow:
          "📦 <strong>Cut Off physical tomorrow:</strong> {count} {operation} {verb} physical closure tomorrow.",
        thisWeek:
          "📦 <strong>This week:</strong> {count} {operation} {verb} physical closure this week.",
      },
      dateReleased: {
        today:
          "📋 <strong>Documents released today:</strong> {count} {document} {verb} today. The importer can manage pickup.",
        tomorrow:
          "📋 <strong>Documents tomorrow:</strong> {count} {document} {verb} tomorrow.",
        thisWeek:
          "📋 <strong>This week:</strong> {count} {document} {verb} this week.",
      },
      importPermit: {
        today:
          "🛂 <strong>Permits expire today:</strong> {count} {permit} {verb} today. Critical! Without permit cannot be nationalized.",
        tomorrow:
          "🛂 <strong>Permits tomorrow:</strong> {count} {permit} {verb} tomorrow. Renew urgently.",
        thisWeek:
          "🛂 <strong>This week:</strong> {count} {permit} {verb} this week.",
      },
      payment_pending: {
        today:
          "⚠️ <strong>Pending payments today:</strong> {count} {payment} {verb} today. Urgent! These payments need to be processed immediately.",
        tomorrow:
          "⚠️ <strong>Pending payments tomorrow:</strong> {count} {payment} {verb} tomorrow. Prepare to process these payments.",
        thisWeek:
          "⚠️ <strong>This week:</strong> {count} {payment} {verb} this week. Review and process pending payments.",
      },
    },
    words: {
      vessel: { single: "vessel", plural: "vessels" },
      container: { single: "container", plural: "containers" },
      payment: { single: "payment", plural: "payments" },
      operation: { single: "operation", plural: "operations" },
      document: { single: "document set", plural: "document sets" },
      permit: { single: "permit", plural: "permits" },
      arrives: { single: "arrives", plural: "arrive" },
      leaves: { single: "departs", plural: "depart" },
      loads: { single: "is loaded", plural: "are loaded" },
      goesOut: { single: "goes out", plural: "go out" },
      expires: { single: "expires", plural: "expire" },
      has: { single: "has", plural: "have" },
      releases: { single: "is released", plural: "are released" },
    },
  },

  // Financial Summary translations
  dashboardWidgets: {
    manage: "Widgets",
    reorder: "Reorder",
    doneReordering: "Done",
    moveUp: "Move up",
    moveDown: "Move down",
    remove: "Remove",
    refresh: "Refresh",
    options: "Widget options",
    dragHint: "Drag to move · corner to resize",
    saving: "Saving…",
    saveError: "Couldn't save the dashboard",
    loadError: "Couldn't load the data.",
    emptyDashboard: "Your dashboard is empty.",
    resetConfirmTitle: "Reset the dashboard?",
    resetConfirmText: "The default dashboard comes back and your widgets and notes are lost.",
    cancel: "Cancel",
    // "Products" and "Contacts" widgets (TradeWidget)
    trade: {
      noSources: "There are no operations you can see.",
      noData: "No data to show.",
      noUnit: "no unit",
      others: "Others",
      vsPrevious: "vs. previous period",
      lastMonths: "Last {n} months",
      allTime: "All time",
      dormantFor: "No operations for {n} months",
      firstIn: "First: {month}",
      lastIn: "Last: {month}",
      opsCount: "{n} ops",
      concentrationText: "of the total in the top {n}, out of {total} clients",
      kpi: { products: "Products", operations: "Operations", qty: "Quantity", total: "Total", newProducts: "New products" },
      empty: {
        newProducts: "No new products in the period.",
        newClients: "No new clients in the period.",
        dormant: "Every client bought within that time.",
      },
      sources: { contract: "Contracts", shipping: "Shipments", proform: "Proformas" },
      kinds: { sale: "Sale", purchase: "Purchase", trade: "Brokerage" },
      measure: { qty: "Quantity", amount: "Amount", operations: "Operations" },
      menu: {
        source: "Operations",
        side: "Side",
        measure: "Measure by",
        unit: "Unit",
        period: "Period",
        dormant: "No operations for",
        months: "{n} months",
        allTime: "All time",
        show: "Show",
        top: "Top {n}",
      },
    },
    categories: {
      all: "All",
      general: "General",
      finance: "Finance",
      products: "Products",
      contacts: "Contacts",
      reports: "Reports",
      containers: "Containers & stock",
      tracking: "Tracking",
      support: "Support",
      tools: "Tools",
      market: "Market",
      ai: "Artificial intelligence",
    },
    catalog: {
      title: "Dashboard widgets",
      subtitle: "Choose what to see on your dashboard. Only widgets for your modules and permissions are listed.",
      search: "Search widgets…",
      close: "Close",
      loading: "Loading widgets…",
      noResults: "No matching widgets.",
      added: "Added",
      add: "Add",
      addAnother: "Add another",
      remove: "Remove",
      reset: "Reset",
      done: "Done",
    },
    items: {
      products_summary: { title: "Products: summary", description: "Products traded, operations, quantities and total for the period, compared with the previous one." },
      products_top: { title: "Top products", description: "Products ranked by quantity, amount or operations, on sales or purchases." },
      products_by_month: { title: "Quantity by month", description: "Tons (or the unit you choose), amount or operations each month." },
      products_new: { title: "New products", description: "Products traded for the first time in the period." },
      contacts_top_clients: { title: "Top clients", description: "Who bought the most, by quantity, amount or operations." },
      contacts_top_suppliers: { title: "Top suppliers", description: "Who it was bought from the most, by quantity, amount or operations." },
      contacts_new_clients: { title: "New clients", description: "Clients with their first operation in the period." },
      contacts_dormant: { title: "Inactive clients", description: "Clients who bought and have not come back for 3, 6 or 12 months, the ones with most operations first." },
      contacts_concentration: { title: "Client concentration", description: "How much of the total the top clients take." },
      shortcuts: { title: "Shortcuts", description: "Case law and MEV one click away." },
      calendar: { title: "Calendar", description: "Your operation dates month by month." },
      recent_activity: { title: "Recent activity", description: "What was created or changed lately, and by whom." },
      operations_summary: { title: "Operations summary", description: "Upcoming events for each date type." },
      containers_month: { title: "Containers by month", description: "Shipped in the last 12 months and year to date." },
      containers_destination: { title: "Containers by destination", description: "Countries with the most containers this year." },
      containers_client: { title: "Containers by client", description: "Clients with the most containers this year." },
      containers_shipper: { title: "Containers by shipper", description: "Shippers with the most containers this year." },
      stock_health: { title: "Stock status", description: "Products in stock, at zero and negative." },
      support_tickets: { title: "Support tickets", description: "How many tickets are pending, in progress or waiting for an answer." },
      finance_month: { title: "This month's finances", description: "Collected, paid and net this month vs. last, by currency." },
      finance_cashflow: { title: "Cash flow", description: "Money in and out over the last 6 months." },
      finance_payments_pending: { title: "Pending payment requests", description: "What's left to pay, what's overdue and what's next." },
      finance_receivables: { title: "Receivables", description: "Balance to collect on operations and the clients who owe the most." },
      finance_payables: { title: "Supplier payables", description: "Balance owed to suppliers, by currency." },
      finance_bank_balances: { title: "Account balances", description: "The balance of each bank account, by currency." },
      finance_margins: { title: "Projected margin", description: "Sales, margin and % by month, on proforms." },
      finance_margins_real: { title: "Real margin", description: "Sales, margin and % by month, on shippings with costs." },
      finance_low_margins: { title: "Lowest margin", description: "Operations from the last 90 days with the lowest margin." },
      finance_advances: { title: "Pending advances", description: "Proform advances not collected yet." },
      notifications: { title: "Latest notifications", description: "The alerts you get by email: payment requests, collections, tickets." },
      tracking_status: { title: "Tracking status", description: "Containers in transit, not sailed, delayed and with errors." },
      tracking_alerts: { title: "Tracking alerts", description: "Overdue milestones, past ETA not arrived and carrier errors." },
      tracking_arrivals: { title: "Upcoming arrivals", description: "Containers by arrival date, with route and shipping." },
      tracking_routes: { title: "Active routes", description: "Active containers by origin and destination." },
      note: { title: "Note", description: "A reminder of your own, only you see it." },
      client_questions: { title: "Questions", description: "What we need you to clarify about what we are building. Answer right here." },
      report: { description: "Saved {model} report." },
    },
    report: {
      empty: "The report has no rows.",
      seeAll: "See all {n} rows",
      rows: "rows",
      partial: "Calculated on the first {n} rows.",
      noValue: "(empty)",
      others: "Others",
      modeList: "List",
      modeKpi: "Total",
      open: "Open report",
      modeChart: "Chart",
      configure: "Configure…",
      chartCaption: "{measure} by {by}",
    },
    settings: {
      title: "Configure widget",
      showAs: "Show as",
      modeList: "List",
      modeKpi: "Total",
      modeChart: "Chart",
      chartType: "Chart type",
      type: { column: "Columns", bar: "Bars", line: "Line", area: "Area", pie: "Pie", donut: "Donut" },
      xAxis: "X axis",
      yAxis: "Y axis",
      slices: "Slices",
      sliceSize: "Size of each slice",
      field: "Field",
      date: "date",
      groupDateBy: "Group the date by",
      bucket: { day: "Day", week: "Week", month: "Month", year: "Year" },
      measure: "Measure",
      ofField: "Of field",
      agg: { count: "Number of rows", sum: "Sum", avg: "Average", max: "Maximum", min: "Minimum" },
      periods: "Periods to show",
      maxCategories: "Max. categories",
      order: "Order",
      sortValue: "Highest first",
      sortLabel: "Alphabetical",
      rowTitle: "Row title",
      auto: "Automatic",
      details: "Details (up to {n})",
      kpiFields: "Columns to sum (up to 4)",
      noNumeric: "The report has no numeric columns.",
      preview: "Preview",
      cancel: "Cancel",
      save: "Save",
    },
    containers: {
      thisMonth: "This month",
      ytd: "In {year}",
      vsLastYear: "vs. last year",
      allYears: "All years",
      empty: "No containers in this period.",
      open: "Open containers",
    },
    stats: {
      products: "products",
      withStock: "In stock",
      zeroStock: "At zero",
      negativeStock: "Negative",
      openTickets: "open tickets",
      pending: "Pending",
      progress: "In progress",
      waitingForAnswer: "Waiting for answer",
      readyForTest: "Ready to test",
      open: "Open",
    },
    finance: {
      noCurrency: "No currency",
      denied: "You don't have permission to see this data.",
      noMovements: "No movements in this period.",
      collected: "Collected",
      paid: "Paid",
      net: "Net",
      prevMonth: "prev. {v}",
      in: "In",
      out: "Out",
      requests: "{n} requests",
      overdue: "{n} overdue · {v}",
      noPending: "No pending payment requests.",
      nothingPending: "No pending balances.",
      operations: "{n} operations",
      proformsWithAdvance: "{n} proforms",
      shippingsCount: "{n} shippings",
      expensesCount: "{n} expenses",
      accounts: "{n} accounts",
      excluded: "{n} records with a balance above the sale are not counted (check them).",
      noMargins: "No operations with margin in this period.",
      sales: "Sales",
      margin: "Margin",
      marginPct: "Margin %",
      marginPctByMonth: "Margin % by month",
      last90: "Last 90 days; records without costs or inconsistent are left out.",
      basis: "Calculate on",
      basisProforms: "Proforms (projected)",
      basisShippings: "Shippings (real)",
      currency: "Currency",
      open: "Open finance",
    },
    tracking: {
      noActive: "No containers being tracked.",
      activeTrackings: "being tracked",
      stoppedCount: "{n} stopped (not counted)",
      state: {
        inTransit: "In transit",
        notSailed: "Not sailed",
        delayed: "Delayed",
        error: "With error",
        completed: "Completed",
        noData: "No data",
      },
      noAlerts: "Nothing to check: all as expected.",
      syncError: "Carrier error ({code}): {text}",
      noArrivals: "No arrivals with ETA.",
      today: "today",
      inDays: "in {n} d",
      daysLate: "{n} d ago",
      open: "Open tracking",
    },
    notifications: {
      empty: "No alerts received yet.",
      repeated: "Received {n} times",
      justNow: "just now",
      minutesAgo: "{n} min ago",
      hoursAgo: "{n} h ago",
      daysAgo: "{n} d ago",
    },
    presets: {
      title: "Saved dashboards",
      close: "Close",
      saveCurrent: "Save the current dashboard",
      saveCurrentShort: "Save this dashboard",
      createSubtitle: "It becomes a button at the top; if you share it, everyone can use it.",
      editTitle: "Edit “{name}”",
      editOne: "Edit “{name}”",
      name: "Name",
      namePlaceholder: "Name (e.g. “Today's operations”)",
      description: "Description",
      descriptionPlaceholder: "Description (optional)",
      share: "Share with other users",
      shareHint: "Every user will see it; each one only sees the widgets their role allows. Notes are not shared.",
      save: "Save",
      saveChanges: "Save changes",
      cancel: "Cancel",
      by: "by {name}",
      widgetsCount: "{n} widgets",
      unsaved: "Changed since you picked it (not saved)",
      overwrite: "Replace with the current dashboard",
      overwriteHint: "Stores in this dashboard how yours is arranged right now.",
      overwriteTitle: "Replace “{name}” with your current dashboard?",
      overwriteText: "Whoever uses it next will get the new layout.",
      delete: "Delete",
      deleteTitle: "Delete “{name}”?",
      deleteSharedText: "It's shared: it stops being available to others (nothing changes for those already using it).",
      saveError: "Couldn't save",
      deleteError: "Couldn't delete",
      default: "Default",
      applyToAll: "Apply to all users",
      applyToAllHint: "Replaces every user's dashboard and becomes the default for new users.",
      applyToAllTitle: "Apply “{name}” to all users?",
      applyToAllText: "It replaces every user's dashboard (their current widgets and notes are lost) and becomes the default for new users. Each one only sees the widgets their role allows.",
      appliedToAll: "Applied to {n} users",
      clearDefault: "Stop using it as default",
      clearDefaultHint: "New users start again with the factory dashboard.",
      switchTitle: "Use “{name}”?",
      switchTextDirty: "Your changes to “{name}” are not saved and will be lost.",
      switchTextUnsaved: "Your current dashboard is not saved and will be lost. To keep it, save it with “+”.",
      saveShort: "Save",
      saveChangesIn: "Save the changes in “{name}”",
      saveAsNew: "You can't change this dashboard: save your changes as a new one",
      discardTitle: "Discard the changes to “{name}”?",
      discardText: "It goes back to how it was saved. To keep your changes, use “Save”.",
      discard: "Discard",
      foreignTitle: "This dashboard isn't yours",
      foreignText: "“{name}” belongs to {owner}: your changes can't be saved in it. Do you want to save them as a new dashboard of your own?",
      foreignTextNoOwner: "“{name}” belongs to another user: your changes can't be saved in it. Do you want to save them as a new dashboard of your own?",
      saveAsNewShort: "Save as new",
      keepWithoutSaving: "Keep without saving",
      copyName: "{name} (copy)",
      switchConfirm: "Use",
    },
    tour: {
      launcher: "Tutorial",
      launcherTitle: "How to use the new widget dashboard",
      hide: "Hide the tutorial",
      welcomeTitle: "Your dashboard is now made of widgets",
      welcomeBody: "Pick what to see, arrange it your way and save it. Here's how, in a minute.",
      addTitle: "Add or remove widgets",
      addBody: "Tap “Widgets” to see everything available to you.",
      catalogTitle: "The catalog",
      catalogBody: "Each card is a widget with its preview: reports, containers, finance, tracking and more. Tap “Add” on the ones you want; you only see those your modules and permissions allow.",
      catalogBodyMobile: "Each card is a widget with its preview. Tap “Add” on the ones you want; you only see those your modules and permissions allow.",
      catalogDoneTitle: "Done",
      catalogDoneBody: "When you're finished, tap “Done” to go back to the dashboard.",
      moveTitle: "Move them",
      moveBody: "Drag a widget by its header. While you carry it, the whole dashboard shrinks so you can drop it anywhere.",
      resizeTitle: "Resize them",
      resizeBody: "Make it bigger or smaller from the bottom-right corner. If you drop it next to another and it doesn't fit, it takes the free width.",
      reorderTitle: "Reorder them",
      reorderBody: "On the phone they stack one below the other: tap “Reorder” to move them up, down or remove them.",
      menuTitle: "Widget options",
      menuBody: "In “⋯”: refresh, remove and, for reports, show them as a list, a total or a chart (with the X and Y axes you choose).",
      presetsTitle: "Save your dashboards",
      presetsBody: "With “+” you save your arrangement under a name. You can have several and share them: each one becomes a button up here.",
      endTitle: "That's it!",
      endBody: "This tutorial stays at hand for a few days with the “Tutorial” button above, in case you want to go over it again.",
    },
    note: {
      placeholder: "Write something to remember…",
    },
    clientQuestions: {
      pending: "Pending",
      answered: "Answered",
      new: "New question",
      reply: "Answer",
      correct: "Edit answer",
      send: "Send answer",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      deleteConfirm: "Delete this question?",
      reopen: "Ask again",
      markRead: "Mark as read",
      newAnswer: "New answer",
      answerPlaceholder: "Write your answer…",
      questionPlaceholder: "The question",
      contextPlaceholder: "Context: what we saw, where the question comes from",
      topicPlaceholder: "Topic (optional)",
      answeredBy: "Answered by {name} · {date}",
      previousAnswers: "Previous answers ({n})",
      emptyPending: "No pending questions. Thanks!",
      emptyAnswered: "No answered questions yet.",
      thanks: "Thanks for your answer!",
      saveError: "Could not save",
      archived: "Archived",
      archive: "Archive",
      unarchive: "Unarchive",
      archivedBy: "Archived by {name} · {date}",
      emptyArchived: "No archived questions.",
    },
  },
  tour: {
    step: "{n} of {total}",
    next: "Next",
    back: "Back",
    done: "Done",
    skip: "Skip",
    clickToContinue: "Click the highlighted item to continue",
  },
  recentActivity: {
    title: "Recent activity",
    reload: "Refresh",
    empty: "Nothing has moved yet.",
    error: "Recent activity could not be loaded.",
    createdByAt: "was created by {who} at {when}",
    createdAt: "was created at {when}",
    createdBy: "was created by {who}",
    modifiedByAt: "(last modified by {who} at {when})",
    modifiedAt: "(last modified at {when})",
  },
  financialSummary: {
    title: "Operational Dashboard",
    summaryClientLabel: "Client:",
    summaryClientFallback: "View contact",
    openContactNewTab: "Open contact in new tab",
    loading: "Loading financial data...",
    allGood: "All financial aspects are in order",
    helpTitle: "Understanding Collections",
    close: "Close",
    pickShippingContainersTitle: "Which container slots?",
    pickShippingContainersHint:
      "This proforma has {total} container slot(s). Select the slot(s) for this new shipping. Slots already used by other shippings are hidden.",
    pickShippingContainersNeedOne: "Select at least one slot.",
    pickShippingContainersNoneLeft:
      "Every container slot on this proforma is already linked to another shipping.",
    pickShippingContainersNoneLeftTitle: "No free container slots",
    pickShippingContainersConfirm: "Continue",
    pickShippingContainersCancel: "Cancel",
    totalProform: "Total Proform",
    totalBilled: "Total Billed",

    expectedAmount: "Expected Amount",
    advanceDeducted: "advance deducted",
    shippingCollectionsApplied: "collections applied to shipping",
    commercialNotesCreditDeducted: "credit notes",
    commercialNotesDebitAdded: "debit notes",
    collected: "Collected",
    pending: "Pending",
    pendingAdvance: "Pending Advance",
    overCollectedWarning: "Over-collected: {amount}",
    stages: {
      step1Short: "Advance (proforma only)",
      step2Short: "Per shipping",

      /** Text after highlighted «{pct}%» in stage 1 summary (CollectionSummary). */
      stage1AdvanceSummaryLineAfterAmount:
        " advance expected ({pct}% of this proforma {total})",
      stage1AssignAdvanceToShippingNamed: "Assign this advance to —> {name}",
      stage1AssignAdvanceToShippingNamedHint:
        "Assign to advance on this shipping (proforma + shipping), not invoice balance",
      stage1AssignAdvanceToShippingTitle: "Shipping {n}",

      collectedShort: "Collected",
      remainingShort: "Left",
      overCollectedInvoiceHint:
        "Over-collected on this invoice: {amount}. Reassign the excess by dragging the collect chip to another shipping.",
      overCollectedAdvanceHint:
        "Advance over-collected: {amount}. Reassign the excess to another shipping or proforma.",
      notaImpactBoxCaption: "Commercial notes (client)",
      notaImpactAdvanceMetaCaption: "Proforma — advance stage",
      notaImpactAdvanceCreditRowTitle: "Credit notes (proforma)",
      notaImpactAdvanceDebitRowTitle: "Debit notes (proforma)",
      notaImpactAdvanceCredit:
        "Credit on proforma: {amount} — lowers the advance still to collect.",
      notaImpactAdvanceDebit:
        "Debit on proforma: {amount} — adds to what is still to collect (with shipments, in stage 2).",
      notaImpactInvoiceCredit:
        "Credit on invoice (this shipping): {amount} — lowers invoice balance to collect.",
      notaImpactInvoiceCreditRowTitle: "Credit notes (invoice)",
      notaImpactInvoiceDebit:
        "Debit on invoice (this shipping): {amount} — raises invoice balance to collect.",
      notaImpactInvoiceDebitRowTitle: "Debit notes (invoice)",
      notaImpactSupplierPaymentsCredit:
        "Supplier credit on this shipping: {amount} — reduces supplier payment due.",
      notaImpactSupplierPaymentsCreditRowTitle: "Supplier credit notes (payments)",
      notaImpactSupplierPaymentsDebit:
        "Supplier debit on this shipping: {amount} — increases supplier payment due.",
      notaImpactSupplierPaymentsDebitRowTitle: "Supplier debit notes (payments)",
      notaImpactExpectedNet:
        "Net note impact on expected amount: {amount} (credits lower, debits raise).",

      noAdvancePct: "No advance % on this proforma.",
      advancePctSetButton: "Set advance",
      advancePctEditHint: "Change the advance of this proforma",
      advanceModalEditTitle: "Change advance",
      advanceModalSetTitle: "Set advance",
      advanceModePct: "Percentage",
      advanceModeAmount: "Amount",
      advancePreviewFromPct: "= {amount} advance expected",
      advancePreviewFromAmount: "= {pct}% of this proforma",
      advancePayableLabel: "Payment conditions (client)",
      advancePayableNone: "— none —",
      advanceValueInvalid: "Enter a number greater than zero.",
      advanceAmountNoTotal: "This proforma has no total yet, so an amount cannot be converted.",
      advanceAmountOverTotal: "The advance cannot exceed the proforma total ({total}).",
      advancePctPlaceholder: "1–100",
      advancePctSave: "Save",
      advancePctSaving: "Saving…",
      advancePctInvalidTitle: "Invalid percentage",
      advancePctInvalid: "Enter a whole number between 1 and 100.",
      advancePctSaved: "Advance updated",
      advancePctSaveError: "Could not save the advance percentage.",

      stage2ShippingCollectCompleteTitle: "This shipping is already complete",
      stage2ShippingCollectCompleteText:
        "It shows as Shipping OK: no invoice balance pending and assigned advance covers what was expected. You cannot register more collections from here.",
      noCollectPermissionHint: "No permission to register collections.",

      shipStage2AdvanceBlockTitle: "Proforma advance",
      shipStage2PaymentsBlockTitle: "Payments (supplier & costs)",
      shipStage2OperationMarginCaption: "Operation margin (collected − paid)",
      shipStage2CompactSummaryExpandHint:
        "Click to show shipping collections and payments",
      shipStage2CompactSummaryCollapseHint: "Click to hide details",
      supplierAdvancePctInlineLabel: "Supplier invoice advance (%)",
      supplierAdvancePctSave: "Save",
      supplierAdvancePctSaving: "Saving…",
      supplierAdvancePctInvalidTitle: "Invalid percentage",
      supplierAdvancePctInvalid: "Enter a whole number between 1 and 100.",
      supplierAdvancePctSaved: "Supplier advance updated",
      supplierAdvancePctSaveError:
        "Could not save the supplier advance percentage.",

      /** Label before highlighted % in read-only supplier advance line */
      supplierAdvancePctReadOnlyBefore: "Supplier invoice advance: ",

      supplierInvoiceAdvanceSummaryLineAfterPct:
        " of supplier invoice ({total}) → {expected} advance expected",
      shipPaymentsShipperLine: "Supplier: {name}",
      shipPendingAfterNotesHint: "Pending is already net of the commercial notes applied here.",
      shipPaymentsLinkedForExpenseCaption: "Payments linked to this expense",
      shipPaymentsPillPaidBadge: "Paid",

      shipPaymentsQuickPayButton: "Pay",
      shipPaymentsQuickPayHint:
        "Mark as paid with date, bank account, comment and receipt only (amount read-only)",
      quickMarkPaymentPaidTitle: "Quick pay — mark as paid",
      quickMarkPaymentPaidHint:
        "The payment amount and expense applications are not edited here. Use Pay if you need the full payment screen.",
      quickMarkPaymentPaidAmountLabel: "Amount",
      quickMarkPaymentPaidAmountInvalid: "Enter a valid amount greater than zero.",
      quickMarkPaymentPaidAmountMaxHint: "Maximum for this expense: {max}",
      quickMarkPaymentPaidAmountExceedsExpense:
        "Amount cannot exceed the expense total ({max}).",
      quickMarkPaymentPaidDateLabel: "Payment date",
      quickMarkPaymentPaidEstimatedDateLabel: "Expected payment date",
      quickMarkPaymentPaidNeitherDateError: "Enter a payment date or an expected payment date.",
      quickMarkPaymentPaidCommentLabel: "Comment",
      quickMarkPaymentPaidCommentPlaceholder: "Optional",
      quickMarkPaymentPaidReceiptLabel: "Payment receipt / proof",
      quickMarkPaymentPaidReceiptHint: "Images, PDF or Word. Max 10 MB.",
      quickMarkPaymentPaidSave: "Save and mark paid",
      quickMarkPaymentPaidDateRequired: "Payment date is required.",
      quickMarkPaymentPaidBankRequired: "Bank account is required.",
      quickMarkPaymentPaidValidationTitle: "Check the form",
      quickMarkPaymentPaidFileTooBig: "File must be under 10 MB.",
      quickMarkPaymentPaidFileType:
        "Unsupported file type. Use images, PDF or Word.",
      quickMarkPaymentPaidFileError: "Could not upload the file.",
      quickMarkPaymentPaidSuccessTitle: "Payment updated",
      quickMarkPaymentPaidSuccessText: "Saved and marked as paid.",
      quickMarkPaymentPaidSuccessEstimated: "Saved with expected payment date.",
      quickMarkPaymentPaidSaveError: "Could not save the payment.",
      quickMarkPaymentPaidDeleteConfirmTitle: "Delete payment?",
      quickMarkPaymentPaidDeleteConfirmText:
        "This payment will be permanently removed from the operation.",
      quickMarkPaymentPaidDeleteLoadingTitle: "Deleting payment...",
      quickMarkPaymentPaidDeleteSuccessTitle: "Payment deleted",
      quickMarkPaymentPaidDeleteError: "Could not delete the payment.",
      quickMarkPaymentPaidDeleteConfirmPaidText:
        "This payment is already marked as paid. Are you sure you want to permanently remove it from the operation?",
      shipPaymentsDeletePaymentHint: "Delete payment",
      shipStage2CollectionsBlockTitle: "Collections (client)",
      shipPaymentsTotalCosts: "Total costs",
      shipPaymentsEditShipperPricesButton: "Set shipper prices",
      shipPaymentsEditShipperPricesTitle: "Shipper unit prices (shipping)",
      shipPaymentsEditShipperPricesHint:
        "Enter the unit price for each line in «product / price shipper». Saving updates the shipping and recalculates supplier totals. The sale column comes from «product / price» (invoice to client) so you can compare with the shipper cost.",
      shipPaymentsEditShipperPricesProduct: "Product",
      shipPaymentsEditShipperPricesQty: "Qty",
      shipPaymentsEditShipperPricesInvoiceUnitPrice: "Sale unit (invoice)",
      shipPaymentsEditShipperPricesUnitPrice: "Shipper unit price",
      shipPaymentsEditShipperPricesEmpty:
        "This shipping has no lines in product / price shipper yet. Add them on the shipping record, then you can set prices here.",
      shipPaymentsEditShipperPricesLoadError: "Could not load the shipping.",
      shipPaymentsEditShipperPricesSave: "Save to shipping",
      shipPaymentsEditShipperPricesSaved: "Shipping updated",
      shipPaymentsEditShipperPricesSaveError:
        "Could not save. Check amounts and try again.",
      shipPaymentsEditShipperPricesInvalidNumber:
        "Enter a valid number for every unit price (or leave empty to clear).",
      shipPaymentsEditShipperPricesInvalidTitle: "Check prices",
      shipPaymentsEditShipperInvoiceQtyButton: "Set proform supplier quantities",
      shipPaymentsEditShipperInvoiceQtyTitle: "Supplier invoice quantities (product / price shipper)",
      shipPaymentsEditShipperInvoiceQtyHint:
        "Enter quantity or net weight and shipper unit price for each line in «product / price shipper» on this shipping. The first reference column shows the client invoice quantity; the next shows the sale unit price from the client invoice block when it exists. Saving updates the shipping and recalculates supplier totals.",
      shipPaymentsEditShipperInvoiceQtyClientRef: "Quantity or Net weight (client invoice)",
      shipPaymentsEditShipperInvoiceQtySupplierCol: "Quantity or Net weight (supplier)",
      shipPaymentsEditShipperInvoiceQtyEmpty:
        "This shipping has no lines in product / price shipper yet. Add them on the shipping record, then you can set quantities here.",
      shipPaymentsEditShipperInvoiceQtyLoadError: "Could not load the shipping.",
      shipPaymentsEditShipperInvoiceQtySave: "Save to shipping",
      shipPaymentsEditShipperInvoiceQtySaved: "Shipping updated",
      shipPaymentsEditShipperInvoiceQtySaveError:
        "Could not save. Check quantities and unit prices and try again.",
      shipPaymentsEditShipperInvoiceQtyInvalidNumber:
        "Enter a valid number for every quantity (or leave empty to clear).",
      shipPaymentsEditShipperInvoiceQtyInvalidTitle: "Check quantities",
      shipCollectionsEditInvoiceUnitQtyButton: "Set invoice quantities",
      shipCollectionsEditInvoiceUnitQtyTitle: "Client invoice quantities (product / price)",
      shipCollectionsEditInvoiceUnitQtyHint:
        "Enter the quantity or net weight for each line in «product / price» (client invoice). Saving updates the shipping and recalculates the invoice total. The reference column shows the same field from the linked proforma for the matching product.",
      shipCollectionsEditInvoiceUnitQtyProduct: "Product",
      shipCollectionsEditInvoiceUnitQtyProformaQty: "Quantity or Net weight (proforma)",
      shipCollectionsEditInvoiceUnitQtyLabel: "Quantity or Net weight (invoice)",
      shipCollectionsEditInvoiceUnitQtyEmpty:
        "This shipping has no lines in product / price yet. Add them on the shipping record, then you can set quantities here.",
      shipCollectionsEditInvoiceUnitQtyLoadError: "Could not load the shipping.",
      shipCollectionsEditInvoiceUnitQtySave: "Save to shipping",
      shipCollectionsEditInvoiceUnitQtySaved: "Shipping updated",
      shipCollectionsEditInvoiceUnitQtySaveError:
        "Could not save. Check quantities and try again.",
      shipCollectionsEditInvoiceUnitQtyInvalidNumber:
        "Enter a valid number for every quantity (or leave empty to clear).",
      shipCollectionsEditInvoiceUnitQtyInvalidTitle: "Check quantities",
      shipTimelineProformSupplier: "Proform supplier",
      shipTimelineClientInvoice: "Client invoice",
      shipTimelineInvoice: "Invoice",
      shipTimelinePackingList: "Packing list",
      shipTimelineInvoiceSupplier: "Invoice supplier",
      shipCollectionsAutoloadPackingListTitle: "Packing list from invoice quantities",
      shipCollectionsAutoloadPackingListHint:
        "Edit the packing-list product fields shown in the table, then save to update the shipping.",
      shipCollectionsAutoloadPackingListColLine: "Line",
      shipCollectionsAutoloadPackingListColQuantity: "Quantity or Cartoons",
      shipCollectionsAutoloadPackingListColNetweight: "Net weight",
      shipCollectionsAutoloadPackingListSaved: "Packing list saved",
      shipCollectionsAutoloadPackingListLoadError:
        "Could not load shipping or build packing list. Check client invoice lines on this shipping and try again.",
      shipCollectionsAutoloadPackingListSaveError:
        "Could not save packing list. Check fields and try again.",
      shipCollectionsAutoloadPackingListEmpty:
        "No packing lines were generated (missing «product / price» blocks or preload returned empty).",
      shipPaymentsAutoloadExpensesButton: "Autoload expenses",
      shipPaymentsAutoloadExpensesTitle: "Autoload shipping expenses",
      shipPaymentsAutoloadExpensesHint:
        "These lines are generated like the shipping «Autoload expenses» action. Set an amount for each line you want to create, remove any you are not ready to book yet (for example if freight is still unknown), then save.",
      shipPaymentsAutoloadExpensesType: "Type",
      shipPaymentsAutoloadExpensesAmount: "Amount",
      shipPaymentsAutoloadExpensesContact: "Contact",
      shipPaymentsAutoloadExpensesNewBadge: "New",
      shipPaymentsAutoloadExpensesRemove: "Remove this line",
      shipPaymentsAutoloadExpensesSave: "Save to shipping",
      shipPaymentsAutoloadExpensesSaved: "Shipping expenses updated",
      shipPaymentsAutoloadExpensesLoadError:
        "Could not load or preload expenses for this shipping.",
      shipPaymentsAutoloadExpensesSaveError:
        "Could not save expenses. Check amounts and try again.",
      shipPaymentsAutoloadExpensesEmpty:
        "Nothing new to suggest: every autoload expense type already exists on this shipping, or totals/fields required for autoload are missing.",
      shipPaymentsAutoloadExpensesInvalidNumber:
        "Enter a valid amount for each line you keep (or clear the amount and remove the row).",
      shipPaymentsAutoloadExpensesInvalidTitle: "Check amounts",
      shipPaymentsAutoloadExpensesAddLine: "Add expense line",
      shipPaymentsAutoloadExpensesPickType: "Choose type…",
      shipPaymentsAutoloadExpensesMissingType:
        "Choose an expense type for each new line that has an amount.",
      shipPaymentsExpensesCaption: "Expenses (supplier & other costs)",
      shipPaymentsExpenseSupplierInvoice: "Supplier invoice",
      shipPaymentsExpenseSupplierInvoiceSplit: "Supplier invoice (divided)",
      shipPaymentsSupplierExpenseTrashHint:
        "This supplier invoice expense is in trash (soft-deleted). Restore it to request payments.",
      shipPaymentsSupplierExpenseInTrashLabel: "In trash",
      shipPaymentsViewShippingExpense: "View shipping expense",
      shipPaymentsExpenseDueShort: "Due",
      /** Fila compacta (junto a Due / Pending) en tarjeta de gasto embarque */
      shipPaymentsExpensePaidRowShort: "Paid / req.",

      shipPaymentsExpensePendingShort: "Pending",
      shipPaymentsExpenseCoveredAwaitingBankHint:
        "Covered by a request: use Pay on the linked payment (red). Do not Request payment again.",
      /** Mismo pago aplicado más de una vez al gasto: el número de arriba queda inflado. */
      shipPaymentsExpenseDuplicatedAppliedHint:
        "Duplicate entry: \"Paid / req.\" is counting {amount} twice. The same payment is linked to this expense more than once (marked ×2 below). Open that payment and delete the repeated \"Applied to\" line.",
      shipPaymentsPillDuplicatedBadgeHint:
        "This payment is linked to the expense {times} times. Open it and delete the repeated \"Applied to\" line.",
      shipPaymentsRequestPaymentButton: "Request payment",
      shipPaymentsPayNowButton: "Pay",
      shipPaymentsDividePaymentButton: "Divide payment",
      editShippingExpense: "Edit shipping expense",
      editShippingExpenseModalTitle: "Shipping expense",
      editShippingExpenseAmountLockedHint:
        "Amount cannot be lower than the total already applied in linked payments.",
      editShippingExpenseAmountFollowsPaymentHint:
        "The automatic payment of this expense is updated to the new amount.",
      editShippingExpenseDeleteBlockedHint:
        "This expense cannot be deleted while it has linked payments.",
      editShippingExpenseLoadError: "Could not load the expense.",
      editShippingExpenseInvalidAmount: "Enter a valid amount (0 or greater).",
      shipPaymentsProgressCaption: "Paid & requested / total",
      shipPaymentsProgressAriaGroup:
        "Payment progress: paid vs requested pending",
      shipPaymentsProgressLegendPaid: "Paid (marked paid)",
      shipPaymentsProgressLegendRequested: "Requested (not paid yet)",

      shipPaymentsNoBalance:
        "No balance row for this shipping yet — refresh the financial summary or open the shipping record.",
      shipAdvanceMetaCaption: "Target (this shipping)",
      shipAdvanceAssignedLabel: "Applied on collects (proforma + shipping)",
      shipStage2InvoiceBlockTitle: "Shipping invoice",
      shipInvoiceMetaCaption: "Balance (this invoice)",
      shipInvoiceTotalExpected: "{amount} — invoice total (this shipping)",
      shipInvoiceNotesCreditLine: "− {amount} credit notes",
      shipInvoiceNotesDebitLine: "+ {amount} debit notes",
      shipProformNotesCreditLine: "− {amount} proforma credit notes",
      shipProformNotesDebitLine: "+ {amount} proforma debit notes",
      shipInvoiceNetToCollect: "{amount} to collect",
      shipInvoiceDueNetHint:
        "Invoice total {total}, adjusted by the commercial notes applied to this shipping.",
      shipInvoiceCollectedCaption: "Collected (shipping invoice only)",

      shipExpectedAdvanceAfterPct:
        " advance on the proforma · by containers, {amount} falls to this shipping",

      noShippingsYet: "No shippings — stage 2 will list each shipping here.",
      noShippingsYetZeroProformContainers:
        "This proforma has no total container quantity (or it is zero). Set it on the proforma first; then Add shipping and Quick shipping appear here when there is capacity to assign.",
      missingShippingPlaceholderTitle:
        "Containers not fully assigned to shippings",
      missingShippingPlaceholderBody:
        "{remaining} container(s) still need a shipping.\nAdd a shipping or change container quantities so they match.",
      missingShippingContainersCaption:
        "{shipped} of {total} containers on shippings",
      addShippingButton: "Add shipping",
      openCollectNewTab: "Open collect in new tab",
      openShippingNewTab: "Open shipping in new tab",
      openNotaComercialNewTab: "Open commercial note in new tab",
      quickEditCollectTitle: "Edit collect",
      quickEditCollectHint: "Adjust amount on this assignment, date, received, bank account, comment or receipt.",
      quickEditCollectLineAmountLabel: "Amount (this assignment)",
      quickEditCollectDateLabel: "Collection date",
      quickEditCollectBankPlaceholder: "—",
      quickEditCollectLoadFailed: "Could not load the collect.",
      quickEditCollectDeleteConfirmTitle: "Delete this collect?",
      quickEditCollectDeleteConfirmText:
        "The collect will be permanently deleted and unlinked from this proforma/shipping.",
      quickEditCollectDeleteSuccessTitle: "Collect deleted",
      quickEditCollectDeleteSuccessText: "The collect was removed.",
      quickEditCollectDeleteBlockedTitle: "Cannot delete",
      quickEditCollectDeleteBlockedText: "Mark the collect as not received first, or delete it from the full collect screen.",
      quickEditCollectSaveSuccessTitle: "Collect updated",
      quickEditCollectSaveSuccessText: "Changes were saved.",
      stage2AddCollectAdvanceHint:
        "Register a collect for advance on this shipping",
      stage2AddCollectInvoiceHint:
        "Register a collect for shipping invoice (direct)",
      stage2AdvanceCollectBlockedTitle: "Proforma advance already collected",
      stage2AdvanceCollectBlocked:
        "There is no remaining advance on the proforma to assign with a new collect. To move amounts to this shipping, drag a collect chip from stage 1 onto this shipping card.",
      stage2ShippingAdvanceAlreadyCollectedTitle:
        "Advance for this shipping already collected",
      stage2ShippingAdvanceAlreadyCollectedText:
        "The expected advance for this shipping invoice is already applied on collects (proforma + shipping). There is no remaining amount to register another advance collect here.",
      stage2InvoiceNeedsAdvanceTitle: "Assign advance on this shipping first",
      stage2InvoiceNeedsAdvanceText:
        "Before registering a shipping invoice (direct) collect, the expected advance for this shipping must be assigned on this card (Advance on this shipping). Expected {expected}, assigned so far {assigned}. Use + in that section or drag from stage 1.",
      stage2InvoiceTotalMissingTitle: "Shipping invoice total missing",
      stage2InvoiceTotalMissingText:
        "Enter the shipping invoice information so the total can be calculated.",
      shipPaymentsSupplierInvoiceTotalMissingText:
        "Enter the supplier invoice information so the total can be calculated.",
      dragChipsHint:
        "Collections on proforma — drag to a shipping to allocate part of the advance",
      stage1AllocatedAdvanceCaption:
        "Collects behind this advance, already allocated to a shipping (move them from stage 2)",
      stage1AllocatedAdvanceShipHint: "Allocated to shipping {name}",
      sendRowToProformHint: "Send this collect to the proforma (stage 1)",
      sendRowToProformAlreadyTitle: "It is already part of the proforma",
      sendRowToProformAlreadyText:
        "This collect is applied to the proforma and to this shipping: it already counts toward the stage-1 advance. To take it off the shipping, drag it to the «Drop here to move allocated advance back to proforma-only» zone in stage 1.",
      shipInvoiceProductsHint: "Products on this shipping's invoice",
      shipPortOfLoading: "Port of loading",
      shipPortOfDischarge: "Port of discharge",
      containerMismatchTitle: "Container counts don't match",
      containerMismatchBody:
        "The proforma says {proform} container(s) and its shippings add up to {sum}. The advance expected on each shipping is split by containers, so this throws off the whole operation.",
      containerMismatchDetailCaption: "Containers per shipping",
      containerMismatchFixNote:
        "«Fix» sets the proforma's container quantity to {sum}. The shippings are left untouched.",
      containerMismatchFix: "Fix",
      containerMismatchLater: "Later",
      containerMismatchFixedTitle: "Proforma updated",
      containerMismatchFixedText: "The proforma now has {sum} container(s).",
      containerMismatchFixError: "The proforma's container quantity could not be saved.",
      advanceShortMoneyOnInvoicesTitle: "The money is already collected",
      advanceShortMoneyOnInvoicesBody:
        "{missing} of advance is missing, but this operation already has {onInvoices} collected against the shippings' invoices. It is the same money, applied to the invoice instead of the advance: there is nothing to collect again and no collect to delete.",
      reorderCollects: "Reorder collects",
      reorderCollectsHint:
        "Moves that money onto the advance of the shippings that still have room. No collect is deleted and no amount changes.",
      moveInvoiceMoneyToAdvanceTitle: "Reorder collects",
      moveInvoiceMoneyToAdvanceIntro:
        "{total} moves from the shippings' invoices to the advance. No collect is deleted and no amount changes — only what each one is applied to:",
      moveInvoiceMoneyToAdvanceConfirm: "Reorder",
      moveInvoiceMoneyToAdvanceOk: "{amount} moved to the advance.",
      dropReturnProform:
        "Drop here to move allocated advance back to proforma-only",
      proformPocket: "Proforma (stage 1)",
      redistributeTitle: "Redistribute amount",
      redistributeNoRoomOnShip:
        "No remaining advance capacity on this shipping vs. the expected target.",
      redistributeNoRoomOnShipInvoice:
        "In the shipping-invoice drop zone there is no capacity left vs. invoice pending (and available advance). Drop on the advance block if you only want the advance target.",
      redistributeToShipHtml:
        "Move to <strong>{ship}</strong>. Max <strong>{max}</strong>.",
      redistributeToShipInvoiceOnlyHtml:
        "Allocate to <strong>{ship}</strong> as <strong>shipping-invoice only</strong> (no proforma on the applied line). Invoice pending: {pending}. Max to move: <strong>{max}</strong>.",
      redistributeToProformHtml:
        "Return to proforma-only pool. Max <strong>{max}</strong>.",
      redistributeReturnToProformBlockedAdvanceComplete:
        "Stage-1 advance is already fully collected for this proforma. You cannot move allocation back to the proforma-only pocket.",
      redistributeNoRoomNoChange:
        "No room in the proforma-only pocket; the collect remains on the shipping line (no changes).",
      redistributeNoRoomReasonNoAdvanceExpected:
        "This proforma has no stage-1 advance expected; nothing can be moved to the proforma-only pocket.",
      redistributeNoRoomReasonPocketFull:
        "The proforma-only pocket is already full for the expected advance; nothing more can be moved from the shipping line.",
      redistributeNoRoomReasonStage1Cap:
        "Stage-1 advance is already fully collected; this shipping-only collect cannot be moved to the proforma pocket.",
      redistributeToProformRemainderNote:
        "If the line is larger, only this portion moves to the proforma pocket; the remainder stays on the shipping line.",
      redistributeCappedToProformaPocketToast:
        "Only the amount that fits the proforma-only pocket was applied: {moved}. The rest remains on the shipping line.",
      observationsTitle: "Observations",
      observationsPlaceholder: "Notes for this operation (saved automatically)",
      observationsSaving: "saving…",
      observationsSaved: "saved",
      observationsError: "could not save",
      containerNumbersHint: "Container numbers loaded in the packing list of this shipping.",
      flagsTitle: "Operation flags",
      flagsPlaceholder: "Add flags…",
      flagsTagPlaceholder: "Press enter to create this flag",
      flagsNoOptions: "No flags in the catalog yet",
      flagsSaving: "saving…",
      flagsCreateOption: "Add new flag…",
      flagsManageLists: "Manage lists",
      flagsManageListsHint:
        "Open the lists page to rename a flag, change its colour or delete it.",
      flagColorTitle: "Colour of “{name}”",
      flagColorHint:
        "The colour belongs to the flag: it changes everywhere this flag is shown.",
      flagColorApply: "Apply colour",
      flagColorHintOnBadge: "Click the flag to change its colour",
      flagCreateTitle: "New flag",
      flagCreateNameLabel: "Flag name",
      flagCreateApply: "Create flag",
      flagCreateNameRequired: "Enter a name for the flag",
      flagCreateNameExists: "A flag with that name already exists",
      flagsHint:
        "Tag this operation with a flag from the catalog (the same ones used by the list flag column) or create a new one.",
      flagNone: "No flag assigned",
      flagAssign: "Assign flag",
      flagChange: "Change flag",
      redistributeSplitHint:
        "The collect ({total}) is larger than the advance still expected on {ship} ({advanceMax}). You can allocate the excess to that shipping's invoice balance (pending {pending}).",
      redistributeSplitUnappliedNote:
        "Includes {amount} of this collect that was not applied anywhere yet.",
      redistributeSplitAdvanceLabel: "To the shipping advance (max {max})",
      redistributeSplitAdvanceFull:
        "The advance on this shipping is already complete: the whole amount goes to the invoice balance.",
      redistributeSplitRemainderCheckbox:
        "Allocate the excess to {ship}'s invoice balance",
      redistributeSplitRemainderLabel: "Excess to invoice balance (max {max})",
      redistributeSplitRemainderTooMuch: "The excess cannot exceed {max}",
      redistributeSplitOk:
        "Allocation updated: {advance} to the advance and {remainder} to the shipping balance.",
      redistributeConfirm: "Apply",
      redistributeInvalid: "Enter a valid amount",
      redistributeTooMuch: "Cannot exceed {max}",
      redistributeOk: "Allocation updated",
      redistributeError: "Could not update allocation",
      quickCollectRemaining: "Quick collect",
      quickCollectRemainingHint:
        "Opens the collect form with optional container amount shortcuts (stage 1). Use «Add collection» for the compact form without those helpers.",
    },
    messages: {
      noPaymentCondition:
        "⚠️ <strong>No payment condition configured.</strong> This proform doesn't have an advance percentage set.",
      noPaymentConditionDetails:
        "Configure a payment condition to track advance payments properly.",
      missingCurrencyRate:
        "This operation has amounts in more than one currency and there is no exchange rate for {currency}. Until it is loaded in Settings, the margin stays empty: amounts in different currencies cannot be compared.",
      advancePending:
        "💰 <strong>Advance payment pending:</strong> {percentage}% advance ({amount}) needs to be collected.",
      advancePendingDetails:
        "No collections have been registered yet for this proform.",
      advancePartial:
        "⏳ <strong>Partial advance collected:</strong> {collected} of {expected} ({percentage}% complete). <strong>{remaining} remaining.</strong>",
      advancePartialDetails: "{count} collection(s) registered.",
      advanceComplete:
        "✅ <strong>Advance fully collected:</strong> The advance was <strong>{percentage}%</strong> of the proform total (target <strong>{expected}</strong>); <strong>{amount}</strong> is recorded in collections.",
      advanceCompleteDetails: "{count} collection(s) registered.",
      shippingInvoicesPendingAfterAdvance:
        "📄 <strong>Shipping invoice(s):</strong> {total} still to collect across {count} shipping(s) (after proforma advance share and applicable credit notes).",
      hasShippings: "🚢 <strong>This proform has {count} shipping(s).</strong>",
      hasShippingsDetails:
        "The advance ({advancePerShipping} per shipping) will be deducted when collecting each shipping.",
      readyForShipping:
        "📦 <strong>Ready for shipping:</strong> The advance has been collected.",
      readyForShippingDetails: "You can now create shippings for this proform.",
    },
    actions: {
      configure: "Configure",
      addCollection: "Add Collection",
      addCommercialNote: "Add commercial note",
      notaComercialNoPendingTitle: "Cannot add commercial note",
      notaComercialNoPendingText:
        "There is no amount left to collect on this operation. Commercial notes are used to adjust what is still outstanding; if everything is already collected, you cannot add one from here.",

      receivePayment: "Add Collection",

      addShippingShipper: "Quick shipping",
    },
    // Modal messages
    collectionCreatedSuccessfully: "Collection created successfully",
    failedToOpenCollectionModal: "Failed to open collection modal",
    failedToOpenAddShippingModal: "Could not open add shipping form.",
    shippingCreatedFromProformOk: "Shipping saved. Refreshing data…",
    failedToSaveShipping: "Could not save shipping.",
    quickAddShippingShipperTitle: "New shipping — shipper & containers",
    quickAddShippingShipperHint:
      "Creates a shipping linked to this proforma. Other fields are prefilled from mapping / defaults; set the shipper and how many containers this shipping uses (quantity only). Positions for the title field «Containers involved» (e.g. 1,2) are taken as the next free slots on this proforma, not 1…N from the quantity alone. If invoice lines are shown, each line’s container qty must sum to that total (or use «Match shipping total»).",
    quickAddShippingShipperFieldLabel: "Shipper",
    quickAddShippingQtyContainersLabel: "Container count",
    quickAddShippingContainersFieldLabel: "Containers involved (positions)",
    quickAddShippingContainersCsvInvalidTitle: "Invalid container positions",
    quickAddShippingContainersCsvInvalidText:
      "Use free slot numbers on this proforma (1–{total}), separated by commas, no duplicates. The count must match the container count ({qty}).",
    quickAddShippingQtyContainersInvalidTitle: "Invalid container count",
    quickAddShippingQtyContainersInvalidText:
      "Enter a whole number of containers (1 or more).",
    quickAddShippingContainersNotEnoughTitle: "Not enough free container slots",
    quickAddShippingContainersNotEnoughText:
      "This shipping needs {needed} container slot(s) on the proforma, but only {free} are still free (of {total}). Add slots on the proforma or adjust existing shippings.",
    quickAddShippingInvoiceLinesTitle: "Invoice lines (containers per line)",
    quickAddShippingInvoiceLinesHint:
      "Each line’s «containers» must add up to the shipping’s container count above. Adjust manually or use auto-split.",
    quickAddShippingInvoiceLineQtyLabel: "Qty",
    quickAddShippingInvoiceLinesAutoSplit: "Match shipping total",
    quickAddShippingInvoiceLinesSum:
      "Sum of line quantities: {sum} — shipping: {ship}",
    quickAddShippingInvoiceLinesMismatch: "Totals must match before saving.",
    quickAddShippingInvoiceLinesInvalidTitle: "Invoice lines vs shipping",
    quickAddShippingInvoiceLinesInvalidText:
      "The sum of containers in invoice lines ({sum}) must equal the shipping container count ({ship}).",
    quickAddShippingInvoiceLineDefault: "Line {n}",

    quickAddShippingInvoiceLineProductsCount: "{count} products in this line",
    quickAddGenericRequiredTitle: "Required field",
    quickAddGenericRequiredText:
      "Complete the highlighted required field before saving.",
    quickAddCollectTitle: "Register collection",
    quickAddCollectHint:
      "Amount, applications and other fields come from context (proforma/shipping). Only set destination bank account, comment, and file if needed.",
    quickAddCollectHintEditable:
      "Enter the amount to collect, destination bank account, and optionally comment or file. If the amount is above the pending amount, the excess stays unapplied, as a credit for the contact.",
    quickAddCollectAmountLabel: "Amount to collect",
    quickAddCollectAmountInvalidTitle: "Invalid amount",
    quickAddCollectAmountInvalidText: "Enter an amount greater than zero.",
    quickAddCollectAmountTooMuchTitle: "Amount above pending",
    quickAddCollectAmountTooMuchText:
      "The collect ({amount}) is above the pending collectible amount ({max}). If you save anyway, it is applied up to the pending amount and {excess} stays unapplied, as a credit for the contact.",
    quickAddCollectAmountTooMuchMultipleShipsText:
      "Cannot exceed pending advance on stage 1 ({max}). With more than one shipping, assign the rest on stage 2.",
    quickAddCollectAmountTooMuchCombinedText:
      "Cannot exceed {max} (stage 1 advance, shipping advance, and invoice balance on {ship}).",
    quickAddCollectUnallocatedRemainder:
      "{amount} of this collect was not applied to this proforma (available for other proformas or shippings).",
    quickAddCollectUnallocatedToContact:
      "{amount} of this collect stayed unapplied, as a credit for the contact.",
    quickAddCollectMissingFields:
      "Could not load collect fields. Try again or use the full form from the model.",
    quickAddCollectBankAccountLabel: "Bank account ({tenant})",
    quickAddCollectBankRequiredTitle: "Bank account required",
    quickAddCollectBankRequiredText:
      "Select the destination bank account for this collection.",
    quickAddCollectFileRequiredDuntowerTitle: "Receipt file missing",
    quickAddCollectFileRequiredDuntowerText:
      "You should attach the receipt file before saving this collection.",
    quickAddCollectFileRequiredDuntowerSaveAnyway: "Save anyway",
    quickAddCollectAppliedtoRounding: "Rounding (applied to line)",
    quickAddCollectAppliedtoCommission: "Bank commission (applied to line)",
    quickAddCollectAmountPlusRoundingTotal: "Total (amount + rounding)",
    quickAddCollectSave: "Save",

    quickAddCollectInfoTitle: "Information",
    quickAddCollectUnderstood: "OK",
    quickAddCollectHintWithCalc:
      "Choose containers per line—the amount updates automatically. Then pick the bank account and save.",
    quickAddCollectCalcCompactTitle: "Containers",

    quickAddCollectCalcBadgePerC: "Per ct.",
    quickAddCollectCalcBadgeLine: "Line total",
    quickAddCollectCalcModePerCTooltip:
      "Price is per container: line total = unit price × number of containers on this line.",
    quickAddCollectCalcModeLineTooltip:
      "Price is for the whole line: each container’s share = line total ÷ containers.",
    quickAddCollectCalcLineSub: "{each}/ctn · max {max}",
    quickAddCollectCalcCapShort: "Capped at pending balance ({max}) if needed.",
    quickAddCollectCalcCapHintAdvancePct:
      "Collect amount = {pct}% of the selected invoice subtotal (containers). It cannot exceed the pending collectible amount ({max}).",
    quickAddCollectCalcCappedByBalance:
      "Selected lines add up to {selected}, which is above the pending balance; the collect amount stays at {cap}.",
    quickAddCollectCalcCappedAdvancePool:
      "Advance at {pct}% on {invoice} equals {advance}, which is more than the remaining advance; this collect is limited to {cap}.",
    quickAddCollectCalcAdvanceBreakdown:
      "{pct}% × invoice subtotal {invoice} = {amount}.",
    quickAddCollectCalcNoPicksUsesPending:
      "No containers selected yet — amount matches the full pending balance. Pick lines to align the collect with invoice containers.",
    quickAddCollectCalcNoPicksUsesPendingAdvance:
      "No containers selected — amount is the full remaining advance. When you pick containers, the amount becomes {pct}% of that invoice subtotal (still capped by what is left).",
    failedToSaveCollection: "Failed to save collection",
    quickRequestPaymentTitle: "Request payment (expense)",
    quickPayExpenseTitle: "Pay expense",
    quickPaymentAppliedToTitle: "Applied to",
    quickPaymentAppliedToUnnamed: "Expense",
    quickPayExpenseAmountLabel: "Amount to pay",
    quickPayExpenseHint:
      "The payment is saved as already paid: there is no request step to confirm later.",
    quickPayExpenseSave: "Pay",
    quickPayExpenseSuccess: "Payment registered",
    quickPayExpenseDateRequiredTitle: "Payment date required",
    quickPayExpenseDateRequiredText: "Enter the date the expense was paid.",
    quickRequestPaymentHint:
      "The payment is created for this expense only. Applied amount (payment_appliedto) follows the amount you enter. Choose the bank account and optional comment.",
    quickRequestPaymentAmountLabel: "Amount to request",
    quickRequestPaymentBankLabel: "Bank account (from)",
    quickRequestPaymentCommentLabel: "Comment",
    quickRequestPaymentBankRequiredTitle: "Bank account required",
    quickRequestPaymentBankRequiredText:
      "Select the bank account for this payment request.",
    quickRequestPaymentSave: "Save",
    quickRequestPaymentMissingFields:
      "Could not load payment fields. Try again or open the full payment form.",
    quickRequestPaymentOpenFailed: "Could not open the quick payment form.",
    quickRequestPaymentAmountInvalidTitle: "Invalid amount",
    quickRequestPaymentAmountInvalidText: "Enter an amount greater than zero.",
    quickRequestPaymentAmountTooMuchTitle: "Amount too high",
    quickRequestPaymentAmountTooMuchText:
      "Cannot exceed pending for this expense ({max}).",
    quickRequestPaymentSplitContactRequiredTitle: "Contact required",
    quickRequestPaymentSplitContactRequiredText:
      "Choose the contact for the divided supplier expense.",
    quickRequestPaymentSplitSourceMissing:
      "Could not load the source supplier expense to divide the payment.",
    quickRequestPaymentSplitParentMissing:
      "Could not resolve the shipping for the divided supplier expense.",
    quickRequestPaymentSplitCreateExpenseFailed:
      "Could not create the divided supplier expense.",
    quickRequestPaymentSplitSourceAmountInvalid:
      "Source supplier expense has an invalid amount to divide.",
    quickRequestPaymentSplitAmountTooHigh:
      "Divide amount cannot be higher than the source supplier expense amount.",
    // Collection details modal
    viewCollections: "View collections",
    viewShipping: "View shipping",
    collectionDetails: "Collection Details",
    collectedAmount: "Collected Amount",
    collections: "Collections",
    name: "Name",
    amount: "Amount",
    status: "Status",
    date: "Date",
    actionsColumn: "Actions",
    received: "Received",
    viewDetails: "View details",
    noCollections: "No collections found",
    fobNotaComercial: {
      addSupplierNote: "Supplier note",
      addSupplierNoteHint:
        "Create a commercial note from this expense's supplier, with its role and currency already filled in.",
      addSupplierNoteFailed: "Could not open the commercial note for this expense.",
      notaComercialButton: "Commercial note",
      notaComercialButtonShipping: "Commercial note (shipping)",
      modalTitle: "Commercial note",
      variantLabel: "Note type",
      optionCreditoCliente: "Credit note to client",
      optionDebitoCliente: "Debit note to client",
      optionCreditoProveedor: "Supplier credit to us",
      optionDebitoProveedor: "Supplier debit to us",
      amountLabel: "Amount",
      dateLabel: "Date",
      currencyLabel: "Currency",
      appliedToShippingHint: "Applied to shipping: {name}",
      appliedToProformHint: "Applied to proforma: {name}",
      save: "Save",
      saving: "Saving…",
      cancel: "Cancel",
      successTitle: "Commercial note created",
      successText: "The note was saved.",
      errorTitle: "Could not create the note",
      needClient: "This operation has no client contact assigned.",
      needSupplier: "This shipping has no supplier contact.",
      needShipping: "Add at least one shipping to apply the note.",
      needProform: "The proforma could not be resolved to apply the note.",
      needAmount: "Enter a valid amount greater than zero.",
      needCurrencyLists: "Currency list could not be loaded. Try again or reload the page.",
      editCommercialNote: "Edit credit note",
      editModalTitle: "Edit credit note",
      editHintProform: "Amount applied to this proforma ({name}).",
      editHintShipping: "Amount applied to this shipping invoice.",
      editLoadFailed: "Could not load the note.",
      editSuccessTitle: "Note updated",
      editSuccessText: "Changes were saved.",
      dragApplyNoLines: "This note has no amount applied only to this proforma anymore.",
      dragReturnNoLines: "No amount for this shipping could be moved back to the proforma.",
      deleteButton: "Delete",
      deleteConfirmTitle: "Delete this note?",
      deleteConfirmText:
        "The commercial note will be permanently deleted and unlinked from balances.",
      deleteSuccessTitle: "Note deleted",
      deleteSuccessText: "The commercial note was removed.",
    },
    errorLoadingCollectionDetails: "Error loading collection details",
    // Payment details modal
    viewPayments: "View payments",
    paymentDetails: "Payment Details",
    totalToPay: "Total To Pay",
    errorLoadingPaymentDetails: "Error loading payment details",
    // Cash flow modal
    viewCashFlow: "View cash flow details",
    cashFlowDetails: "Cash Flow Details",
    collectionsIncome: "Collections (Income)",
    paymentsExpenses: "Payments (Expenses)",
    totalCollected: "Total Collected",
    totalPaid: "Total Paid",
    noPayments: "No payments found",
    errorLoadingCashFlow: "Error loading cash flow details",
    // Receipt modal
    viewReceipt: "View receipt",

    // Additional shipping-specific translations
    shippingPending: "Shipping pending collection",
    toCollect: "to collect",
    shippingPendingDetails:
      "No collections have been registered yet for this shipping.",
    shippingPartial: "Partial collection",
    of: "of",
    remaining: "remaining",
    shippingComplete: "Shipping fully collected",
    collectionsRegistered: "collection(s) registered",
    help: {
      advanceTitle: "Advance Payment",
      advanceDescription:
        "The advance is a percentage of the total proform that the client pays before the shipping is dispatched. It's configured through the 'Payment Condition' field.",
      calculationTitle: "How it's calculated",
      calculationDescription:
        "Expected Advance = Total Proform × Advance Percentage. For example, if the proform is $10,000 and the advance is 30%, the expected advance is $3,000.",
      shippingTitle: "Shippings and Advances",
      shippingDescription:
        "When you collect from a shipping, the system automatically deducts the proportional advance already paid. If the proform has 2 shippings and $3,000 was paid as advance, each shipping deducts $1,500.",
      exampleTitle: "Practical Example",
      example1: "Proform: $10,000 with 30% advance",
      example2: "Expected advance: $3,000 (collected before shipping)",
      example3:
        "When collecting shipping: Total shipping - ($3,000 ÷ number of shippings)",
    },
    // Payments section (for shippings)
    payments: {
      title: "Payments Summary",
      allGood: "All payments are up to date",
      supplierTotal: "Supplier Total",
      total: "Total",
      requested: "Requested",
      debitNotes: "debit notes",
      expectedAdvance: "Expected Advance",
      paid: "Paid",
      pending: "Pending",
      notes: "Notes",
      totalExpenses: "Total Expenses",
      expensesPaid: "Expenses Paid",
      expensesPending: "Expenses Pending",
      addPayment: "Request Payment",
      completePayment: "Request Payment",
      requestAdvance: "Request {percentage}%",
      requestFull: "Request 100%",
      requestRemaining: "Complete Advance",
      requestBalance: "Request Balance",
      paymentCreatedSuccessfully: "Payment created successfully",
      failedToOpenPaymentModal: "Failed to open payment form",
      failedToSavePayment: "Failed to save payment",
      advancePending:
        "🚚 <strong>Supplier advance pending:</strong> {percentage}% ({amount}) must be paid to the supplier before shipping.",
      advancePendingDetails:
        "Register the advance payment to the supplier/shipper.",
      advancePartial:
        "⏳ <strong>Partial advance paid:</strong> {paid} of {expected} ({percentage}%). <strong>{remaining} remaining</strong>",
      advancePartialDetails: "Complete the advance payment to the supplier.",
      advanceComplete:
        "✅ <strong>Supplier advance complete:</strong> {amount} paid",
      advanceCompleteDetails:
        "The advance payment to the supplier has been completed.",
      balancePending: "Balance pending: {amount} remaining to request.",
      balanceRequested:
        "Balance of {amount} requested. Awaiting payment confirmation.",
      requestAlreadySent:
        "A payment request already covers this amount. Open the linked payment and use Pay (do not Request payment again).",
      actionDisabledNoPermission:
        "You do not have permission to register supplier payments (finance.payments or finance.manage).",
      actionDisabledNoCollectPermission:
        "You do not have permission to register collections (finance.collects or finance.manage).",
      balanceAwaitingHint:
        "The balance was already requested; open the linked payment and use Pay to mark it paid at the bank.",
      summaryPreparing: "Loading payment summary…",
      emptySummaryTitle: "No supplier or expense payment lines yet",
      emptySummaryDetailsNoExpenses:
        "There is no supplier invoice amount to pay on this shipping yet, and no shipping expenses have been registered. Add amounts in Expenses (and ensure the operation has supplier totals) so payment requests can appear here.",
      emptySummaryDetailsGeneric:
        "There is nothing to show in this summary yet. When the operation has supplier amounts or expense lines with amounts, they will appear here.",
      summaryLoadError: "Could not load payment summary",
      summaryLoadErrorDetails:
        "Check your connection and try refreshing. If it continues, contact support.",
      supplierInvoicePending:
        "🚚 <strong>Supplier invoice pending:</strong> {amount} must be paid to the supplier.",
      supplierInvoicePendingDetails:
        "Register the payment to the supplier/shipper.",
      supplierInvoiceNoAmount:
        "🚚 <strong>Supplier invoice:</strong> no amount yet.",
      supplierInvoiceNoAmountDetails:
        "Load the supplier's prices to request payments. Their commercial notes can already be assigned.",
      supplierInvoicePartial:
        "⏳ <strong>Partial supplier payment:</strong> {paid} of {total} ({percentage}%). <strong>{remaining} remaining</strong>",
      supplierInvoiceComplete:
        "✅ <strong>Supplier invoice complete:</strong> {amount} paid",
      expensesPendingMsg:
        "📋 <strong>Pending expenses:</strong> {amount} in shipping expenses to pay.",
      expensesPendingDetails: "Register payments for the shipping expenses.",
      expensesPartial:
        "⏳ <strong>Partial expenses paid:</strong> {paid} of {total} ({percentage}%). <strong>{remaining} remaining</strong>",
      expensesComplete: "✅ <strong>Expenses complete:</strong> {amount} paid",
      expense: "Expense",
      toPay: "to pay",
      of: "of",
      remaining: "remaining",
      expenseNotPaidDetails: "This expense has not been paid yet.",
      requested: "requested",
      awaitingPayment:
        "Request sent. Open the linked payment and use Pay to mark it paid at the bank (green = paid; red = pending).",
      paymentLinkPaidHint: "Payment marked as paid at the bank",
      paymentLinkUnpaidHint:
        "Pending request: not marked as paid at the bank yet. Use Pay on this payment.",
      bankPaymentDateForPaymentHint: "Bank payment date: {name}",
      payExpense: "Request",
      completeExpense: "Request",
      totalToPay: "Total To Pay",
      totalPaid: "Total Paid",
      proformaNegotiationFreight: "Negotiation freight {amount}",
    },
    // Operation Balance section
    balance: {
      title: "Operation Balance",
      noData: "Balance data not available",
      concept: "Concept",
      totalAmount: "Total",
      paid: "Paid/Collect",
      pending: "Pending",
      status: "Status",
      complete: "Complete",
      partial: "Partial",
      pendingStatus: "Pending",
      // Client section
      clientSection: "CLIENT (Income)",
      totalInvoice: "Total Invoice",
      // Supplier section
      supplierSection: "SUPPLIER (Expenses)",
      supplierInvoice: "Supplier Invoice",

      costsSubtotal: "Costs Subtotal",
      breakdownAmountTitle: "What adds up to: {concept}",
      breakdownPaidTitle: "Payments for: {concept}",
      breakdownAmountHint: "See which expenses add up to this amount",
      breakdownPaidHint: "See which payments cover this amount",
      breakdownContact: "Contact",
      breakdownRequested: "Requested (not paid)",

      projectedMargin: "Projected Margin",
      realMargin: "Real Margin",
      currentMargin: "Current Margin",
      basedOnProforma: "based on proforma",
      basedOnAllRequests: "based on all expenses",
      basedOnPaidOnly: "only confirmed payments",
      proformaTotal: "Proforma Total",
      totalInvoices: "Total Invoices",
      projected: "Projected",
      invoice: "Invoice",

      advancePortion: "Advance",
      overCollectedStatus: "Over-collected",
      marginHelpAria: "How this margin is calculated",
      marginHelp: {
        clientNotes: "Client commercial notes",
        estimatedCosts: "Estimated costs",
        bankCommissions: "Bank commissions",
        cashIn: "Cash in (applied to this operation)",
        collectedApplied: "Collections applied",
        creditNotes: "Credit notes applied",
        confirmedPaid: "Confirmed payments (paid)",
        supplierPaid: "Supplier paid",
        costsPaid: "Other costs paid",
        projectedIntro:
          "Projected Margin uses the proforma total minus the estimated costs of this operation:",
        projectedNote:
          "Estimated costs include the supplier invoice, other shipping expenses, and bank commissions.",
        realIntro:
          "Real Margin uses the invoice total of this operation minus the same estimated costs:",
        realNote:
          "Same cost base as Projected Margin; only the income side changes from proforma to invoice.",
        currentIntro:
          "Current Margin is the actual cash flow of this operation: money already collected minus payments already marked as paid:",
        currentNote:
          "It does not use pending payment requests or the full invoice total—only confirmed cash movements.",
        fobProjectedIntro:
          "In FOB the Projected Margin starts from the negotiation gross margin and swaps the estimated interest for the operation's:",
        grossMargin: "Negotiation gross margin",
        estimatedInterest: "Estimated interest (negotiation)",
        interestReal: "Real interest (days between payment and collection)",
        interestProjected: "Projected interest (pending amounts as of today)",
        fobProjectedNote:
          "While collections are pending, interest is projected to today and grows each day of delay; with the last collection it becomes the real one.",
        fobRealIntro:
          "In FOB the Real Margin is the Current Margin minus payment requests not yet paid:",
        requestedUnpaid: "Requested unpaid payments",
        fobRealNote: "It is what would be left in cash if everything already requested were paid today.",
        proformPlanIntro:
          "The Projected Margin uses the proforma total minus the expenses entered in the proforma itself:",
        proformPlanCosts: "Proforma expenses",
        proformPlanNote:
          "Proforma expenses are the operation plan: supplier invoice, freight, commissions and other expected costs.",
      },
    },
  },

  // Calendar Tutorial translations
  calendarTutorial: {
    // Welcome step
    calendarWelcome: {
      title: "Welcome to Calendar Tutorial",
      description:
        "I will guide you through the ExportAI calendar functionality and explain the meaning of shipping status colors.",
      details: [
        "You will learn to navigate the monthly calendar",
        "You will understand how events and important dates are displayed",
        "You will know the meaning of each shipping status color",
        "You will know how to interact with calendar days and events",
      ],

      tip: "The calendar is your main tool for visualizing and managing all important dates of your trading operations.",
    },

    // Calendar navigation step
    calendarNavigation: {
      title: "Calendar Navigation",
      description:
        "Navigation buttons allow you to move between months to see events in different periods.",
      details: [
        "Left button: Go back to previous month",
        "Right button: Go forward to next month",
        "Current month and year are displayed in the center",
        "Navigation is instant and maintains your current view",
      ],

      tip: "Use navigation to plan future operations or review past events.",
    },

    // Calendar days step
    calendarDays: {
      title: "Calendar Days",
      description:
        "Each calendar day shows visual information about events and important dates.",
      details: [
        "Current month days are shown on white background",
        "Other months days are shown in gray",
        "Current day is highlighted with a blue border",
        "Days with events have a light blue background",
      ],

      tip: "Days with events are easy to identify by their light blue background.",
    },

    // Event display step
    eventDisplay: {
      title: "Event Display",
      description:
        "Events are shown within each calendar day with relevant information.",
      details: [
        "Each event shows the field and item name",
        "Shipping events show colors according to their status",
        "Proform events are shown in standard blue",
        "You can see multiple events on the same day",
      ],

      tip: "Event colors give you quick information about the state of your operations.",
    },

    // Shipping colors step
    shippingColors: {
      title: "Shipping Status Colors",
      description:
        "Shipping events are shown with specific colors that indicate their priority and state.",
      details: [
        "Gray: No priority (initial state)",
        "Yellow: Pending operation",
        "Orange: Delayed operation",
        "Blue: Departure date reached",
        "Red: Arrival approaching (20 days or less)",
        "Green: In port (final state)",
      ],

      tip: "Colors allow you to quickly identify which operations require immediate attention.",
    },

    // Color meaning step
    colorMeaning: {
      title: "Color Meaning",
      description:
        "Each color represents a specific state calculated automatically by the system.",
      details: [
        "The system automatically calculates status based on dates",
        "Colors change automatically according to operation progress",
        "Green (in port) is the desired final state",
        "Red indicates that arrival is approaching and requires attention",
      ],

      tip: "Keep an eye on red and orange events, as they require immediate action.",
    },

    // Day interaction step
    dayInteraction: {
      title: "Day Interaction",
      description:
        "You can click on any calendar day to see more details of the events.",
      details: [
        "Click on a day with events to see the complete list",
        "If there is only one event, you will go directly to its detail",
        "If there are multiple events, a modal opens with the list",
        "From the modal you can navigate to any event",
      ],

      tip: "Use clicks on days to quickly access detailed information about your operations.",
    },

    // Event details step
    eventDetails: {
      title: "Day Events Panel",
      description:
        "The right panel shows events of the selected day with navigation options.",
      details: [
        "Shows the selected date in readable format",
        "Lists all events of the day with their type and name",
        "Each event has a button to see its complete details",
        "Events are grouped by model (Proform, Shipping)",
      ],

      tip: "This panel gives you a quick view of everything that happens on a specific day.",
    },

    // Completion step
    calendarCompletion: {
      title: "Calendar Tutorial Completed!",
      description:
        "Now you perfectly understand how the calendar works and the shipping color system.",
      details: [
        "Navigation: You know how to move between months and days",
        "Events: You understand how events are displayed and organized",
        "Colors: You know the meaning of each status color",
        "Interaction: You know how to access detailed information",
      ],

      tip: "The calendar is now your main tool for managing and visualizing all your trading operations!",
    },
  },
  // PDF Exporter translations
  pdfExporter: {
    exportToPdf: "Export to PDF",
    customizePdf: "Customize PDF",
    template: "Template",
    fieldsToInclude: "Fields to include",
    preview: "Preview",
    cancel: "Cancel",
    export: "Export",

    errorGeneratingPdf: "Error generating PDF",
  },
  // Tree Edit translations
  treeEdit: {
    dragToMove: "Drag to move",
    elementName: "Element name",
    editElement: "Edit element",
    deleteElement: "Delete this element",

    accountingCode: "Accounting code for journal entries",
    itemColor: "Element color",
    itemColorHint:
      "The color is used as the label background when this element shows up in a list. Leave it unset to show it in grey.",
    noColor: "No color",
    listTranslationsSection: "Translations by language (optional)",
    listTranslationsHint:
      "If you fill a language, users will see that text when the UI is in that language. Leave empty to use the default name above.",
  },
  // Template pages translations
  templatePages: {
    editRecord: "Edit",
    printOrExport: "Print or export",
    openRecord: "View record",
    pdfTextSize: "Print text size",
    pdfTextSizeHint:
      "Smaller text fits more content on one page when printing or saving as PDF from the browser.",

    retry: "Retry",
    reloadVersion: "Reload version",
    generatedAt: "PDF generated",
    generatedAtHint:
      "Date of the version being shown. Reload the version to regenerate it with the current data.",
    popupBlocked:
      "Allow pop-ups for this site to open the print dialog for this view.",
  },
  // AI translations
  ai: {
    analyzing: "Analyzing...",

    analyzeWithAI: "Analysis with AI",
    analysisConfiguration: "Analysis Configuration",
    analysisPrompt: "Analysis Prompt",
    clearResults: "Clear results",
    processing: "Processing...",
    aiAnalysis: "AI Analysis",

    analysisWithAI: "Analysis with AI",
    hereToHelpTooltip: "I'm here to help",

    customPrompts: "Custom prompts",
    customPromptsChatHint:
      "Pick a prompt to load it into the chat. You can edit it before sending.",
    executeWithAiNow: "Run now",
    quickRunFieldset: "Create custom prompt",
    missingItemForChat:
      "No item is loaded; open AI analysis from a record detail page.",
    customPromptLoadedInChat:
      "I loaded the prompt «{name}» in the box below; send when you are ready.",
    deletePrompt: "Delete prompt",

    saveCustomPrompt: "Save Custom Prompt",
    promptName: "Prompt name",

    prompt: "Prompt",

    pleaseSelectAIModel: "Please select an AI model",
    pleaseEnterPrompt: "Please enter a prompt for the analysis",
    errorStartingAnalysis: "Error starting the analysis",
    errorAnalyzingContent: "Error analyzing content",
    errorCheckingStatus: "Error checking status",

    errorGettingResult: "Error getting result",
    analysisFailed: "The analysis failed",
    analysisTimeout: "The analysis took too long and was cancelled",
    errorCheckingAnalysisStatus: "Error checking the analysis status",

    promptSaved: "Prompt saved",
    promptSavedSuccessfully:
      "The custom prompt has been saved successfully and will be available for future analyses.",

    errorSavingCustomPrompt: "Error saving the custom prompt",
    deletePromptQuestion: "Delete prompt?",
    deletePromptConfirmation:
      'Are you sure you want to delete the prompt "{promptName}"? This action cannot be undone.',
    yesDelete: "Yes, delete",
    promptDeleted: "Prompt deleted",
    promptDeletedSuccessfully:
      "The custom prompt has been deleted successfully.",
    errorDeletingPrompt: "Error deleting the prompt",
    errorDeletingCustomPrompt: "Error deleting the custom prompt",
    accept: "Accept",
    yes: "Yes",
    no: "No",
    error: "Error",

    errorLoadingModels: "Error loading models",
    errorLoadingRecords: "Error loading model records",
    errorInAnalysis: "Error in analysis",
    errorCopyingToClipboard: "Error copying to clipboard",
    errorSavingToView: "Error saving to view",

    itemCreateGenerateError: "Could not generate JSON",
    itemCreateApplyError: "Could not create the record",
    itemCreateOriginalPrompt: "Original request",
    itemCreateIntent: "Intent",
    itemCreateCreatedTitle: "Record created",
    itemCreateCreatedBody:
      "Model: {model}. You can open the new record from the detail view.",
    itemCreateCreatedShort: "The record was created.",

    itemModifySpecUserPrompt: "User request (from Analyze with AI):",
    itemModifySpecAiResponse: "AI analysis response:",
    itemModifySpecPending: "Pending clarifications",
    itemModifyFieldsHint: "Suggested fields",

    itemModifyGenerateError: "Could not generate update JSON",
    itemModifyApplyError: "Could not apply changes",
    itemModifySavedTitle: "Record updated",
    itemModifySavedBody:
      "The record was saved. The page will refresh with the latest data.",
    lastAiAnalysisSection: "Last AI analysis",
    viewHistoryItem: "View",

    conversationIntro:
      "Use natural language: ask for analysis, field updates, or new record creation.",
    conversationPlaceholder:
      "Example: analyze this record and list risks; or update the demand field with this text...",
    agentChatTitle: "AI Agent",
    agentFabChoice: "Assistant",
    agentFabOpenFull: "Open full screen",
    agentFabReplied: "The assistant replied",
    agentNewChat: "New chat",
    agentHistoryTitle: "History",
    agentSpendMonth: "AI this month: {usd}",
    agentSpendMine: "you: {usd}",
    agentSpendTrial: "free until {date}",
    agentSpendSaving: "saving",
    agentSpendChange: "Change AI",
    agentSpendAccumulated: "Total this month:",
    agentModelChange: "Change AI model",
    agentSpendColMessages: "Messages",
    agentSpendColSpent: "Spent",
    agentSpendOther: "No per-message detail",
    agentSpendPerMessage: "{usd} per message",
    agentModelChoose: "Choose the model to continue with",
    agentMessageCost: "This message: {usd}",
    agentModelModalTitle: "Chat AI model",
    agentModelModalIntro: "Each message to the assistant is charged according to the model that answers it. So far this month, the company has spent {usd}.",
    agentModelOnlyAdmin: "Only an administrator can change the model. Ask them if you want to spend less.",
    agentHistoryEmpty: "No conversations yet.",
    agentHistoryUntitled: "Untitled conversation",
    goodMorningTitle: "Good morning",
    goodMorningGreeting: "Good morning, {name}",
    goodMorningHint: "Tap a suggestion to talk it through with me.",
    goodMorningPreview: "Preview for {name}: not saved and not shown to them.",
    goodMorningOpen: "Open the screen",
    goodMorningDismiss: "Hide for today",
    goodMorningCustomPending: "Preparing…",
    goodMorningCustomError: "Could not be built today.",
    goodMorningCustomize: "My custom tips",
    agentLockedIntro: "Every morning I leave you tips to start the day. To ask me to do things in the system you need the AI assistant chat.",
    agentLockedReply: "I can't help you with that without the chat enabled. With the chat I can search, enter and update records for you.",
    agentLockedAdmin: "Enable it in [System features → Artificial intelligence](/systemfeatures): the first week is free.",
    agentLockedUser: "Ask an administrator to enable it in System features: the first week is free.",
    agentLockedUnavailable: "The assistant chat is not available for your company yet.",
    agentLockedPlaceholder: "The chat is not enabled",
    customAdviceTitle: "My custom tips",
    customAdviceHelp: "Tell your assistant what you want it to keep an eye on. Every morning it checks on its own, without you asking, and leaves what it found in “Today's suggestions”. It only reads data: it never enters or changes anything.",
    customAdviceExample: "E.g.: Let me know about payments due this week, with supplier and amount.",
    customAdviceAdd: "Add",
    customAdviceSave: "Save",
    customAdviceEmpty: "You have no custom tips yet.",
    customAdviceFreeBadge: "Free",
    customAdvicePaidBadge: "Pay per use",
    customAdviceCount: "{used} of {limit}",
    customAdviceLimitFree: "You have {free} free. To add more, an administrator has to enable them in System features → Artificial intelligence.",
    customAdvicePaidWarning: "From the third one, usage is billed to the company.",
    customAdviceDeleteConfirm: "Delete this custom tip?",
    customAdviceSaved: "Done: I'm building it and it will show up in today's tips.",
    agentChatIntro: "Ask for what you need: search, create or update records. Before saving anything it shows what it will save and waits for your confirmation.",
    agentChatPlaceholder: "Type your request…",
    agentChatUnavailable: "The assistant is not available.",
    agentChatLoading: "The assistant is working; it may take a couple of minutes",
    agentFileDownloadError: "The file could not be downloaded.",
    agentChatKnowledge: "What it learned",
    agentChatKnowledgeHelp: "What people in your company taught it. It uses this in every conversation for every user: fix or delete anything that is wrong.",
    agentChatKnowledgeEmpty: "It hasn't learned anything yet. Explain a term in the chat and it will offer to save it.",
    agentChatKnowledgeDeleteConfirm: "Delete “{term}”? The agent will forget it in future conversations.",
    agentChatInstallApp: "Install app",
    agentChatInstallHelp: "Install {name} on your phone to chat with the AI Agent like any other app, without opening the browser.",
    agentChatInstallIosSteps: "On iPhone: tap Share (the square with the up arrow) and choose “Add to Home Screen”.",
    agentChatInstallOtherSteps: "Open the browser menu (⋮) and choose “Install app” or “Add to Home screen”.",
    agentChatInstallOpensHome: "The app opens on the {name} home page; the chat is in the menu, under “AI Agent”.",
    agentChatSubtitle: "{name} assistant",
    agentChatTyping: "typing…",
    agentChatNotifyOff: "Turn on notifications",
    agentChatNotifyOn: "Notifications on",
    agentChatNotifyEnabled: "Done: when the AI Agent replies you get a notification on this device, even if you closed the chat. Tap it to go back to the conversation. You will also be notified of emails the system sends you.",
    agentChatNotifyDenied: "Your browser is blocking notifications from {name}. Allow them in the browser settings and try again.",
    agentChatNotifyUnavailable: "Notifications are not configured on the server yet.",
    agentChatNotifyIosInstallFirst: "On iPhone notifications only work with the app installed: tap “Install app”, open {name} from your home screen and turn them on there.",
    conversationSend: "Send",
    conversationClear: "Reset conversation",
    conversationLoading: "AI is responding…",
    conversationGreeting:
      "Great, I already have context for this record ({model}). Tell me what you need and we will handle it in chat.",

    listingAssistantIntro:
      "Create a new record, ask for filters to narrow the list (the AI builds the URL like the filter bar), or ask about fields. The AI uses this list’s model definition. For a new row you don’t need every field upfront—share the essentials for a draft and finish the rest on the record screen.",
    listingAssistantPlaceholder:
      "e.g. draft a row with…, explain what field X means…",
    listingAssistantGreeting:
      "You are on the list for {model}. Tell me what record to generate or what you need.",
    listingAssistantCreatedOk: "Done — the record was created.",
    listingFiltersApplied:
      "Done — list filters were updated (reflected in the URL).",
    listingAssistantError: "The AI action could not be completed.",
    supportFABAssistantIntro:
      "Ask in everyday language how the system works, forms, shipments, or support tickets. I answer in plain, non-technical wording.",

    supportFABAssistantPlaceholder:
      "e.g. a field didn’t fill in when I created a shipment, how do I follow up on a ticket, where do I change…?",
    supportFABAssistantError: "The assistant could not complete the reply.",
    supportFABTokenUsage:
      "This message used {total} tokens ({prompt} input + {completion} output, {calls} requests) · {cost} USD",
    supportFABGreetingCapabilities:
      "You can ask about using the system, forms, shipments, or support tickets.\n\nKeyword rules:\n«Remember this:» — Saves rules for future chats so you do not repeat them. You can also use «clarification:» or «aclaracion:». Confirm with yes/no when saving.\nView or edit saved rules under System Features → Included modules → Technical support AI → My rules. They are shared with all users in your organization.",
    chatTurnNetworkSlow:
      "The service is very slow or did not respond in time. Please try again in a few minutes.",
    chatTurnTimeoutSlow:
      "The reply took too long. Try again shortly or with a shorter question.",
    supportChatTurnTimeoutPartial:
      "The request took longer than the browser waits, but part of the reply is already shown above. Send again or rephrase your request.",
    supportFABTechnicalIALabel: "AI Agent",

    supportChatAttach: "Attach file",
    supportChatAttachMax: "Maximum {max} files per conversation.",
    supportChatAttachError: "Could not upload the file.",
    supportFABChoiceReportBug: "Reportar un bug",
    supportFABChoiceChat: "Chat",
    supportFABChoicePerformance: "Performance",
    supportFABPerformanceTitle: "Performance",
    supportFABPerformanceIntro:
      "We measure your connection from the browser. If support asks, take a screenshot of this panel.",
    supportFABPerformanceRefresh: "Refresh measurement",
    supportFABPerformanceCopy: "Copy data",
    supportFABPerformanceCopied: "Data copied to clipboard.",
    supportFABPerformanceCopyError: "Could not copy data.",
    supportFABPerformanceLoading: "Measuring connection…",
    supportFABPerformanceError: "Could not complete the measurement.",
    supportFABPerformanceNotAvailable: "Not available",
    supportFABPerformanceSummary: "Summary",
    supportFABPerformanceNetwork: "Browser network",
    supportFABPerformanceOnline: "Online",
    supportFABPerformanceEffectiveType: "Connection type",
    supportFABPerformanceDownlink: "Estimated download",
    supportFABPerformanceBrowserRtt: "Browser RTT",
    supportFABPerformanceSaveData: "Data saver",
    supportFABPerformanceApiLatency: "Server latency",
    supportFABPerformanceAvgLatency: "Average",
    supportFABPerformanceMinMaxLatency: "Min / Max",
    supportFABPerformanceSamples: "Samples",
    supportFABPerformancePageLoad: "This page load",
    supportFABPerformanceTtfb: "TTFB",
    supportFABPerformanceDomInteractive: "DOM interactive",
    supportFABPerformanceLoadTotal: "Total load",
    supportFABPerformanceEnvironment: "Environment",
    supportFABPerformanceTimezone: "Timezone",
    supportFABPerformanceLocale: "Language",
    supportFABPerformanceScreen: "Screen",
    supportFABPerformanceViewport: "Viewport",
    supportFABPerformanceScreenshotHint:
      "Send a screenshot of this screen to support if they ask for it.",
    supportFABPerformanceOffline: "Offline",
    supportFABPerformanceStatusGood: "Good",
    supportFABPerformanceStatusModerate: "Moderate",
    supportFABPerformanceStatusSlow: "Slow",
    supportFABPerformanceStatusUnknown: "No data",
    supportFABPerformanceGeneratedAt: "Measured at",

    promptHistoryTitle: "AI chat history (applied results)",
    promptHistoryHint:
      "Saved to your account when the chat applied changes to this record or created one from chat. Restore a request below to reuse or refine it.",
    promptHistoryRestoredHint:
      "Your saved request is in the box below; review it and send when ready.",
    promptHistoryRestore: "Restore",
    promptHistoryRemove: "Remove from history",
    promptHistoryUntitled: "(untitled)",

    promptHistoryKindChatModify: "Chat · changes applied",
    promptHistoryKindChatCreate: "Chat · record created",
    promptHistoryChatModifyNote: "Changes applied to this record from chat.",
    promptHistoryChatCreateNote: "New record created from chat.",

    analysisInProgressTitle: "Analysis in progress",
    analysisInProgressMessage: 'Analyzing: "{excerpt}"',
    viewContent: "View content",
    cancelAnalysis: "Cancel",
    analysisCompletedTitle: "Analysis complete",
    analysisCompletedMessage: "The AI analysis finished successfully.",
    analysisCancelledTitle: "Analysis cancelled",
    analysisCancelledMessage: "The analysis was cancelled.",
    analysisErrorTitle: "Analysis error",
    analysisErrorGeneric: "Something went wrong during the analysis.",
    cancelAnalysisErrorTitle: "Could not cancel",

    cancelAnalysisErrorRetry:
      "Could not cancel the analysis. Please try again.",
    processingAnalysisProgress: "Processing analysis… {progress}%",

    progressBarPercent: "{progress}% complete",
  },
  // Preferences translations
  savePreferences: "Save Preferences",
  preferencesSaved: "Preferences saved successfully",
  preferencesSaveError: "Error saving preferences",
  savePreferencesTooltip:
    "Save current preferences for columns, order, widths and filters",
  applyPreferencesToAllUsers: "Apply these preferences to all users",
  applyPreferencesToAllUsersHint:
    "This will overwrite the preferences of all system users for this model",
  preferencesAppliedToAllUsers: "Preferences applied to all users successfully",
  // Column and report translations
  ColumnRemoved: "Column removed",
  LoadingColumnPreferences: "Loading column preferences...",
  NoRecordsAvailable: "No records available",
  // Mobile pieces (components/mobile) and phone versions of screens.
  mobile: {
    actions: "Actions",
    recordActions: "Record actions",
    columns: "Columns",
    filterFields: "Choose filters",
    showResults: "Show {n} results",
    of: "of",
    previous: "Previous",
    next: "Next",
    navigation: "Navigation",
    home: "Home",
    support: "Support",
    menu: "Menu",
    pushOff: "Turn on notifications",
    pushOn: "Notifications on",
    pushEnabled: "Done: this phone gets a notification for every email the system sends you and when the AI Agent replies. Tap again to turn them off.",
    pushDenied: "Notifications from this app are blocked on this phone. Allow them in the settings and try again.",
    installTitle: "Install {name} on your phone",
    installSubtitle: "It opens like an app and notifies you of your emails.",
    installButton: "Install",
    installDismiss: "Not now",
    installWhichPhone: "Which phone do you have?",
    installOtherPhone: "Do you have {name}? See its steps",
    installAndroidQuick: "Your phone can install it with one tap:",
    installNow: "Install now",
    installOrManual: "Or do it manually:",
    installIosStep1: "Open this page in Safari and tap the Share button (the square with the arrow pointing up) in the bottom bar.",
    installIosStep2: "Scroll down and choose “Add to Home Screen”.",
    installIosStep3: "Tap “Add” in the top right corner.",
    installIosAddLabel: "Add to Home Screen",
    installIosCancel: "Cancel",
    installIosConfirm: "Add",
    installAndroidStep1: "In Chrome, tap the three dots (⋮) in the top right corner.",
    installAndroidStep2: "Choose “Install app” (or “Add to Home screen”).",
    installAndroidStep3: "Confirm by tapping “Install”.",
    installAndroidLabel: "Install app",
    installStepOpen: "Done: open {name} from the icon on your home screen. From there you can turn on notifications in your user menu.",
    pushBannerTitle: "Turn on notifications",
    pushBannerSubtitle: "Get on your phone the alerts you receive by email today.",
    pushBannerButton: "Turn on",
    pushNeedsInstall: "On iPhone notifications only work with the app installed: in Safari tap Share → “Add to Home Screen”, open the app from there and turn them on in this menu.",
  },
  PleaseSelectColumns:
    "Please select columns in the blue button at the top right to see information in this listing",
  Column: "Column",
  restored: "restored",
  New: "New",
  ImportJSON: "Import JSON",
  SelectAll: "Select all",
  BulkEdit: "Bulk Edit",
  DeleteSelected: "Delete Selected",
  Archive: "Archive",
  ArchiveSelected: "Archive selected",
  listTitleTrash: "Trash",
  listTitleArchive: "Archive",
  listTitleHidden: "Hidden",
  "Export to Excel": "Export to Excel",
  "Hide empty date": "Hide empty date",
  "Actions": "Actions",
  "Debit": "Debit",
  "Credit": "Credit",
  "Attached File": "Attached File",
  "No transactions found matching your search": "No transactions found matching your search",
  "Hide movements that have no date": "Hide movements that have no date",
  "No payments found": "No payments found",
  "No collects found": "No collects found",
  listTabActive: "Active",
  listTabArchived: "Archived",
  listTabAll: "All",
  hide: "Hide",
  hideInThisView: "Hide in this view",
  showInThisView: "Show in this view",
  HideSelected: "Hide selected",
  ShowSelected: "Show selected",
  "View archived": "View archived",
  "This item is archived": "This item is archived",
  excelExportArchived: "Archived",
  excelExportPaid: "Paid",
  excelExportUnpaid: "Unpaid",
  Unarchive: "Unarchive",
  UnarchiveSelected: "Unarchive selected",
  "records archived successfully.": "records archived successfully.",
  "records archived": "records archived",
  "An error occurred while archiving the records.": "An error occurred while archiving the records.",
  "records unarchived successfully.": "records unarchived successfully.",
  "records unarchived": "records unarchived",
  "An error occurred while unarchiving the records.": "An error occurred while unarchiving the records.",
  "The record has been unarchived successfully.": "The record has been unarchived successfully.",
  "An error occurred while unarchiving the record.": "An error occurred while unarchiving the record.",
  SaveAsReport: "Save as Report",
  Reports: "Reports",
  Filters: "Filters",
  MoreFilters: "More filters",
  MyItems: "My items",
  listTitleMyItems: "Only my items",
  userOwner: "User owner",
  userOwnerFieldSelect: "User owner fields",
  userOwnerFieldNone: "None",
  userOwnerFieldSaveError: "Could not save the user owner field",
  KeywordSearch: "Keyword search",
  Choose: "Choose",
  CreationDate: "Creation date",
  ReportLoaded: "Report Loaded",
  ReportLoadedSuccessfully: 'Report "{name}" loaded successfully',
  ErrorLoadingReport: "Error loading report",
  // Report modal translations
  ReportName: "Report Name",
  EnterReportName: "Enter report name",
  EnterReportDescription: "Enter report description (optional)",
  MakeReportPublic: "Make this report public (all users can access it)",
  ReportSaveInfo: "This will save the current view configuration including:",
  ReportSaveInfoColumns: "Selected columns and their order",
  ReportSaveInfoColumnLabels: "Custom column titles (saved with the report)",
  ReportSaveInfoWidths: "Column widths",
  ReportSaveInfoFilters: "Applied filters",
  ReportSaveInfoSort: "Sort order",
  ReportSaveInfoPagination: "Pagination settings",
  SaveReport: "Save Report",
  PleaseEnterReportName: "Please enter a report name",
  ReportIcon: "Report Icon",
  SearchIcon: "Search icon...",
  ChooseIcon: "Choose icon",
  NoIconsFound: "No icons match that name",
  ReportSavedSuccessfully: "Report saved successfully!",
  ErrorSavingReport: "Error saving report",
  SavedReports: "Saved Reports",
  Loading: "Loading...",
  NoSavedReportsFound: "No saved reports found",
  Name: "Name",
  Visibility: "Visibility",
  CreatedBy: "Created By",
  UpdatedBy: "Updated by",
  Created: "Created",
  Public: "Public",
  Private: "Private",
  Unknown: "Unknown",
  Load: "Load",
  LoadReport: "Load Report",
  EditReport: "Edit Report",
  DeleteReport: "Delete Report",
  Import: "Import",
  Continue: "Continue",
  ImportReportConfig: "Import report config",
  ExportReportConfig: "Export report config",
  ReportConfigImportedSuccessfully: "Report config imported successfully",
  ErrorImportingReportConfig: "Error importing report config",
  ErrorExportingReportConfig: "Error exporting report config",
  InvalidReportConfigFile: "Invalid report config JSON file",
  ModelMismatch: "Model mismatch",
  ReportConfigModelMismatch:
    "This config was exported from another model. You can continue, but some columns or filters may not apply.",
  Close: "Close",
  deleteBlockedFinancial: {
    title: "Cannot delete",
    introProforms:
      "The following proformas cannot be deleted because they have associated payments/collections:",
    introShippings:
      "The following shippings cannot be deleted because they have associated payments/collections:",
    introGeneric:
      "The following records cannot be deleted because they have associated payments/collections:",
    introContacts:
      "The following contacts cannot be deleted because they have associated movements:",
    commercialNotes: "Commercial notes",
    expenseShippings: "Shippings with expenses from this contact",
    clientShippings: "Shippings where it is the client",
    bankAccounts: "Bank accounts",
  },
  Save: "Save",
  Saving: "Saving",
  Edit: "Edit",
  List: "List",
  ListOpenView: "View",
  "Add new": "Add new",
  "Recalculate status": "Recalculate status",
  "Recalculate status for all shippings":
    "Recalculate status for all shippings",
  "Recalculate status done": "Status updated for {count} shippings in {ms} ms.",
  All: "All",
  addReferenceRelatedToContent: "Add {label}",
  Delete: "Delete",
  Clear: "Clear",
  Activate: "Activate",
  Deactivate: "Deactivate",
  Active: "Active",
  Inactive: "Inactive",
  editColumnDisplayName: "Column header",
  editColumnDisplayNameHint:
    "Leave empty or keep the default name to restore the original label.",
  editColumnDisplayNameTooltip: "Customize column",
  editColumnDescription: "Column description",
  editColumnDescriptionHint:
    "Shown when hovering the \"?\" icon in the header. Leave it empty to restore the system description, or to remove the icon if the field has none.",
  editColumnDescriptionTooltip: "Describe this column",
  editColumnDisplayNameTooLong: "Maximum 200 characters",
  editColumnDisplayBold: "Bold",
  editColumnShowTotal: "Show total",
  editColumnGroupBy: "Group rows by this column",
  editColumnMoveToStart: "Send to start",
  editColumnMoveToEnd: "Send to end",
  reportColumnLayoutTitle: "Column layout",
  reportRowGroupingBy: "Rows grouped by: {column}",
  reportRowGroupingNone: "Rows are not grouped. To group rows, use «Customize column» in the column header.",
  reportRowGroupingChange: "Change",
  reportGroupByEmpty: "(no value)",
  groupTotals: {
    groupDateBy: "Group the date by",
    period: { day: "Day", yearMonth: "Month", year: "Year" },
    inGroupRow: "In each group row, show",
    weightedBy: "weighted by",
    op: {
      none: "Nothing",
      sum: "Sum",
      avg: "Average",
      weightedAvg: "Weighted average",
      min: "Minimum",
      max: "Maximum",
    },
    highlightMonth: "Show for each year the month",
    none: "Don't show",
    lowestMonth: "Lowest",
    highestMonth: "Highest",
    lowestMonthText: "lowest month: {month} ({value})",
    highestMonthText: "highest month: {month} ({value})",
    collapsedByDefault: "Groups start collapsed (one row per group)",
    toggleGroup: "Expand or collapse the group",
  },
  reportColumnLayoutHint:
    "Group columns places them side by side under a shared title and color (including merged columns). Merge columns combines cell content into one column; already merged columns cannot be merged again.",
  reportColumnMergeIncludesMergedTitle: "Use Group columns",
  reportColumnMergeIncludesMergedText:
    "Already merged columns cannot be merged again. Select them and use Group columns to place them under the same title and color.",
  reportColumnGroup: "Group columns",
  reportColumnMerge: "Merge columns",
  reportColumnGroupTitle: "Group title",
  reportColumnGroupTitleRequired: "Enter a group title",
  reportColumnMergeStack: "Stack vertically",
  reportColumnMergeSum: "Sum values",
  reportColumnSelectTwo: "Select at least two columns",
  reportColumnMergesList: "Merged columns",
  reportColumnGroupsList: "Groups",
  reportColumnMergedBadge: "merged",
  reportColumnLayoutColumns: "columns",
  Apply: "Apply",
  ReportUpdatedSuccessfully: "Report updated successfully",
  ErrorUpdatingReport: "Error updating report",
  updateReport: "Update Report",
  foreignReport: {
    title: "This report isn't yours",
    text: "“{name}” belongs to {owner}: your changes can't be saved to it. Save them as a new report of your own?",
    textNoOwner: "“{name}” belongs to another user: your changes can't be saved to it. Save them as a new report of your own?",
    saveAsNew: "Save as new",
    keepWithoutSaving: "Keep without saving",
    copyName: "{name} (copy)",
  },
  updateReportTooltip: "Update the loaded report with current configuration",

  ReportExited:
    "You have exited the report and returned to your saved preferences",
  ErrorExitingReport: "Error exiting report",
  ViewingReport: "Viewing report",
  AreYouSure: "Are you sure?",
  ConfirmDeleteReport: 'Do you want to delete the report "{name}"?',
  YesDeleteIt: "Yes, delete it",
  Deleted: "Deleted",
  ReportDeletedSuccessfully: "Report deleted successfully",
  ErrorDeletingReport: "Error deleting report",
  ErrorLoadingReports: "Error loading reports",
  ResizeColumn: "Resize column",
  Sort: "Sort",
  PinColumn: "Pin column",
  UnpinColumn: "Unpin column",
  "Select all": "Select all",
  columnSelectorSelectedCount: "{count} selected columns",
  columnSelectorNoFields: "No displayable fields found",
  Cancel: "Cancel",
  "Customize display": "Customize display",
  "Clear filter": "Clear filter",
  "Clear all": "Clear all",
  "Close all": "Close all",
  "Is empty": "Is empty",
  "Is not empty": "Is not empty",
  HideColumn: "Hide column",
  ClipViewMoreColumnOn: "Compact column (show + to expand)",
  ClipViewMoreColumnOff: "Disable compact column",
  WrapTextColumnOn: "Wrap text in this column",
  WrapTextColumnOff: "Remove text wrapping",
  ColumnsFormatAll: "Format all columns",
  WrapTextAllColumns: "Wrap text in all columns",
  ClipViewMoreAllColumns: "Compact all columns (with +)",
  ClearFormatAllColumns: "Remove format from all columns",
  OrderByDragAndDrop: "Order by drag and drop",
  RowDragHandle: "Drag to reorder",
  RowOrderSaveError: "Could not save the row order",
  ColumnFieldHelpAria: "View field description",
  ImportCSV: "Import CSV",
  AdvancedImport: "Advanced Import",
  ImportPresetSavedConfigs: "Saved layouts",
  ImportPresetPickToApply: "— Apply saved layout —",
  ImportPresetSaveCurrent: "Save current layout",
  ImportPresetPickToDelete: "— Delete saved —",
  ImportPresetHint:
    "Save CSV column mapping, delimiter, and duplicate/reference options to reuse them. You can apply any saved layout; columns that match by name will use the saved mapping. The saved name is taken from the uploaded file name (without extension).",
  ImportPresetNamePrompt: "Name for this layout",
  ImportPresetNameRequired: "Enter a name to save.",
  ImportPresetSavedOk: "Layout saved successfully.",
  ImportPresetMismatch: "The file columns do not match that saved layout.",
  ImportPresetDeletedOk: "Saved layout removed.",
  ImportPresetConfirmDelete: "Remove this saved layout?",
  ImportPresetNoFile: "No CSV file",
  ImportPresetNoFileDetail: "Select a file before saving this layout.",
  ImportSkipHooks: "Skip hooks during import",
  ImportSkipHooksHelp:
    "Speeds up import by avoiding hook/model-hook execution on each row.",
  ImportErrorsLiveTitle: "Import errors detected",
  ImportRowPrefix: "Row",
  ImportGenericRowError: "Error importing row",
  ImportErrorAdminNote: "Technical detail visible for admin role.",
  ImportCreateMissingRefs: "Create missing references",
  ImportCreateMissingRefsHelp:
    "If a reference value does not exist, it will be created automatically using the file value as the name.",
  LoadingData: "Loading data...",
  // AI Model Context translations
  aiModelContext: {
    title: "AI Context Configuration by Model",
    subtitle:
      "Define the specific context that AI should have for each data model",
    configurePrompts: "Configure Prompts",
    goToAI: "Go to AI",
    whatIsAIContext: "What is AI Context?",
    aiContextDescription:
      "AI context is specific information that is sent to artificial intelligence every time it analyzes data from a particular model. This helps AI understand:",
    whatModelRepresents: "What the model represents",
    whatModelRepresentsDesc: "Its purpose and function in the business",
    howToInterpretData: "How to interpret the data",
    howToInterpretDataDesc: "The meaning of each field",
    whatToLookFor: "What to look for in the analysis",
    whatToLookForDesc: "Important aspects to consider",
    businessContext: "Business context",
    businessContextDesc: "Relationships with other models",
    definitionModels: "Definition Models",
    loading: "Loading...",
    loadingModels: "Loading models...",
    noModelsDefined: "No models defined",
    createModelsDescription:
      "Create definition models to configure their AI context",
    createModel: "Create Model",
    model: "Model",
    label: "Label",
    aiContext: "AI Context",
    status: "Status",
    actions: "Actions",
    noLabel: "No label",
    configured: "Configured",
    notConfigured: "Not configured",
    active: "Active",
    configure: "Configure",
    view: "View",
    configureAIContext: "Configure AI Context",
    modelLabel: "Model:",
    aiContextLabel: "AI Context *",
    aiContextGeneralLabel: "General model context",
    generalContextOptional:
      "Optional if you already fill action or field sections.",
    actionPromptsTitle: "Prompts per action",
    actionEditItemLabel: "Edit an item",
    actionAddItemLabel: "Add an item",
    actionDeleteItemLabel: "Delete an item",
    actionSearchItemLabel: "Search for an item",
    actionPromptPlaceholder: "Instructions for the AI when this action applies…",
    fieldPromptsTitle: "Prompts per field",
    fieldPromptsHint:
      "Technical field key (as in filters and JSON). Only non-empty texts are saved.",
    fieldPromptPlaceholder: "Rules or operational meaning for this field…",
    noFieldsInModel: "This model has no fields in its definition.",
    saveRequiresOneSection:
      "Fill at least one block: general context, an action, or a field.",
    previewAsSentToAi: "Preview (as sent to the AI)",
    previewGeneral: "General model context",
    previewActions: "Instructions per action",
    previewFields: "Instructions per field (technical key)",
    emptyPreview: "(no content)",
    aiContextPlaceholder:
      "Describe the specific context of this model for AI...",
    contextExamples: "Context examples:",
    example1:
      "This model represents business contacts. Analyze the quality of contact information, business activity and business opportunities.",
    example2:
      "This model contains catalog products. Evaluate the completeness of information, competitive prices and product description.",
    example3:
      "This model records financial transactions. Identify spending patterns, correct categorization and possible anomalies.",
    tipsForGoodContext: "Tips for good context:",
    tip1: "Explain what the model represents in the business",
    tip2: "Describe what aspects are important to analyze",
    tip3: "Mention relationships with other models if any",
    tip4: "Specify the type of insights you expect to obtain",
    cancel: "Cancel",
    saving: "Saving...",
    saveContext: "Save Context",
    modelAIContext: "Model AI Context",
    aiContextLabelView: "AI Context:",
    close: "Close",
    edit: "Edit",
    error: "Error",
    errorLoadingModels: "Error loading models",
    success: "Success!",
    contextSavedSuccessfully: "AI context saved successfully",
    errorSavingContext: "Error saving context",
  },
  // Dynamic Model Detail translations
  "Este contenido es un subitem de otro contenido.":
    "This content is a subitem of another content.",
  "Para editar, debes ir al modelo padre y modificar el campo correspondiente.":
    "To edit, you must go to the parent model and modify the corresponding field.",
  "Ir a la vista del item padre": "Go to parent item view",
  "Ir al listado del modelo padre": "Go to parent model list",
  "Ver Item Padre": "View Parent Item",
  "Ir al Modelo Padre": "Go to Parent Model",
  "No hay campos definidos": "No fields defined",
  "Contact ID is required to display Account Statement":
    "Contact ID is required to display Account Statement",
  "Bank Account ID is required to display Bank Account Statement":
    "Bank Account ID is required to display Bank Account Statement",
  "Análisis de Inteligencia Artificial": "Artificial Intelligence Analysis",
  "Prompt utilizado:": "Prompt used:",
  "Resultado del análisis:": "Analysis result:",
  "Información del análisis": "Analysis information",
  "Modelo:": "Model:",
  "Item:": "Item:",
  "Fecha:": "Date:",
  "Contexto analizado": "Analyzed context",
  "No hay información de contexto disponible":
    "No context information available",
  "Copiar análisis": "Copy analysis",
  "You won't be able to revert this action":
    "You won't be able to revert this action",
  "The item has been deleted successfully.":
    "The item has been deleted successfully.",
  "Could not delete the item.": "Could not delete the item.",
  "N/A": "N/A",
  "Análisis de IA -": "AI Analysis -",
  "Prompt:": "Prompt:",
  "Resultado:": "Result:",
  "Copiado al portapapeles": "Copied to clipboard",
  "El análisis se ha copiado correctamente":
    "The analysis has been copied successfully",
  "No se pudo copiar automáticamente": "Could not copy automatically",
  "Por favor, selecciona y copia el texto manualmente":
    "Please select and copy the text manually",
  Entendido: "Understood",
  "No hay estructura de contenido disponible": "No content structure available",
  "Estructura jerárquica del registro": "Hierarchical record structure",
  "ID del item:": "Item ID:",
  "GRUPOS ORGANIZACIONALES:": "ORGANIZATIONAL GROUPS:",
  "GRUPO:": "GROUP:",
  "Icono:": "Icon:",
  REQUERIDO: "REQUIRED",
  ARRAY: "ARRAY",
  "(vacío)": "(empty)",
  elementos: "elements",
  "(sin valor)": "(no value)",
  "(objeto complejo)": "(complex object)",
  "(objeto)": "(object)",
  "CAMPOS INDEPENDIENTES:": "INDEPENDENT FIELDS:",
  Item: "Item",
  submittedby: "Submitted by {name} on {date}",
  updatedby: "Updated by {name} on {date}",

  // Months
  months: {},

  // Website Module
  websites: {
    title: "Websites",
    subtitle: "Manage your websites and domains",
    menuItem: "Websites",
    createWebsite: "Create Website",
    editWebsite: "Edit Website",
    name: "Name",
    description: "Description",
    domain: "Domain",
    status: "Status",
    createdAt: "Created At",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    isActive: "Active",
    edit: "Edit",
    delete: "Delete",
    noWebsites: "No websites found",
    noWebsitesHint: "Create your first website using the button above",
    searchPlaceholder: "Search websites...",
    namePlaceholder: "Website name",
    descriptionPlaceholder: "Website description (optional)",
    domainPlaceholder: "example.com",
    domainHint:
      "Optional. Configure the domain when you want to publish the site.",
    saving: "Saving...",
    created: "Website created successfully",
    updated: "Website updated successfully",
    deleted: "Website deleted successfully",
    confirmDelete: 'Do you want to delete the website "{name}"?',
    requiredFields: "Please fill in the required fields",
    errorLoading: "Error loading websites",
    errorSaving: "Error saving website",
    errorDeleting: "Error deleting website",
    preview: "Preview",
  },

  // Pages (Website Module)
  pages: {
    title: "Pages",

    createPage: "Create Page",
    editPage: "Edit Page",
    slug: "Slug",
    model: "Model",

    status: "Status",

    actions: "Actions",
    active: "Active",
    inactive: "Inactive",

    noPages: "No pages",
    noPagesHint: "Create your first page using the button above",
    searchPlaceholder: "Search pages...",

    created: "Page created successfully",
    updated: "Page updated successfully",
    deleted: "Page deleted successfully",
    confirmDelete: 'Do you want to delete the page "{slug}"?',
    requiredFields: "Slug is required",

    errorSaving: "Error saving page",
    errorDeleting: "Error deleting page",
    preview: "Preview",

    shortcodeIf: "Shows content if the field exists",
    shortcodeHidden: "Hides in certain dbNames",
    shortcodeShow: "Shows only in certain dbNames",
    shortcodeFor: "Iterates over an array",

    conditionals: "Conditionals",
    loops: "Loops",
    visibility: "Visibility",
    operators: "Operators",
    loopVars: "Loop variables",
    loopIndex: "Current index (0, 1, 2...)",
    loopFirstLast: "First/last element",

    // Visual Editor
    editor: {
      loading: "Loading editor...",
      splitView: "Split view",
      codeOnly: "Code only",
      previewOnly: "Preview only",
      openInBrowser: "Open in browser",
      save: "Save",
      saving: "Saving...",
      configuration: "Configuration",
      urlSlug: "URL (slug)",
      pageActive: "Page active",
      dataSource: "Data source",
      noData: "No data",
      selectModel: "Select model...",
      selectReport: "Select report...",
      elements: "Elements",
      title: "Title",
      text: "Text",
      image: "Image",
      button: "Button",
      divider: "Divider",
      container: "Container",
      columns: "Columns",
      list: "List",
      card: "Card",
      hero: "Hero",
      gallery: "Gallery",
      video: "Video",
      blocks: "Blocks",
      media: "Media",
      uploadImage: "Upload image",
      noMedia: "No images",
      clickToInsert: "Click to insert",
      uploadError: "Error uploading image",
      confirmDeleteMedia: "Delete this image?",
      files: "CSS/JS Files",
      noFiles: "No files",
      manageFiles: "Manage files",
      fileInserted: 'File shortcode "{name}" inserted',
      variables: "Variables",
      insertLoop: "Insert t-for loop",
      logic: "Logic",
      conditional: "Conditional",
      ifElse: "If/Else",
      loop: "Loop",
      hideFor: "Hide for",
      showFor: "Show for",
      html: "HTML",
      formatCode: "Format code",
      livePreview: "Live preview",
      refresh: "Refresh",
      noSampleWarning: "No sample data",
      writePlaceholder:
        "Write your HTML here or use elements from the left panel...",
    },
    // Page Import
    importFromHtml: "Import from HTML",
    importHtmlSimpleHelp:
      "Paste your HTML code. CSS and JavaScript files will be automatically extracted and saved as site files.",

    baseUrl: "Site base URL",
    baseUrlHint:
      "To resolve relative URLs (e.g., /css/style.css → https://example.com/css/style.css)",
    pasteHtml: "Paste your HTML code here:",
    htmlPlaceholder:
      "<!DOCTYPE html>\n<html>\n<head>...</head>\n<body>\n  <header>...</header>\n  <main>...</main>\n  <footer>...</footer>\n</body>\n</html>",
    importPage: "Import page",
    importing: "Importing...",
    importSuccess:
      "Page imported successfully. {files} CSS/JS files extracted.",
    importError: "Error importing the page",

    generateBlocksWithAI: "Generate blocks with AI",
    analyzing: "Analyzing...",
    aiAnalysisResults: "AI Analysis Results",
    blocksDetected: "Blocks detected",
    pagePreview: "Page preview",
    createSelectedBlocks: "Create selected blocks",
    createBlocksAndUpdatePage: "Create blocks and update page",
    noBlocksDetected: "No blocks detected",
    htmlRequired: "HTML is required",

    analyzeError: "Error analyzing the HTML",
    generateBlocksInfo:
      "Selected blocks will be created and the page content will be updated, replacing the original HTML with the corresponding block shortcodes.",
    pageContentAfter: "Page content (after)",
    pageUpdatedWithBlocks: "Page updated with {blocks} blocks created",
    noContentToAnalyze: "This page has no content to analyze",
    errorUpdating: "Error updating the page",
    deletePage: "Delete page",

    noBlocksDetected: "No reusable blocks detected",

    pageCreatedWithBlocks: "Page created with {blocks} blocks",
    slugRequired: "Slug is required",

    errorCreating: "Error creating the page",
  },

  // Blocks (Website Module)
  blocks: {
    title: "Blocks",

    createBlock: "Create Block",
    editBlock: "Edit Block",
    name: "Name",

    model: "Model",
    content: "Content",
    status: "Status",
    actions: "Actions",
    shortcode: "Shortcode",
    isActive: "Active",
    noBlocks: "No blocks",
    noBlocksHint: "Create your first block using the button above",
    searchPlaceholder: "Search blocks...",
    contentPlaceholder: "<header>\n  <nav>...</nav>\n</header>",
    created: "Block created successfully",
    createdCount: "{count} blocks created successfully",
    createError: "Error creating blocks",
    updated: "Block updated successfully",
    deleted: "Block deleted successfully",
    confirmDelete: 'Do you want to delete the block "{name}"?',
    requiredFields: "Name is required",
    nameRequired: "Block name is required",
    namePlaceholder: "E.g.: Main Header",
    newBlock: "New Block",
    blockActive: "Block active",
    noItemId: "No Item ID",
    fromUrl: "From URL (?itemId=...)",
    fixedId: "Fixed ID",
    errorSaving: "Error saving block",
    errorDeleting: "Error deleting block",
    types: {},
    modelConfig: "Model Configuration",
    noModel: "No model",
    itemIdSource: "Item ID Source",
    itemIdNone: "None (random)",
    itemIdUrl: "From URL (?itemId=...)",
    itemIdFixed: "Fixed ID (hardcoded)",
    itemIdSourceHelp: "Where to get the item ID from",
    fixedItemId: "Fixed Item ID",
    fixedItemIdPlaceholder: "Document ID",
    // HTML Import with AI
    importFromHtml: "Import from HTML",
    importHtmlHelp:
      "Paste your HTML code and AI will automatically identify reusable blocks such as headers, footers, hero sections, etc.",
    pasteHtml: "Paste your HTML code here:",
    htmlPlaceholder:
      '<html>\n<head>...</head>\n<body>\n  <header>...</header>\n  <section class="hero">...</section>\n  <footer>...</footer>\n</body>\n</html>',
    analyzeWithAi: "Analyze with AI",
    analyzing: "Analyzing...",
    blocksFound: "{count} blocks found",
    analyzeAnother: "Analyze another HTML",
    selectAtLeastOne: "Select at least one block to create",
    createSelected: "Create {count} selected blocks",
    noBlocksFound: "No reusable blocks found in the HTML",
    analyzeError: "Error analyzing the HTML",
    blocksCreated: "{count} blocks created successfully",
    someBlocksFailed: "{count} blocks could not be created",
    errorCreating: "Error creating blocks",
  },

  // Menus (Website Module)
  menus: {
    locations: {},
  },

  // Files (Website Module - CSS/JS)
  files: {
    title: "Files",

    createFile: "Create File",
    editFile: "Edit File",
    name: "Name",
    type: "Type",
    source: "Source",
    url: "URL",
    content: "Content",
    status: "Status",
    actions: "Actions",
    shortcode: "Shortcode",
    isActive: "Active",
    isExternal: "External file (CDN)",
    isExternalHint:
      "Enable if the file is on an external CDN (URL only). Disable for local code.",
    noFiles: "No files",
    noFilesHint:
      "CSS/JS files will be created automatically when importing HTML or you can create them manually",
    searchPlaceholder: "Search files...",
    nameHint: "Include the extension (.css or .js)",
    created: "File created successfully",
    updated: "File updated successfully",
    deleted: "File deleted successfully",
    confirmDelete: 'Do you want to delete the file "{name}"?',

    errorSaving: "Error saving file",
    errorDeleting: "Error deleting file",
  },

  // Media
  media: {
    title: "Media",

    upload: "Upload File",
    name: "Name",
    url: "URL",

    noMedia: "No media files",
    noMediaHint:
      "Images will be imported automatically from HTML or you can upload them manually",
    searchPlaceholder: "Search media...",
    delete: "Delete",
    copyUrl: "Copy URL",
    urlCopied: "URL copied to clipboard",
    copyError: "Error copying URL",
    deleted: "Media file deleted",
    confirmDelete: 'Do you want to delete the file "{name}"?',
    errorDeleting: "Error deleting file",
    uploadHint:
      "To upload images, use the page editor or import HTML with images",
  },

  // Accounting Module
  accounting: {
    journalEntries: "Journal Entries",

    generateEntry: "Generate Entry",
    viewEntry: "View Entry",
    editEntry: "Edit Entry",
    newEntry: "New Entry",
    entryNumber: "Entry Number",
    entryGenerated: "Entry Generated Successfully",
    errorGenerating: "Error generating entry",
    regenerateEntry: "Regenerate Entry",
    regenerate: "Regenerate",
    regenerateConfirmText:
      "This will update the entry with current data from the source document (account numbers, amounts, etc.)",
    regenerateSuccess: "Entry Regenerated",
    regenerateSuccessText: "The entry has been updated with the current data.",
    regenerateError: "Error regenerating entry",
    regenerateEntryGone: "The source document no longer generates this entry: it was removed from the journal.",
    regenerateAll: "Regenerate all",
    regenerateAllConfirmText:
      "The entries of every document shown in the journal with the current filters are rebuilt with today's data (accounts, contact, amounts). Manual entries are not touched; collection and payment entries get new numbers.",
    regenerateAllDone: "Entries regenerated",
    regenerateAllResult: "{resynced} of {documents} documents updated.",
    regenerateAllSkipped: "{count} without a source document (deleted or in the trash).",
    regenerateAllErrors: "{count} with errors.",

    generateAllEntries: "Generate All Entries",
    confirmGenerateAll: "Generate All Entries?",
    confirmGenerateAllText:
      "This will generate accounting entries for all pending transactions in this operation.",
    generate: "Generate",
    generationResults: "Generation Results",
    generated: "Generated",
    skipped: "Skipped",
    errors: "Errors",
    entriesGenerated: "Entries Generated",
    noNewEntries: "No New Entries",
    allEntriesExist: "All accounting entries already exist for this operation.",
    export: "Export to Excel",
    exportExcel: "Export to Excel",
    exportCSV: "Export to CSV",

    noEntries: "No accounting entries found",
    noEntriesHint:
      "Generate entries from the Finance tab of a Shipping or Proforma",
    searchPlaceholder: "Search by concept, account...",
    totalItems: "{count} entry(ies)",
    showingItems: "Showing {from}-{to} of {total}",

    // Date fields
    date: "Date",
    dateFrom: "Date From",
    dateTo: "Date To",
    day: "Day",
    year: "Year",
    month: "Month",

    accountNumber: "Account Number",
    accountName: "Account Name",
    searchAccount: "Search by number or name…",
    accountNotInChart: "Not in the chart of accounts",
    chooseAccounts: "Choose the debit and credit accounts",
    debit: "Debit",
    credit: "Credit",

    // Transaction fields
    concept: "Concept",
    conceptPlaceholder: "e.g., ADVANCE PAYMENT PI 4803/2025",
    amount: "Amount",
    total: "Total",
    currency: "Currency",
    notes: "Notes",
    notesPlaceholder: "Additional notes (optional)",
    sourceDocument: "Source Document",
    entryType: "Entry Type",

    // Currency names
    currencies: {
      ARS: "Argentine Peso",
      USD: "US Dollar",
      EUR: "Euro",
      GBP: "British Pound",
      CNY: "Chinese Yuan",
    },

    // Entry types
    types: {
      collect_advance: "Client Advance Collection",
      collect_balance: "Client Balance Collection",
      payment_advance: "Supplier Advance Payment",
      payment_expense: "Expense Payment",
      payment_bank_to: "Payment bank account (to)",
      invoice_client: "Client Invoice",
      expense_load: "Expense Loading",

      other: "Manual / Other",
    },

    // Delete all
    deleteAll: "Delete All",
    deleteAllConfirmTitle: "Delete all entries?",
    deleteAllConfirmText:
      "This action will delete ALL accounting entries. This action cannot be undone.",
    deleteAllWarning: "WARNING: This action is irreversible!",
    typeToConfirm: "Type 'delete all' to confirm",
    typeDeleteAllToConfirm: "You must type 'delete all' to confirm",
    deleteAllSuccess: "Entries deleted",
    deleteAllSuccessText: "Successfully deleted {count} entry(ies).",
    deleteAllError: "Error deleting all entries",

    // Journal tabs
    tabEntries: "Entries",
    issues: {
      tab: "Not generated",
      intro:
        "Documents that did not generate their entry and entries generated with a missing account. Each row says why and what to fix; once fixed, click «Retry».",
      loading: "Checking documents…",
      empty: "Nothing pending: everything that had to be booked has its complete entry.",
      toFix: "What to fix",
      toFixHint: "What unblocks the most entries comes first.",
      affects: "{count} entry(ies)",
      showMore: "Show all",
      showLess: "Show less",
      filterKind: "Problem",
      filterSource: "Document",
      searchPlaceholder: "Document, contact, shipping…",
      document: "Document",
      date: "Date",
      amount: "Amount",
      reason: "Why it was not generated",
      fix: "What to do",
      retry: "Retry",
      retryAll: "Generate {count} entry(ies)",
      retryAllHint: "{count} document(s) have nothing to fix: their entry just needs to be generated or rebuilt.",
      retryAllProgress: "Generating {done} of {total}…",
      retryAllConfirmTitle: "Generate {count} entry(ies)?",
      retryAllConfirmText: "The entries of those documents are rebuilt with today's data. It may take a few minutes: don't close the screen.",
      retryAllDone: "{count} entry(ies) generated",
      retryAllStill: "{count} document(s) are still listed ({failed} with errors): check their reason.",
      retryDone: "Entries rebuilt",
      retryStill: "The document still has a problem: check the reason.",
      retryError: "Could not retry",
      open: "Open",
      openContact: "Open contact",
      openBankAccount: "Open bank account",
      openShipping: "Open shipping",
      kinds: {
        missing: "No entry",
        incomplete: "Incomplete entry",
      },
      sources: {
        collect: "Collect",
        payment: "Payment",
        shipping: "Sales invoice",
        shipping_expenses: "Expense",
        notacomercial: "Commercial note",
      },
      reasons: {
        contact_without_account: "Contact «{name}» has no accounting number.",
        stale_contact_account: "The entry was generated without the account of contact «{name}», which now has it.",
        bank_without_account: "Bank account «{name}» has no accounting number.",
        stale_bank_account: "The entry was generated without the account of «{name}», which now has it.",
        expense_type_without_code: "Expense type «{type}» has no accounting code.",
        paid_expense_without_invoice: "The payment is applied to expense «{expense}» of shipping {shipping}, which has no invoice number.",
        before_start: "Date {date} is before the accounting start date ({startDate}).",
        nota_unsupported: "The note is missing: {missing}.",
        nota_unsupported_combination: "That credit/debit, direction and contact role combination is not booked.",
        not_generated: "It has all the data, but the entry was not generated.",
        error: "Error building the entry: {message}",
      },
      fixes: {
        contact_without_account: "Fill in the accounting number on the contact and click Retry.",
        stale_contact_account: "Click Retry to rebuild the entry.",
        bank_without_account: "Fill in the accounting number on the bank account and click Retry.",
        stale_bank_account: "Click Retry to rebuild the entry.",
        expense_type_without_code: "Fill in the accounting code of the expense type in its list (Settings → Lists) and click Retry.",
        paid_expense_without_invoice: "Fill in the invoice number of the expense in the shipping and click Retry.",
        before_start: "If the date is wrong, fix it in the document. If it is right, it is not booked and there is nothing to do.",
        nota_unsupported: "Fill in that data on the note and click Retry.",
        not_generated: "Click Retry to generate it.",
        error: "Let support know the document name.",
      },
      notaFields: {
        credit_debit: "credit or debit",
        flow_direction: "direction (giving or receiving)",
        contact_role: "contact role",
      },
      groups: {
        contact_without_account: "Contact «{name}» without accounting number",
        bank_without_account: "Bank account «{name}» without accounting number",
        expense_type_without_code: "Expense type «{type}» without accounting code",
      },
    },
  },

  // Email module translations
  emails: {
    title: "Emails",
    subtitle: "Automated email management and notifications",
    templates: "Templates",
    triggers: "Triggers",
    logs: "History",
    configuration: "Configuration",

    // Emails written in code (read only)
    codeEmails: "Emails",
    codeEmailsIntro:
      "These are the emails the system sends on its own, written in code: when they go out, who receives them and what they say live in the code, so here you can see them but not edit them; what you can do is turn off the ones you do not use. The notice you get when someone mentions you in a support ticket, for instance, is one of these.",
    noCodeEmails: "No emails written in code yet",
    codeEmailWhen: "When it is sent",
    codeEmailRecipients: "Who receives it",
    codeEmailLastSent: "Last sent",
    codeEmailSentCount: "{count} sent",
    codeEmailNeverSent: "Never sent",
    codeEmailNeverSentHint: "This notice has not been sent in this company yet.",
    codeEmailLastSentEmail: "The last one sent",
    codeEmailSample: "What the email looks like",
    codeEmailSampleHint: "Example with made-up data, so you can see the layout of the email.",
    codeEmailHistoryName: "Name in history",
    codeEmailSource: "File",
    view: "View",
    codeEmailAlways: "Always",
    codeEmailNoFixedRecipients: "nobody",
    codeEmailEditFixedRecipients: "Edit fixed recipients",
    codeEmailFixedRecipientsTitle: "Fixed recipients",
    codeEmailFixedRecipientsHint:
      "These addresses receive this email every time it is sent, on top of the people it goes to according to the record.",
    codeEmailAddRecipient: "Add",
    codeEmailInvalidEmails: "These addresses are not valid: {emails}",
    codeEmailFixedRecipientsSaved: "Fixed recipients saved",
    codeEmailEnabled: "Active",
    codeEmailEnabledHint: "Uncheck it so this email stops being sent in this company.",
    codeEmailDisabledBadge: "Off",
    codeEmailEnabledSaved: "Email turned on",
    codeEmailDisabledSaved: "Email turned off: it will not be sent",
    codeEmailHistoryTitle: "Sent emails",
    codeEmailHistoryTotal: "{count} in total",
    otherGroup: "Other",

    // Templates
    createTemplate: "Create Template",
    editTemplate: "Edit Template",
    searchTemplates: "Search templates...",
    noTemplates: "No templates",
    noTemplatesHint: "Create your first email template to get started",
    name: "Name",
    subject: "Subject",
    content: "Content",
    description: "Description",
    model: "Model",
    noModel: "No model",
    modelHint: "Select a model to use dynamic shortcodes",
    subjectHint: "You can use shortcodes like {{client.name}}",
    contentHint: "Write the email content. Use {{field}} for dynamic data",
    contentPlainOrHtml: "Plain text or HTML",
    templateLanguage: "Template language",
    templateLanguageHint: "Subject and body above are for this language.",
    translations: "Translations",
    translationsHint:
      "Add versions in other languages. You can change the text but keep the shortcodes ({{ ... }}) the same as in the main template.",
    addLanguage: "Add",
    removeTranslation: "Remove",
    loadShortcodes: "Load Shortcodes",

    senderName: "Sender name",
    replyTo: "Reply to",
    senderUseDefaultHint: "Leave empty to use the default from Configuration.",
    sendInLanguage: "Send in language",
    addMoreLanguagesHint:
      "To add more languages, edit this template in Emails > Templates.",
    noLanguagesConfiguredHint:
      "This template has no languages configured. Go to Emails > Templates, edit this template, set the template language and add translations.",
    exportTemplatesHint:
      "Only templates without document model are shown (list/report has no single document for shortcodes).",
    noExportTemplatesHint:
      "No templates without document model. Create a template with no model in Emails > Templates to use here.",
    pdfInPageLanguageHint:
      "PDF is in the current page language. Subject and body are in the selected language.",
    pdfInSelectedLanguageHint: "PDF is in the selected language.",
    pdfLanguage: "PDF language",
    regeneratingPdf: "Regenerating PDF in selected language...",
    pdfRegenerateError: "Could not generate PDF in selected language.",
    isActive: "Active",
    private: "Private",
    privateTemplateHint:
      "Only you can see, edit and use this template. It will not appear in the list or in Send by email for other users.",

    templateCreated: "Template created successfully",
    templateUpdated: "Template updated successfully",
    templateDeleted: "Template deleted successfully",
    confirmDelete: "Delete template '{name}'?",

    // Triggers
    createTrigger: "Create Trigger",
    editTrigger: "Edit Trigger",
    noTriggers: "No triggers",
    noTriggersHint: "Create a trigger to automate email sending",
    template: "Template",
    selectTemplate: "Select template",
    triggerType: "Trigger type",
    triggerConfig: "Configuration",
    eventTrigger: "Event-based",
    scheduleTrigger: "Scheduled",
    manualTrigger: "Manual",
    executions: "Executions",
    allTypes: "All types",

    // Event config
    eventConfig: "Event configuration",
    eventType: "Event type",
    selectEvent: "Select event",
    afterInsert: "After create",
    afterSave: "After save",
    afterUpdate: "After update",
    afterDelete: "After delete",
    afterAppliedtoChange: "After appliedto change",
    eventModel: "Model",
    selectModel: "Select model",
    eventConditions: "Conditions (JSON)",
    eventConditionsHint: '{"paid": {"$changedTo": true}}',
    eventConditionsExample: 'Example: {"paid": true} (on update only if the field changed) or {"paid": {"$changedTo": true}}',
    invalidConditions: "Conditions are not valid JSON",

    // Schedule config
    scheduleConfig: "Schedule configuration",
    scheduleType: "Frequency",
    selectSchedule: "Select frequency",
    once: "Once",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    scheduleTime: "Time",
    scheduleDate: "Date",
    dayOfWeek: "Day of week",
    dayOfMonth: "Day of month",
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",

    // Recipient config
    recipientConfig: "Recipient configuration",

    recipientField: "Model field",
    recipientFieldHint:
      "Expand the tree and click an email or user path to add or remove it.",
    recipientFieldMaxDepthHint:
      "Up to {depth} reference levels (same depth as expanded data).",
    recipientPathsRejected:
      "Paths beyond max depth ({depth}) were removed: {paths}",
    recipientFieldTypeEmail: "Email",
    recipientFieldTypeUser: "User",
    recipientFieldsSelected: "Selected recipients",
    recipientFieldsSelectedEmpty: "None yet. Expand the tree and click a path.",
    recipientExampleItem: "Example record",
    recipientExampleItemSelected: "Example: {label}",
    recipientExampleItemEmpty: "No data in this record to preview field values.",
    recipientExampleItemLoadError: "Could not load the example record.",
    modelForRecipientFields: "Model for email fields",
    selectModelForEmailFields:
      "Select the event model or template model to list email fields.",
    expandGroup: "Expand group",
    collapseGroup: "Collapse group",
    noEmailFieldsFound:
      "No email fields found for this model.",
    noMatchingEmailFields: "No fields match your search.",
    noShortcodeFields: "No shortcodes loaded. Load sample data first.",

    previewWithItem: "Preview with record",
    previewWithItemTitle: "Email preview",
    previewWithItemHint:
      "Search a {model} record and render the template with real data (same engine as when sending).",
    previewSearchItem: "Record",
    previewSearchItemPlaceholder: "Search by name, number or text…",
    previewNoItemsFound: "No records found.",
    previewRendering: "Rendering email…",
    previewSelectItemHint: "Select a record to generate the preview.",
    previewSearchError: "Could not search records.",
    previewRenderError: "Could not render the preview.",
    previewWithItemMissingSource: "Select a model or report and add content first.",
    previewRecipientsTitle: "Recipients",
    previewRecipientsNoTemplate:
      "Save the template to preview recipients from its triggers.",
    previewRecipientsNoTriggers: "No active triggers use this template.",
    previewRecipientsNone: "No recipients for this record with the current trigger setup.",
    previewRecipientsByTrigger: "By trigger",
    previewRecipientsConditionsNotMet: "Conditions not met for this record",
    previewRecipientsConditionsNotMetShort: "conditions not met",

    recipientUsers: "System Users",
    emailField: "Email field",
    fixedEmails: "Fixed emails",
    separateByComma: "Separate with commas",
    selectUsers: "Select Users",
    selectUsersHint: "Select one or more system users to receive emails",

    triggerCreated: "Trigger created successfully",
    triggerUpdated: "Trigger updated successfully",
    triggerDeleted: "Trigger deleted successfully",
    triggerActivated: "Trigger activated",
    triggerDeactivated: "Trigger deactivated",
    confirmDeleteTrigger: "Delete trigger '{name}'?",

    // Data source config
    dataSourceConfig: "Data Source",

    dataSource: "Data Source",

    useReport: "Use report",

    selectReport: "Select report",
    reportHint: "Report data will be used for the email template",

    // Logs
    searchLogs: "Search history...",
    noLogs: "No records",
    noLogsHint: "Sent and queued emails will appear here",
    logSourceItem: "Source item",
    date: "Date",
    to: "To",
    from: "From",
    trigger: "Trigger",
    status: "Status",
    actions: "Actions",
    viewDetails: "View details",
    retry: "Retry",
    retrySuccess: "Email sent again successfully",
    retryFailed: "Could not retry sending the email",
    emailDetails: "Email details",
    logBodyNotStored:
      "Use «Preview email» to render the message with the current template.",
    previewEmailBody: "Preview email",
    previewEmailBodyLoading: "Loading email preview…",
    previewEmailBodyPreview:
      "Live preview rendered with the current template and record.",
    previewEmailBodyDeleteSnapshot:
      "Preview using data saved before the line was deleted.",
    previewEmailBodyUnavailable: "Preview not available for this entry.",
    previewEmailBodyEndpointMissing:
      "Preview endpoint not found. Restart the backend to load the latest email module.",
    queuedBodyPreview: "Preview is not available until the email is sent.",
    showing: "Showing",
    of: "of",
    allStatuses: "All statuses",
    sent: "Sent",
    pending: "Pending",
    queued: "Queued",
    queuedRetry: "Retrying send",
    sending: "Sending",
    failed: "Failed",
    bounced: "Bounced",
    opened: "Opened",
    clicked: "Clicked",
    error: "Error",

    // Config
    brevoConfig: "Brevo Configuration",
    brevoApiKey: "Brevo API Key",
    apiKeyConfigured: " (configured)",
    enterApiKey: "Enter your Brevo API Key",
    brevoApiKeyHint: "Get your API Key from ",
    testConnection: "Test connection",
    connectionSuccess: "Connection successful",
    connectionFailed: "Connection error",
    account: "Account",
    plan: "Plan",
    enabled: "Enabled",
    disabled: "Disabled",

    senderSettings: "Sender settings",
    defaultSenderEmail: "Sender email",
    defaultSenderName: "Sender name",
    defaultReplyTo: "Reply to",

    generalSettings: "General settings",
    enableEmailSending: "Enable email sending",
    enableEmailSendingHint: "Enable this option to allow sending emails",
    enableTemplatePdf: "Enable Template PDF",
    smartEmailSendModeTitle: "How are emails sent?",
    smartEmailSendModeIntro:
      "Choose how the email goes out when someone clicks «Send by email» on a document or a list.",
    smartEmailModeClientTitle: "From my Outlook (or another email app)",
    smartEmailModeClientDescription:
      "The system builds the whole email (recipients, subject, text in the chosen language and the PDF or Excel attached) and downloads it as a draft. Opening it brings it up in your Outlook ready to send from your mailbox: you just click «Send».",
    smartEmailModeClientPro1: "No passwords, permissions or changes to your company's domain.",
    smartEmailModeClientPro2: "The email goes out from your mailbox and stays in your Sent folder, as usual.",
    smartEmailModeClientCon: "It is not sent by the system itself: it takes one more click in Outlook.",
    smartEmailModeServerTitle: "Directly from the system",
    smartEmailModeServerDescription:
      "The email goes out from our sending server with the sender you set below, without opening your email app.",
    smartEmailModeServerReq:
      "To send it with a company mailbox, whoever manages your domain has to add a few DNS records (DKIM and verification) shown right here, ready to copy. Without them, emails land in spam or get rejected.",
    smartEmailModeServerCon:
      "The email does not stay in your mailbox's Sent folder. To keep a copy, add yourself as a recipient.",
    smartEmailSenderEmail: "Sender (email)",
    smartEmailSenderName: "Sender (name)",
    smartEmailSenderHint:
      "Empty = it goes out from the system's general mailbox. When you set your own mailbox, your domain's DNS records show up below.",
    smartEmailSenderInvalid: "The sender email is not valid.",
    smartEmailDnsTitle: "DNS records for",
    smartEmailDnsIntro:
      "Give these records to whoever manages your domain (or add them yourself at your provider: GoDaddy, Cloudflare, Route 53…). Copy each host and value exactly. Once they are in, click «Verify».",
    smartEmailDnsType: "Type",
    smartEmailDnsHost: "Host / Name",
    smartEmailDnsValue: "Value",
    smartEmailDnsRecordOk: "Record verified",
    smartEmailDnsRecordPending: "Not found yet",
    smartEmailDnsAuthenticated: "Domain verified",
    smartEmailDnsPending: "Records missing",
    smartEmailDnsVerify: "Verify",
    smartEmailDnsVerifyHint: "DNS changes can take a few hours to show up.",
    smartEmailDnsNotYet: "Not all records are visible yet. If you just added them, try again in a while.",
    smartEmailDnsCopied: "Copied",
    smartEmailDraftDownloaded: "Draft ready",
    smartEmailDraftDownloadedText:
      "The email was downloaded as a draft. Open it: it opens in your Outlook with everything filled in and you just click «Send».",
    smartEmailOpenInMailClient: "Open in my email",
    enableSmartEmail: "Enable Smart Email",
    enableSmartEmailHint:
      "Allow sending documents (PDF) and list/report exports (Excel) by email with one click",
    enableTemplatePdfHint: "Allow sending document templates as PDF via email",

    // Orphans (admin only)
    Orphans: "Orphans",
    "Orphans description":
      "Group model documents (e.g. payment_appliedto) that have no parent or whose parent document no longer exists.",
    "Clean all orphans": "Clean all orphans",
    "No orphans found": "No orphans found.",
    orphans: "orphans",
    "Parent model": "Parent model",
    "No parent": "No parent",
    "Failed to load orphans": "Failed to load orphans.",
    "Failed to clean orphans": "Failed to clean orphans.",
    "Are you sure you want to permanently delete all orphans?":
      "Are you sure you want to permanently delete all orphans?",
    "Clean orphans": "Clean orphans",
    Deleted: "Deleted",

    // System Features
    "System Features": "System Features",
    "Base Features": "Base Features",
    "Servers, Usage, Maintenance, Base Functionality":
      "Servers, Usage, Maintenance, Base Functionality",
    "Included in base price": "Included in base price",
    Active: "Active",
    month: "month",
    "Email Features": "Email Features",
    "Automatic Email Sending": "Automatic Email Sending",
    Included: "Included",
    "Manual Document Email Sending": "Manual Document Email Sending",
    "Smart Email": "Smart Email",
    "Smart Email description":
      "Smart Email extends email across the product with attachments and one-click sends. It includes:\n\n- Attach files to emails in general (files already stored in the system), not only auto-generated PDFs\n- Send emails with those attachments from the AI Agent chat as well (ask in natural language)\n- Send document PDFs from templates with one click\n- Send list and report exports as Excel attachments\n- Choose recipients from users, document references, or custom addresses\n- Use email templates and languages\n- Log every send in the email history",
    "Send PDF documents via email from templates":
      "Send PDF documents via email from templates",
    "Included Modules": "Included Modules",
    "Optional Features": "Automations",
    "Active extra modules": "Active extra modules",
    "Container Tracking": "Container Tracking",
    "Track container shipments": "Track container shipments",
    "Coming Soon": "Coming Soon",
    "Total Monthly Price": "Total Monthly Price",
    "Base price": "Base price",
    "Billing month charges title": "This month's charges",
    "Billing month charges hint": "What is charged for this month: base, modules, usage and development. Waived items are a gift: they don't appear on the invoice or the outstanding balance.",
    "Billing month charges provisional": "Current month: usage is up to today and will keep growing.",
    "Billing month charges empty": "Nothing to charge this month.",
    "Billing month charges total": "Month total",
  "Billing month charges paid": "Paid",
  "Billing month charges already paid": "Already paid",
  "Billing month charges due": "Still to collect",
    "Billing waive": "Waive",
    "Base price change hint": "Applies from this month on; earlier months keep the price they had.",
    "Manual Document Emails": "Manual Document Emails",
    "Save Changes": "Save Changes",
    "Error loading features": "Error loading features",
    "Features updated successfully": "Features updated successfully",
    "Error saving features": "Error saving features",
    Billing: "Billing",
    "Current month": "Current month",
    "Billing provisional total hint":
      "Provisional: usage-based lines reflect activity through today.",
    "Billing overdue days":
      "Overdue: {days} day(s) past your monthly due date (day {dueDay} of each month, from service start; no paid month record).",
    "Billing print after month closes":
      "Print/PDF is available after the month closes.",
    "No billing data yet": "No billing data yet.",
    "Download invoice PDF": "Download invoice PDF",
    "View invoice": "View invoice",
    "Print or export": "Print or export",
    "Use the browser print dialog to save as PDF":
      "Use the browser print dialog to save as PDF.",
    "Please allow popups to print the invoice":
      "Please allow popups to print the invoice.",
    Description: "Description",
    Amount: "Amount",
    Total: "Total",
    "Error loading billing": "Error loading billing",
    "Error downloading invoice": "Error downloading invoice",
    "Invoice downloaded": "Invoice downloaded",
    Admin: "Admin",
    "Admin settings for billing and invoicing":
      "Admin settings for billing and invoicing",
    "Service start date": "Service start date",
    "Service start date hint":
      "Date when the client began using the system (used for billing history).",
    "Feature prices (USD/month)": "Feature prices (USD/month)",
    "Admin feature prices hint":
      "Container Tracking price is configured in Container Tracking settings.",
    "Billing excluded developers title": "Exclude developers from billing",
    "Billing excluded developers hint":
      "If Exclude is checked, that developer’s development tasks are not billed on unpaid invoices. Already paid months are not changed.",
    "Billing excluded developers empty": "No board programmers configured.",
    "Billing exclude checkbox": "Exclude",
    Developer: "Developer",
    "Paid months": "Paid months",
    "Paid months hint":
      'Mark months as paid when the client pays. For "Paid in advance", tick what the client already prepaid (base and/or paid modules). Anything not ticked for that month, plus Container Tracking and Development, is billed on the following month. You can add several rows for the same month (e.g. prepaid + a partial payment); amounts and flags are merged for billing. In advance months, punctual amounts first reduce the settlement table balance (e.g. amount brought forward from prior months); any remainder then applies to the current-month usage box (developments before other items in that box).',
    "Advance add month defer hint":
      "Unticked items for that month, plus usage (Container Tracking, Development), appear on the next month.",
    "Paid in advance (items)": "Paid in advance (items)",
    "What client paid in advance": "What client paid in advance",
    Base: "Base",
    "Already paid for this month": "Already paid for this month",
    "Billing punctual payments subtotal": "Punctual payments / credits",
    "Already paid month grand total": "Total already paid this month",
    "Paid in advance total": "Paid in advance total",
    Year: "Year",
    Month: "Month",
    Type: "Type",
    "Paid date": "Paid date",
    Paid: "Paid",
    Unpaid: "Unpaid",
    "Paid in advance": "Paid in advance",
    "Billing to pay type": "To be paid",
    "Billing to pay items label": "Items on the invoice",
    "Billing to pay add hint":
      'Ticked items appear on the invoice total (not as "already paid"). Unticked items defer to the next month. When the client pays, tick "Paid" in the table.',
    "Billing to pay received col": "Paid (items)",
    "Billing to pay admin hint":
      '"To be paid" defines what goes on the invoice. When the client pays, add another row for the same month with type Paid and the amount; the system deducts it from the balance. Any amount above that month’s balance is applied automatically to later months in order.',
    "Paid amount hint":
      "Amount paid on that date. If it exceeds that month’s balance, the remainder is applied to later months in chronological order.",
    "Billing invoice settlement section": "Settlement",
    "Billing invoice current period charges title": "Development charges — {period}",
    "Billing invoice monthly to pay title": "Monthly fee (to be paid)",
    "Billing invoice extra lines title": "Extra invoice lines",
    "Billing invoice extra lines hint":
      "Manual lines per month (description and amount). They appear on that month’s invoice and are not tied to system usage. A discount subtracts its amount from what is owed that month; any excess does not carry over to the next month.",
    "Billing invoice extra lines empty": "No extra lines registered.",
    "Billing invoice extra lines section": "Additional items",
    "Billing invoice extra line kind": "Type",
    "Billing invoice extra line kind charge": "Charge",
    "Billing invoice extra line kind discount": "Discount",
    "Billing invoice discounts section": "Discounts",
    "Remaining amount (depends on usage)":
      "Remaining amount (depends on usage)",
    "PDF not available for advance-paid months":
      "PDF not available for advance-paid months.",
    "Billing advance PDF monthly only hint":
      "The printable invoice lists only the monthly prepaid service (not usage-based charges).",
    "Billing advance print two docs hint":
      "Invoice (amount due) = settlement only; Prepayment receipt = proof of prepayment and credits.",
    "Billing advance no PDF hint":
      "Print/PDF lists only the monthly prepaid service; usage-based charges stay in the summary below.",
    "Billing advance remaining hint":
      "Base prepaid. Below: amounts carried from prior months and/or usage for this period.",
    "Billing advance lines hint":
      "This table is the current settlement: balance brought forward and other charges. The fieldset above only shows this month’s usage that will be invoiced next month.",
    "Billing print settlement invoice": "Invoice (amount due)",
    "Billing print payment receipt": "Receipt",
    "Billing print prepaid receipt": "Prepayment receipt",
    "Billing payment receipt title": "Payment receipt",
    "Billing payment receipt intro":
      "Proof of payments received. The issued invoice keeps the original amount.",
    "Billing payment receipt line": "Payment received",
    "Billing standard invoice doc title": "Invoice",
    "Billing invoice start number": "Starting invoice number",
    "Billing invoice start number placeholder": "e.g. 1001",
    "Billing invoice start number hint":
      "First invoice number. Each billing month increases by 1 in chronological order.",
    "Billing invoice period fixed charges title": "Period fee (gross amount)",
    "Billing invoice period usage charges title": "Period usage — {period}",
    "Billing settlement invoice doc title": "Invoice — settlement",
    "Billing settlement invoice doc intro":
      "Amount owed on this settlement. The monthly fee covered by prepayment and other logged payments is documented on the separate prepayment receipt.",
    "Billing settlement receipt pointer":
      "For proof of prepayment and on-account payments, also print “Prepayment receipt”.",
    "Billing prepaid receipt doc title": "Receipt — prepayment & credits",
    "Billing prepaid receipt doc intro":
      "Record of payments already logged (prepaid service fee and on-account payments). This is not an additional charge and does not replace the settlement invoice if a balance is due.",
    "Billing prepaid receipt total paid": "Total paid this period",
    "Billing invoice prepaid reference section title":
      "Already paid — reference only",
    "Billing invoice prepaid reference section hint":
      "Record of what is covered by prepayment and logged payments; it does not add to the amount due in the section above.",
    "Billing invoice subtotal prepaid reference":
      "Subtotal (reference, already paid)",
    "Billing invoice settlement section title": "Amount due",
    "Billing invoice settlement section hint":
      "This is the part of the document that shows the outstanding balance (e.g. from prior months). It should match the settlement total on the Billing screen.",
    "Billing invoice total due": "Total due",
    "Billing invoice no settlement lines": "No balance due on this settlement.",
    "Billing invoice provisional settlement":
      "Provisional settlement as of the issue date.",
    "Remaining total": "Remaining total",
    Upcoming: "Upcoming",
    "No paid months": "No paid months",
    Add: "Add",
    "Invoice company data": "Invoice company data",
    "Invoice company data hint":
      "Your company details for future invoice generation.",
    "Company name": "Company name",
    "VAT number": "VAT number",
    Address: "Address",
    "Address line 2": "Address line 2",
    City: "City",
    "Postal code": "Postal code",
    Country: "Country",
    "Admin settings updated successfully":
      "Admin settings updated successfully",
    "Accounting Module": "Accounting Module",
    "Template PDF Module": "Template PDF Module",
    "Finance Module": "Finance Module",
    "Excel Export": "Excel Export",
    "Calendar Sync": "Calendar Sync",
    "Support technical AI module": "Technical support AI",
    "Support technical AI module description":
      "Technical support assistant in the web chat (and on Telegram when AI Agent is enabled). Keyword rules are shared by all users. Manage My rules here when the Support module is active.",
    "Support technical AI module inactive hint":
      "Activate the Support module under System modules to use the support chat and edit rules.",
    "Base features description":
      "Cloud infrastructure hosting your database and application. Includes server management, automatic backups, security updates, SSL certificates, and 24/7 system monitoring. All technical maintenance and infrastructure costs are covered.",
    "Automatic emails description":
      "Email automation system with triggers and scheduled emails. Create email templates with dynamic data from your models, set up triggers that send emails automatically when documents are created/updated (e.g., send invoice when proforma is confirmed), schedule recurring emails, and track all sent emails in the email log. Uses Brevo (Sendinblue) for reliable email delivery.",
    "Manual emails description":
      "Send PDF documents directly from any document template (proformas, invoices, etc.) via email with one click. Select recipients from system users, automatically extract emails from document references (client emails, contact emails), or enter custom addresses. Customize email subject and body before sending. All sent emails are logged with PDF attachments in the email history.",
    "Container tracking description":
      "Uses the Exportai API to track containers, bookings, or bills of lading. You register a tracking number and type; the system receives status updates via webhook or on-demand. Link each tracking to your documents (e.g. Shipping) and define a mapping from tracking fields (origin, destination, status, carrier, etc.) to your model fields. When data is received, linked documents are updated automatically and aftersave hooks run (e.g. to refresh shipping status). Billing is per active tracking per month.",
    "Accounting module description":
      "Complete double-entry accounting system. Create journal entries with debits and credits, generate balance sheets showing assets, liabilities, and equity, create profit & loss statements, and produce financial reports. All accounting entries are linked to your business documents (invoices, payments, expenses) for automatic reconciliation.",
    "Template PDF module description":
      "Professional PDF document generation from customizable HTML templates. Design templates for proformas, invoices, shipping documents, and any other document type using HTML/CSS. Templates support dynamic data insertion from your models, calculations, conditional formatting, and custom styling. Export documents to PDF with perfect formatting for printing or emailing.",
    "Finance module description":
      "Comprehensive financial management system. Track all payments (received and made), manage expenses with categorization, generate bank account statements and general account statements, create financial summaries by contact/client, analyze cash flow, and generate financial reports. All financial data is linked to your business documents for complete traceability.",
    "Excel export description":
      "Export any dynamic list or report to Excel format (.xlsx). Preserves formatting, includes all columns and filters, supports large datasets, and maintains data types. Perfect for external analysis, sharing with accountants, or creating custom reports in spreadsheet applications.",
    "Calendar sync description":
      "Two-way synchronization with external calendar applications (Google Calendar, Outlook, iCal). Sync deadlines, events, and important dates from your documents to your calendar. View and manage your business schedule directly from your calendar app. Supports multiple calendar accounts and automatic updates.",
    "Dashboard widgets": "Dashboard widgets",
    "Dashboard widgets description":
      "Customizable dashboard made of widgets: each user arranges their own grid with lists, totals and financial indicators, and can share dashboards with the rest of the team.",
    "Change history and trash": "Change history and trash",
    "Change history description":
      "Every document keeps a history of who changed what and when. A daily activity view summarizes creations and edits, and deleted records go to the trash, from where they can be restored.",
    "Users, roles and permissions": "Users, roles and permissions",
    "Roles and permissions description":
      "Users with roles. Define per role which screens, lists and fields each person can see or edit, and which actions they can perform.",
    "Excel import": "Excel import",
    "Excel import description":
      "Load data from Excel files: map spreadsheet columns and cells to the fields of your forms and import many records at once, without typing them one by one.",
    "Exchange rates": "Exchange rates",
    "Exchange rates description":
      "Official daily exchange rate of each currency against the US dollar, updated automatically (BCRA, with Frankfurter as backup), to convert amounts in documents and reports.",
    "Notifications and alerts": "Notifications and alerts",
    "Notifications description":
      "In-app notifications when something that concerns you happens (new documents, assignments, due dates, tickets). Each user chooses which notices they want to receive.",
    "Mobile version": "Mobile version",
    "Mobile version description":
      "The system adapts to phones: lists, forms and menus are designed for small screens so you can check and load data from anywhere, with no app to install.",
    "Multi-language": "Multi-language",
    "Multi-language description":
      "Each user chooses the interface language (Spanish, English and more). Interface texts can be adjusted for your company.",
    "«On the web» for contacts and products": "«On the web» for contacts and products",
    "Web lookup description":
      "When opening a contact or product, the system looks up public information on the web and completes the logo or photo if it is missing.",
    "Support tickets and meetings": "Support tickets and meetings",
    "Support tickets description":
      "Report errors or request changes with support tickets, follow their status and comments, and book video meetings with the support team from the system itself.",
    testMode: "Test mode",
    testModeHint: "In test mode, all emails are sent to the test email",
    testEmail: "Test email",
    testEmailPlaceholder: "test@example.com",
    testEmailHint: "All emails will be sent to this address in test mode",

    rateLimits: "Rate limits",
    maxEmailsPerHour: "Max emails per hour",
    maxEmailsPerDay: "Max emails per day",
    currentUsage: "Current usage",
    hour: "hour",
    day: "day",

    sendTestEmail: "Send test email",
    testRecipient: "Test recipient",
    enterEmail: "Enter an email",
    sendTest: "Send test",
    testEmailSent: "Test email sent successfully",

    saveConfiguration: "Save Configuration",
    configSaved: "Configuration saved successfully",
    senderRequired: "Sender email and name are required",
    requiredFields: "Please complete all required fields",
    errorLoading: "Error loading data",
    errorSaving: "Error saving",
    errorDeleting: "Error deleting",

    errorToggling: "Error changing status",

    // Scheduled triggers
    nextExecution: "Next execution",
    runNow: "Run now",
    runTriggerNow: "Run trigger",
    confirmRunTrigger: "Do you want to run the trigger '{name}' now?",
    triggerExecuted: "Trigger executed successfully",
    triggerExecutionFailed: "Trigger execution partially failed",
    errorRunningTrigger: "Error running trigger",
  },

  // Calendar Sync
  notificationPrefs: {
    all: "All",
    title: "My notifications",
    intro: "Choose which notifications you get. Nothing changes for other users.",
    mobileApp: "Mobile app",
    email: "Email",
    emailNote: "If you turn off an email, the phone notification still reaches you as long as it is on above.",
    noEmails: "There are no automatic emails active in this company.",
    deviceEnable: "Enable on this device",
    deviceDisable: "Disable on this device",
    device: {
      on: "Notifications are enabled on this device.",
      off: "Notifications are not enabled on this device.",
      "needs-install": "On iPhone, notifications only work with the app installed on the home screen.",
      unsupported: "This browser does not support notifications. Enable them from the phone app.",
    },
    groups: {
      Pagos: "Payments",
      Cobros: "Collections",
      Soporte: "Support",
      Novedades: "What's new",
      other: "Other notifications",
    },
    pushOnly: {
      "agent-chat": {
        name: "AI Agent replies",
        description: "When the AI Agent finishes answering you in the chat.",
      },
      "agent-proposals": {
        name: "AI Agent daily suggestions",
        description: "Monday to Friday at 9, what the assistant suggests to start your day.",
      },
      "other-emails": {
        name: "Other emails",
        description: "Any other system email you receive (triggers, manual sends…).",
      },
    },
  },

  calendarSync: {
    syncWithGoogleCalendar: "Sync with Google Calendar",
    syncCalendar: "Sync Calendar",
    calendarSynchronization: "Calendar Synchronization",
    syncDescription:
      "Sync your events with Google Calendar, Outlook, or any calendar app that supports iCal feeds.",
    yourCalendarFeedUrl: "Your Calendar Feed URL",
    copyUrl: "Copy URL",
    urlCopied: "URL copied to clipboard",
    created: "Created",
    lastSync: "Last sync",
    syncCount: "Sync count",
    howToAddToGoogleCalendar: "How to add to Google Calendar?",
    copyTheUrl: "Copy the URL",
    copyUrlDescription:
      "Click the copy button above to copy your personal calendar URL.",
    openGoogleCalendar: "Open Google Calendar",
    goTo: "Go to",
    addCalendarByUrl: "Add calendar by URL",
    addCalendarByUrlDescription:
      'In the left sidebar, click the + next to "Other calendars". Select "From URL"',
    pasteTheUrl: "Paste the URL",
    pasteUrlDescription: 'Paste the copied URL and click "Add calendar"',
    done: "Done!",
    doneDescription:
      "Your events will appear in Google Calendar. It may take a few minutes for the first sync.",
    note: "Note",
    syncNote:
      "Google Calendar typically updates external calendars every 12-24 hours. You can force a refresh by removing and re-adding the calendar.",
    eventsTimeframeNote:
      "Events from 30 days ago onwards will be shown. Events older than 30 days will gradually disappear from your calendar as they pass that threshold, this prevents the sync from accumulating old events which would cause slow loading times.",
    otherCalendarApps: "Other Calendar Apps",
    outlookInstructions:
      "Settings → Calendar → Shared calendars → Subscribe from web",
    appleCalendarInstructions: "File → New Calendar Subscription",
    thunderbirdInstructions: "New Calendar → On the Network → iCalendar (ICS)",
    regenerateUrl: "Regenerate URL",
    regenerateWarning:
      "Use this if your URL was compromised. The old URL will stop working.",
    regenerateUrlConfirm: "Regenerate URL?",
    regenerateUrlWarning:
      "The current URL will stop working. You will need to update the URL in all your calendar apps.",
    yesRegenerate: "Yes, regenerate",
    urlRegenerated: "URL regenerated successfully",
    errorLoadingConfig: "Error loading sync configuration",
    errorRegeneratingUrl: "Error regenerating URL",
    close: "Close",
    regenerating: "Regenerating...",
  },

  // Instance Builder
  instanceBuilder: {
    title: "Instance Builder",
    subtitle:
      "Describe what application you need and AI will generate the configuration",
    describeApp: "Describe your application",
    placeholder:
      "E.g.: I need a system to manage a real estate agency with properties, clients, contracts and payments...",
    orChooseExample: "Or choose an example:",
    generate: "Generate configuration",
    generating: "Generating...",
    waitMessage:
      "AI is processing your request. This may take up to 2 minutes...",
    modifyConfig: "Modify configuration",
    generatedConfig: "Generated configuration",
    simpleView: "Simple view",
    viewJson: "View JSON",
    lists: "Lists",
    models: "Models",
    fields: "fields",
    values: "values",
    startOver: "Start over",
    previewChanges: "Preview changes",
    applyConfig: "Apply configuration",
    applying: "Applying...",
    configApplied: "Configuration applied!",
    modelsCreated: "Models created",
    listsCreated: "Lists created",
    viewModels: "View models",
    createMore: "Create more",
    newModels: "New models",
    newLists: "New lists",
    none: "None",
    overwriteExisting: "Overwrite existing models/lists",
    cancel: "Cancel",
    confirmApply: "Confirm and apply",
    chatPlaceholder: "E.g.: Add a phone field to the Client model...",
    configGenerated:
      "I've generated a configuration with {models} models and {lists} lists. Do you want to make any changes?",
    changesAdded:
      "I've added the changes to the configuration. You can see them in the right panel.",
    modified:
      "I've modified {target}. The changes are reflected in the configuration.",
    deleted: "I've deleted {target} from the configuration.",
    notUnderstood:
      "I didn't quite understand what change you want to make. Can you be more specific?",
    chatError: "There was an error processing your message. Please try again.",
    // Suggestions
    suggestions: {
      realEstate: "Real Estate",
      realEstateDesc:
        "Real estate management system with properties, owners, interested clients, rental and sale contracts, and payment tracking",
      gym: "Gym",
      gymDesc:
        "Gym system with clients, memberships, classes, instructors, and attendance tracking",
      veterinary: "Veterinary",
      veterinaryDesc:
        "Veterinary clinic system with pets, owners, medical history, vaccines, appointments and treatments",
      restaurant: "Restaurant",
      restaurantDesc:
        "Restaurant system with tables, reservations, orders, menu with dishes and categories, and billing",
      school: "School",
      schoolDesc:
        "School system with students, teachers, subjects, grades, attendance and announcements",
      ecommerce: "E-commerce",
      ecommerceDesc:
        "Online store with products, categories, customers, orders, cart and payment methods",
    },
  },

  // Support Module Translations
  "Ticket Type": "Ticket Type",
  Bug: "Bug",
  Development: "Development",
  Deploy: "Deploy",
  Deployed: "Deployed",
  "Deploy feature to main": "Deploy feature to main",
  "This will merge only this feature branch into main":
    "This will merge only this feature branch into main",
  "Feature merged to main": "Feature merged to main",
  "Feature branch": "Feature branch",
  "Categorize ticket": "Categorize ticket",
  "Open in new tab": "Open in new tab",
  "Branch status": "Branch status",
  "Ready for test": "Ready for test",
  Ready: "Ready",
  "Resolved all": "Resolved all",
  "Move all Ready tickets to Resolved": "Move all Ready tickets to Resolved",
  "Move {count} Ready tickets to Resolved?":
    "Move {count} Ready tickets to Resolved?",
  "{count} of them have no feature assigned":
    "{count} of them have no feature assigned",
  "{resolved} resolved, {failed} failed": "{resolved} resolved, {failed} failed",
  "Task without feature": "Task without feature",
  "Closing task without feature warning":
    "You are about to close a task that has no feature assigned, are you sure? You may not be able to find your work later on.",
  "Task done directly on main branch":
    "This task was done directly on the main branch, no feature was created",
  "Moving...": "Moving...",
  "Change status of selected": "Change status of selected",
  "Apply status": "Apply status",
  "Move {count} tickets to {status}?": "Move {count} tickets to {status}?",
  "None of the selected tickets can change to {status}":
    "None of the selected tickets can change to {status}",
  "{updated} updated, {failed} failed": "{updated} updated, {failed} failed",
  "Check the box to continue": "Check the box to continue",
  "Change ticket status?": "Change ticket status?",
  // Soporte: un admin comenta a nombre de otro usuario (onBehalfOf)
  "Comment as…": "Comment as…",
  "Myself": "Myself",
  "Choose the new status for this ticket.": "Choose the new status for this ticket.",
  "Current status": "Current status",
  "Choose a status": "Choose a status",
  "Not started yet": "Not started yet",
  "In development — emails the ticket participants": "In development — emails the ticket participants",
  "Waiting for the user's answer — daily reminder": "Waiting for the user's answer — daily reminder",
  "Ready to test — emails the ticket participants": "Ready to test — emails the ticket participants",
  "Done and deployed — emails the ticket participants": "Done and deployed — emails the ticket participants",
  "Resolved — closes the ticket, no more comments": "Resolved — closes the ticket, no more comments",
  "Change status": "Change status",
  "Keep current status": "Keep current status",
  "Merged to main": "Merged to main",
  "Deploy failed": "Deploy failed",
  "Open test link": "Open test link",
  Features: "Features",
  "Features in test": "Features in test",
  "Waiting in test": "Tickets waiting in test",
  "No tickets waiting in test": "There are no tickets waiting in test",
  "Error loading tickets waiting in test":
    "Error loading tickets waiting in test",
  "Assign feature": "Assign feature",
  "Assign a feature first": "Assign a feature first",
  "No feature": "No feature",
  "Feature assigned to ticket": "Feature assigned to ticket",
  "Error assigning feature": "Error assigning feature",
  "No related ticket": "No related ticket",
  Ticket: "Ticket",
  "No pending features in test": "No features pending in test",
  "No commits": "No commits",
  "Error loading pending features": "Error loading pending features",
  "Create test version": "Create test version",
  "Update test": "Update test",
  "Create test version confirm":
    "This will create the database {db} as a full copy of production. It may take several minutes.",
  "Update test confirm":
    "This will replace {db} with a full copy of production. Existing test data will be overwritten. It may take several minutes.",
  "Test environment created": "Test environment created",
  "Test environment updated": "Test environment updated",
  "Error syncing test environment": "Error syncing test environment",
  "Report an error or issue": "Report an error or issue",
  "Request a new feature or development":
    "Request a new feature or development",
  Important: "Important",
  "Developments are governed by the terms of service":
    "Developments are governed by the terms of service",
  "View Terms of Service": "View Terms of Service",
  "View Terms": "View Terms",
  "Terms of Service": "Terms of Service",
  "Please read and understand our terms of service":
    "Please read and understand our terms of service",
  "No terms of service available": "No terms of service available",
  "The terms of service have not been configured yet":
    "The terms of service have not been configured yet",
  "Error loading terms of service": "Error loading terms of service",

  // Month names
  January: "January",
  February: "February",
  March: "March",
  April: "April",
  May: "May",
  June: "June",
  July: "July",
  August: "August",
  September: "September",
  October: "October",
  November: "November",
  December: "December",

  // Development translations
  "No completed developments found": "No completed developments found",
  "There are no completed developments yet":
    "There are no completed developments yet",
  Completed: "Completed",
  "Completed Date": "Completed Date",
  "Support completed date hint":
    "Used for monthly summaries and completed lists. When marking as Resolved, leave empty to use the current time; set a date to backdate or correct reporting.",
  hours: "hours",
  "Ticket resolution": "Ticket resolution",
  "Reply to this conversation": "Reply to this conversation",
  "Write your reply...": "Write your reply...",
  "Send reply": "Send reply",
  Topics: "Topics",
  "Topic completed": "Topic completed",
  "Topic title": "Topic title",
  "Topic title is required": "Topic title is required",
  "Create topic": "Create topic",
  "Error creating topic": "Error creating topic",
  "Topic created": "Topic created",
  "Delete topic": "Delete topic",
  "Delete topic confirm": "Delete this topic and its replies?",
  "Error deleting topic": "Error deleting topic",
  "Error updating topic": "Error updating topic",
  "Reply to this topic...": "Reply to this topic...",
  "Leave a comment on this ticket": "Leave a comment on this ticket",
  "Send comment": "Send",
  "Close all topics": "Close all topics",
  "Close all topics confirm": "Mark the {n} open topics as completed?",
  "Closed topics count": "{n} closed",
  "Reply to comment": "Reply to this comment",
  "Reply to this comment...": "Reply to this comment...",
  "Create task": "Create task",
  "Create ticket": "Create ticket",
  "This topic is handled in this task": "This topic is handled in this task",
  "This task comes from a topic in": "This task comes from a topic in",
  "This task comes from a comment in": "This task comes from a comment in",
  "View source comment": "View source comment",
  "View source topic": "View source topic",
  "Ticket created from comment": "Ticket created from comment",
  "Error creating ticket from comment": "Error creating ticket from comment",
  "Are you sure you want to create a task based on this comment?":
    "Are you sure you want to create a task based on this comment?",
  "Task created from topic": "Task created from topic",
  "Error creating task from topic": "Error creating task from topic",
  "Resolved tickets cannot receive comments":
    "This ticket is already resolved. No further comments can be added.",
  "Creating...": "Creating...",
  "See more": "See more",
  "See less": "See less",

  // Translation module
  translations: {
    title: "Translations",
    subtitle:
      "Override texts by admin (all clients) or by this client (dbName).",
    priorityHelp:
      "Priority: 1) This client override (dbName), 2) Admin override (all), 3) Front .js files.",
    seeInAppHint:
      "When you save, translations apply in this session. If you don't see them in another tab or session, refresh the page (F5); you don't need to log out.",
    forAllClients: "For all clients (admin)",

    locale: "Locale",
    key: "Key",
    value: "Value",
    addOverride: "Add override",

    save: "Save",

    loading: "Loading...",

    confirmDelete: "Delete override",

    searchKeyPlaceholder: "Search by key or text...",

    keyPlaceholder: "e.g. client or tutorial.welcome.title",
    noKeysMatch: "No keys or no matches for search",

    originalValue: "Original value",
    yourOverride: "Your translation / override",
    removeOverride: "Remove override",
    overridePlaceholder: "Type to override",
    bulkReplace: "Bulk replace",
    bulkReplaceHelp:
      "Replace a word or phrase in all keys that contain it. Overrides will be created or updated with the replaced text. The search field also filters the list (including keys that only have a translation in another language), so you can use it just to find keys.",
    replaceSearch: "Search text",
    replaceSearchPlaceholder: "e.g. client",
    replaceWith: "Replace with",
    replaceWithPlaceholder: "e.g. buyer",
    bulkReplaceNoMatch: "No keys contain that text.",
    bulkReplacePreview:
      '{count} key(s) contain "{search}". They will be updated with the replacement.',
    applyReplace: "Apply replace",
    applying: "Applying",
    bulkReplaceConfirm:
      'Apply replace in {count} key(s)? "{search}" → "{replacement}"',
    empty: "(empty)",
    done: "Done",
    bulkReplaceDone: "Replace applied to {count} key(s).",

    replaceResult: "Result:",
    caseSensitive: "Case sensitive",
    wholeWord: "Whole word",
    showingOnlyReplaceMatches:
      'Showing only the {count} key(s) containing "{search}" (the ones that will be replaced).',
  },

  shippingExpenses: {
    copyToShipping: "Copy to shipping",
    copyToShippingTitle: "Copy expenses to shipping",
    copyToShippingIntro:
      "Selected expenses will be copied without payments to one or more shippings. {count} expense(s) selected.",
    copyToShippingSuccess:
      "{count} expense copy/copies created across {shippingCount} shipping(s).",
    copyToShippingError: "Could not copy expenses.",
  },

  findTeu: {
    // Automatic deactivation when the shipment ends (billing depends only on it being active)
    autoStopInfo:
      "Each tracking deactivates itself when the shipment ends: when every container reaches the destination port, when the shipping line marks them as finished, or when the ETA passed more than {days} days ago with no news. From then on it is no longer billed.",
    autoStopBadge: "Deactivated automatically",
    autoStopReason_arrived: "All containers arrived at destination{port} on {date}.",
    autoStopReason_completed: "The shipping line marked all containers as finished{port}.",
    autoStopReason_eta_overdue: "The ETA ({date}) passed more than {days} days ago and the shipping line did not report the arrival.",
    autoStopDisabledBadge: "Won't deactivate automatically",
    autoStopDisabledTitle: "It was reactivated manually: it stays active, and billed, until someone stops it.",
    autoStoppedUseReactivate:
      "This tracking deactivated itself because the shipment ended. If you want to keep following it, reactivate it from the stopped tab.",
    reactivate: "Reactivate",
    reactivateTitle: "Reactivate tracking {number}?",
    reactivateText:
      "If you reactivate it manually, this tracking will no longer deactivate itself when the shipment ends: it will stay active, and billed, until you stop it.",
    reactivateConfirm: "Yes, reactivate",
    reactivatedTitle: "Tracking reactivated",
    reactivatedText: "Remember to stop it when you no longer need it.",
    containerTracking: "Container Tracking",
    modelMappingTitle: "Automatic mapping by model",
    modelMappingIntro:
      "One or more sources (field + type) per model, in priority order. When tracking starts they are tried in order until Exportai accepts one. Nothing runs until the rule is saved; on save it starts, asks, or waits for a manual start, depending on the chosen mode.",
    startFromItem: "Start from item",
    startFromItemTitle: "Start tracking from item",
    startFromItemIntro:
      "Choose a model with automatic mapping, search an item, and start tracking from here.",
    startFromItemNoModels:
      "No models with automatic mapping yet. Configure one in the section below first.",
    startFromItemSearch: "Search",
    startFromItemSearchPlaceholder: "Name or text…",
    startFromItemSearchBtn: "Search",
    startFromItemSkipped: "Tracking was not started (no valid number or already active).",
    startFromItemScacNone: "no carrier",
    startFromItemScacNoneHint:
      "The item has no carrier: fill the configured carrier field to start tracking.",
    startFromItemNoNumberBlocked: "The item has no tracking number.",
    startFromItemNoScacBlocked:
      "Booking and BL need the carrier: fill it on the item to start tracking.",
    modelMappingAdminNoteTitle: "Before you start: the carrier field",
    modelMappingAdminNoteBadge: "admin only",
    modelMappingAdminNoteBody1:
      "The «Exportai — Carrier (SCAC)» list is created on its own when the module is enabled, but the field is not. To be able to pick the carrier, add a list-type field (usually «scaccode») pointing to that list.",
    modelMappingAdminNoteBody2:
      "It normally lives on the carrier record — a contact-type model — and the tracked model points at it through a reference (e.g. shipping_line.scaccode). It can also sit directly on the tracked model. Without that field, step 3 only offers loose text fields.",
    modelMappingSavedTitle: "Models with tracking mapping",
    modelMappingNone: "No model starts tracking automatically yet. Add one below.",
    modelMappingRowSources: "sources:",
    modelMappingRowScac: "carrier:",
    modelMappingRowScacAuto: "auto-detected",
    onSaveModeLabel: "On save:",
    onSaveModeAuto: "Automatic",
    onSaveModeAsk: "Ask",
    onSaveModeManual: "Manual",
    onSaveModeAutoHelp: "Every time an item with a tracking number is saved, tracking starts on its own.",
    onSaveModeAskHelp: "When an item with a tracking number and no active tracking is saved, a prompt asks whether to start it.",
    onSaveModeManualHelp: "Saving does nothing: tracking is started by hand, with «Start from item» or the bulk start.",
    askOnSaveTitle: "Start tracking?",
    askOnSaveText: "This item has number {number} ({type}) and no active tracking yet. Start it now?",
    askOnSaveConfirm: "Yes, start",
    askOnSaveCancel: "Not now",
    askOnSaveStarting: "Starting tracking…",
    modelMappingEditRow: "Edit",
    modelMappingEditorTitleNew: "Add a model",
    modelMappingEditorTitleEdit: "Editing «{model}»",
    modelMappingStepModel: "1. Model",
    modelMappingStepSources: "2. Tracking sources (priority order)",
    modelMappingSourcesHint:
      "E.g. 1) container, 2) booking, 3) BL. If the item only has a BL, that row is used even when earlier rows are empty.",
    modelMappingAddSource: "Add source",
    modelMappingSelectModel: "Model",
    modelMappingPickModel: "Choose model…",
    modelMappingPickTrackingField: "Choose field…",
    modelMappingStepScac: "3. Carrier (SCAC)",
    modelMappingScacQuestion: "Where does the carrier come from?",
    modelMappingScacModeNone: "Do not send it — Exportai detects the carrier",
    modelMappingScacModeDirect: "A field on this model",
    modelMappingScacModeReference: "A field on a referenced model",
    modelMappingScacGroupList: "Carrier (SCAC) list fields",
    modelMappingScacGroupOther: "Other text fields",
    modelMappingScacPickDirect: "Choose field…",
    modelMappingScacPickReference: "Choose reference…",
    modelMappingScacPickNested: "Carrier field inside the reference…",
    modelMappingScacPathPreview: "Saved as:",
    modelMappingScacIncomplete:
      "Pick the field: as it stands, the rule would be saved with no carrier.",
    modelMappingScacAutodetect:
      "With no carrier field, Exportai detects it — or the first text field that looks like a SCAC is sent. Choosing the field is faster and safer.",
    modelMappingApply: "Save and enable",
    modelMappingUnsaved: "Not saved yet: this rule runs only after «Save and enable».",
    modelMappingFieldsHint:
      "For booking/BL the carrier is optional, but a «Carrier (SCAC)» list field is faster and more reliable than letting it be detected.",
    modelMappingApplied:
      "Mapping saved. The selected model fields will be used.",
    viewTrackingFromField: "View Exportai tracking",
    modelMappingResultRows: "mappings",
    modelMappingResultButton: "Map → item",
    modelMappingResultModalTitle: "Update item when tracking changes",
    modelMappingResultModalHelp:
      "Choose which Exportai result paths copy into model fields. Applied on daily sync (cron) and when new API data is fetched. If empty, the global mapping from the tracking detail view (legacy) is used.",
    modelMappingPickPath: "Choose path…",
    modelMappingAddRow: "Add row",
    modelMappingResultSaved:
      "Mapping saved. Linked items will update when tracking data changes.",
    bulkStartTracking: "Start tracking",
    bulkStartTrackingTitle: "Bulk start Exportai tracking",
    bulkStartTrackingIntro:
      "Each selected item is processed in parallel using the automatic mapping configured for this model.",
    bulkStartItem: "Item",
    bulkStartDetail: "Detail",
    bulkStartLaunch: "Start",
    bulkStartRunning: "Processing…",
    bulkStartSummary: "Done: {started} started, {skipped} skipped, {errors} with errors.",
    bulkStartStatusPending: "Pending",
    bulkStartStatusRunning: "Processing",
    bulkStartStatusStarted: "Started",
    bulkStartStatusSkipped: "Skipped",
    bulkStartStatusError: "Error",
    bulkStartStartedOk: "Tracking started",
    bulkStartAlreadyActive: "Tracking already active",
    bulkStartSkipNoCandidates: "No tracking number in configured fields",
    bulkStartSkipNoApiKey: "Exportai API key not configured",
    bulkStartSkipNoRule: "No Exportai mapping for this model",
    addTracking: "Add Tracking",
    startNewTracking: "Start New Tracking",
    trackingType: "Tracking Type",
    bookingNumber: "Booking Number",
    containerNumber: "Container Number",
    billOfLading: "Bill of Lading",
    scacCode: "SCAC code",
    scacPlaceholder: "e.g. MSCU, MAEU",
    scacHelp: "Optional: the system can auto-detect the carrier. Select one if you know it for faster results.",
    scacSelectCarrier: "Select carrier...",
    scacAutoDetect: "Auto-detect carrier",
    scacOther: "Other (enter code)",
    scacRequired: "SCAC required",
    scacRequiredHelp:
      "Please select the carrier or enter the SCAC code for booking/BL.",
    bookingLabel: "Booking",
    containerLabel: "Container",
    blLabel: "B/L",
    trackingNumber: "Tracking Number",
    searchInDatabase: "Search in database",
    start: "Start",
    supportedCarriers: "Supported Shipping Carriers",
    supportedCarriersDescription:
      "We track containers from the following major shipping carriers and leasing companies:",
    loading: "Loading...",
    loadingTrackingInfo: "Loading tracking information...",
    tryAgain: "Try Again",
    origin: "Origin",
    destination: "Destination",
    status: "Status",
    linkedItems: "Linked items",
    shippingColumn: "Shipping No.",
    openLinkedShipping: "Open shipping",
    lastUpdated: "Last Updated",
    actions: "Actions",
    editLinkedItems: "Edit linked items",
    na: "N/A",

    noActiveTrackings: "No Active Trackings",
    noActiveTrackingsHint:
      'Start tracking a container by clicking "Add Tracking" button above.',
    trackingDetails: "Tracking Details",
    close: "Close",

    type: "Type",
    carrierScac: "Carrier (SCAC)",
    lastUpdatedLabel: "Last updated",
    carrierDataAsOf: "Last change reported by the carrier",
    hintsTitle: "What to check, in this order:",
    hint_check_number_typo: "That the number matches the carrier's document exactly. One digit off is the most common cause.",
    hint_booking_too_new: "If the booking is very recent it may not be in the system yet. In that case the number is fine and you should retry in a day or two.",
    hint_check_carrier_field: "That the shipment's carrier (SCAC) is the right one for that number.",
    hint_try_without_scac: "Try leaving the carrier empty: the provider will attempt to detect it.",
    hint_wait_and_retry: "This is a temporary problem on the provider's or the carrier's side. Retry in a few minutes.",
    hint_check_api_key: "This is an account or API key problem, not a shipment problem. Check the module configuration.",
    milestoneColumn: "Next milestone",
    milestoneNext: "{date} {action} {port}",
    milestoneOverdue: "{days}d overdue: {action} {port}",
    milestoneEtaOverdue: "ETA {days}d overdue",
    milestoneLastActual: "Last confirmed event: {date} {action} {port}",
    milestoneHint: "While the next milestone is still in the future, having no news is expected. The carrier only reports when something happens.",
    syncErrorBadge: "error {code}",
    syncErrorTooltip: "The last sync attempt failed with error {code}: {text}. That is why the carrier data is not moving. Fix the configuration (for example the carrier/SCAC) and use Refresh to check.",
    pendingValueNow: "now",
    pendingValueWouldBe: "would become",
    updateHistoryArrowLegend: "In each line, the value on the left is the previous one and the value on the right is the new one.",
    carrierDataAsOfColumn: "Last change",
    carrierDataAsOfTooltip: "Date of the last change the carrier reported. Exportai checks every 6 to 48 hours depending on the stage of the journey, but only produces new data when something changed: an old date means no news, not that nobody checked.",
    carrierDataAgeHours: "{hours}h ago",
    refreshFromCarrier: "Refresh",
    refreshFromCarrierTitle: "Query Exportai now, without waiting for the daily cron. Returns the latest snapshot Exportai has from the carrier.",
    refreshNoChangesTitle: "No changes",
    refreshNoChangesText: "Exportai has no newer data. Its carrier snapshot is still from {ts}.",
    refreshChangesTitle: "Data updated",
    refreshChangesText: "{summary}. Changes are pending your validation.",
    refreshErrorTitle: "Could not refresh",
    refreshRefetchAsked: "The carrier was asked to report again. The final value may arrive a few seconds later; reopen the tracking to see it.",
    completed: "Completed",
    inTransit: "In Transit",
    terminal: "Terminal",
    portOfLoading: "Port of Loading (POL)",
    portOfDischarge: "Port of Discharge (POD)",
    etd: "ETD",
    eta: "ETA",
    eventsTimeline: "Events Timeline",
    eventsTimelineHint:
      "Actual vs expected milestones, locations, vessels and transport modes.",
    bookingDetails: "Booking",
    containerQty: "Containers",
    bookingReference: "Reference",
    containersOnBooking: "{count} containers with event history below",
    updateHistoryTypeColumn: "Type",
    updateHistoryTypeTracking: "Tracking data",
    updateHistoryTypeMapping: "Item mapping",

    updateHistorySummary: "Summary",
    updateHistoryDetailAction: "Details",
    updateHistoryShowDetails: "View changes",
    updateHistoryHideDetails: "Hide",
    updateHistoryDetectedChanges: "Changes detected in this update",
    updateHistoryNoSummary: "(no summary)",
    event: "Event",

    vessel: "Vessel",
    voyage: "Voyage",
    mode: "Mode",
    code: "CODE",
    searchItemForTracking: "Search item for tracking",
    loadingConfig: "Loading configuration...",
    noReportConfigured:
      "No report is configured for the search. Configure one in <strong>System Modules</strong> → <strong>Tracking search configuration</strong>.",
    filterResults: "Filter results...",
    loadingReport: "Loading report...",
    noItemsOrNoMatch: "No items or none match the filter.",
    chooseNumberForTracking: "Choose the number to use for tracking:",
    backToList: "Back to list",
    linkedItemsTitle: "Linked items",
    noLinkedItems: "No linked items.",
    remove: "Remove",

    save: "Save",
    errorStartingTracking: "Error Starting Tracking",
    trackingStartedTitle: "Tracking Started",
    trackingStartedSuccess: "Tracking has been started successfully.",
    ok: "OK",
    confirmStopTitle: "Are you sure?",
    confirmStopText: "Do you want to stop tracking {number}?",
    yesStop: "Yes, stop",
    stopAll: "Stop all",
    stoppingAll: "Stopping…",
    confirmStopAllTitle: "Stop all trackings?",
    confirmStopAllText: "Do you want to stop all {count} active trackings?",
    yesStopAll: "Yes, stop all",
    allTrackingsStoppedSuccess: "{count} trackings have been stopped.",
    autoApplyActivate: "Enable automatic update",
    autoApplyDeactivate: "Disable automatic update",
    autoApplyOffTitle: "Apply tracking changes to linked items automatically, without validating one by one",
    autoApplyOnTitle: "Tracking changes are applied automatically to linked items",
    autoApplyConfirmOnTitle: "Enable automatic update?",
    autoApplyConfirmOnText: "Changes coming from tracking will be applied to linked items automatically, without going through \"Pending changes\". Current pending changes are applied right now.",
    autoApplyConfirmOffTitle: "Disable automatic update?",
    autoApplyConfirmOffText: "Tracking changes will again be left as \"Pending changes\" to validate manually.",
    autoApplyOnSuccessTitle: "Automatic update enabled",
    autoApplyOnSuccessText: "Pending changes were applied to {n} item(s).",
    autoApplyOffSuccessTitle: "Automatic update disabled",
    autoApplyOffSuccessText: "Upcoming changes will be left pending validation.",
    autoApplyError: "Error changing automatic update.",
    cancel: "Cancel",
    trackingStopped: "Tracking Stopped",
    trackingStoppedSuccess: "Tracking has been stopped successfully.",
    errorStoppingTracking: "Error stopping tracking",
    searchNotConfiguredTitle: "Search not configured",
    searchNotConfiguredHtml:
      "To search items from the database you must configure a report in <strong>System Modules</strong> → <strong>Tracking search configuration</strong>.",
    understood: "Understood",
    placeholderBooking: "Enter booking number",
    placeholderContainer: "Enter container number",
    placeholderBl: "Enter bill of lading number",
    placeholderTracking: "Enter tracking number",
    failedLoadTrackingDetails: "Failed to load tracking details",
    tabActive: "Active",
    tabStopped: "Stopped",
    tabCost: "Cost",
    stoppedAt: "Stopped at",
    noStoppedTrackings: "No stopped trackings",
    noStoppedTrackingsHint: "Trackings you stop will appear here.",
    costPerMonthSummary: "Cost per month",
    costPerMonthExplanation:
      "Based on start and stop dates. A tracking is charged for a month only if it was active for at least 24 hours in that month (e.g. created on the 15th and stopped on the 20th counts for that month; created on the 30th and stopped on the 1st does not).",
    month: "Month",
    activeCount: "Trackings that month",
    totalCost: "Total",
    noCostData: "No cost data.",
    costPerTracking: "Cost per tracking",
    priceAtLaunch: "Price at launch",
    monthlyCost: "Monthly cost",
    active: "Active",
    stopped: "Stopped",
    activeFromTo: "active",

    mappingColumn: "Mapping",
    mappingNone: "—",
    mappingOneField: "1 field",
    mappingFields: "{n} fields",
    mappingTitle: "Tracking result → linked item mapping",
    mappingHelp:
      "Define which tracking result fields will be copied to linked item fields (for future automatic update).",
    trackingPath: "Result field (path)",
    modelName: "Model",
    itemField: "Item field",
    itemFieldNone: "— None —",

    savedSuccess: "Saved successfully.",
    mappingNoLinkedItem:
      "This tracking has no linked item. Link an item to define the mapping (it will apply to all items of the same model).",

    trackingValue: "Tracking value",
    valueToApply: "From > To",
    saveMapping: "Save mapping",
    updateItemNow: "Update item now",
    updateItemNowNoMapping:
      "Assign at least one item field in the table to update.",
    updateItemNowSuccess:
      "The linked item has been updated with the tracking data.",
    updateItemNowError: "Error updating the item.",
    updateItemNowConfirmItems: "Item(s) to be updated:",
    updateItemNowConfirmFields: "Fields to be applied:",
    updateItemNowConfirm: "Accept and update",

    updateHistoryTitle: "Update history",
    updateHistoryEmpty:
      "No mapping updates have been applied yet for this tracking.",
    updateHistoryAt: "Date & time",
    updateHistorySource: "Source",
    updateHistorySourceManual: "Manual",
    updateHistorySourceWebhook: "Automatic",
    updateHistorySourceCron: "Scheduled cron",
    updateHistorySourceAutoApply: "Automatic update",
    updateHistoryItem: "Item",

    pendingChangesLabel: "Pending changes",
    pendingChangesTitle: "Pending changes for linked items",
    pendingChangesDetected: "Detected changes pending to apply:",
    pendingChangesItemsToUpdate: "{n} linked item(s) will be updated",
    pendingChangesApply: "Apply pending changes",
    pendingChangesApplySuccess: "{n} linked item(s) updated successfully.",
    pendingChangesApplyError: "Error applying pending changes.",
    pendingChangesLoadError: "Error loading pending changes.",
    pendingChangesNone: "No pending changes to apply.",
    pendingChangesDiscard: "Discard changes",
    pendingChangesDiscardConfirmTitle: "Discard pending changes?",
    pendingChangesDiscardConfirmText:
      "The pending changes badge will disappear. Linked items will not be updated. If tracking data changes again later, pending changes may reappear.",
    pendingChangesDiscardSuccess: "Pending changes discarded.",
    pendingChangesDiscardError: "Error discarding pending changes.",
  },

  excelMapping: {
    title: "Excel Mapping",
    subtitle: "Map Excel cells to model fields and import data",
    menuItem: "Excel Mapping",
    myMappings: "My mappings",
    createMapping: "Create mapping",
    importData: "Import data",
    loading: "Loading...",
    noMappings: "No mappings yet",
    noMappingsHint:
      "Create a mapping to link Excel cells to a model, then use it to import data.",
    name: "Name",
    targetModel: "Target model",
    mode: "Mode",
    modeSingle: "Single",
    modeRows: "Rows",
    actions: "Actions",
    step1Title: "1. Select target model",
    step1Hint: "Choose the model where imported data will be created.",
    model: "Model",
    selectModel: "— Select model —",
    importMode: "Import mode",
    modeSingleHelp:
      "Single record: map each cell to a field (one record per sheet)",
    modeRowsHelp: "Multiple rows: each row = one record, map columns to fields",
    next: "Next",
    step2Title: "2. Upload Excel template",
    step2Hint:
      "Upload an Excel file. We will show its cells so you can map each one to a model field.",
    parsing: "Parsing Excel...",
    sheet: "Sheet",
    noField: "—",
    cellMapHint: "Assign a model field to each cell that contains data.",
    groupArrayTitle: "Map rows to group array",
    groupArrayHint:
      "If your Excel has a table (several rows) that should become one array field (e.g. line items), set the row range and map columns to the group sub-fields.",
    groupArrayStartRow: "Data start row (0-based)",
    groupArrayEndRow: "End row (optional; leave empty = all)",
    groupArrayColumnHint: "Map each column index to a sub-field:",
    subFields: "sub-fields",
    optional: "Optional",
    headerRow: "Header row index",
    columnMapHint: "Map columns (by index) to fields below. Row 0 = first row.",
    back: "Back",
    step3Title: "3. Name and save",
    description: "Description",
    namePlaceholder: "e.g. Clients template",
    saveMapping: "Save mapping",
    saved: "Saved",
    savedHint: "Mapping saved. You can use it to import data.",
    error: "Error",
    parseError: "Could not parse Excel file",
    selectMapping: "Select mapping",
    selectMappingOption: "— Select a mapping —",
    excelFile: "Excel file",
    previewing: "Previewing...",
    preview: "Preview",
    records: "records",
    showingFirst20: "Showing first 20 rows.",
    total: "total",
    importNow: "Import now",
    noPreviewRecords: "No records to preview. Check mapping and file.",
    previewError: "Could not generate preview",
    importDone: "Import done",
    importDoneText: "Created {n} record(s).",
    importError: "Import failed",
    importErrorUnknown: "Record could not be created.",
    importErrorsCount: "{n} error(s).",
    deleteConfirm: "Delete mapping?",
    deleteConfirmText: "This cannot be undone.",
    delete: "Delete",
    deleted: "Deleted",
    savedMappingsHint:
      "Saved mappings: next time you only need to select one and upload your Excel file—no need to map again.",
    editMapping: "Edit mapping",
    editingMapping: "Editing mapping",
    step2HintEdit:
      "Re-upload the Excel template to view and edit cell/column mappings.",
    updateMapping: "Update mapping",
    updated: "Updated",
    updatedHint: "Mapping updated. You can use it to import data.",
    importWithThisMapping: "Import with this mapping (only upload file)",
    importOnlyUploadHint:
      "The mapping is already saved. Select it and upload an Excel file with the same format—no need to map again.",
    saveMappingHint:
      "Save this mapping once; later you will only need to select it and upload your Excel file to import.",
  },

  inmobiliaria: {
    menuItem: "Real estate",
    sourcesTab: "Sources",
    searchesTab: "Searches",
    resultsTab: "Results",
    addSource: "Add source",
    addSearch: "Create search",
    active: "Active",
    inactive: "Inactive",
    noSources: "No sources yet. Add listing site or portal URLs.",
    noSearches: "No searches yet.",
    noResults: "No results yet.",
    noActiveSources: "No active sources.",
    queryLabel: "Query (free text)",
    queryPlaceholder: "E.g. 3-bedroom in Palermo under USD 200,000",
    cronEnable: "Periodic search",
    cronDisable: "Disable periodic",
    cronOn: "Cron on",
    cronDaily: "Once a day",
    cronWeekly: "Once a week",
    cronModalTitle: "Periodic search",
    cronIntervalLabel: "Frequency",
    cronModalHint:
      "The search will run automatically with active sources at this frequency.",
    cronSave: "Save",
    runNow: "Search now",
    viewResults: "View results",
    status: "Status",
    allSearches: "All searches",
    selectSourcesHint: "Choose sources to use (defaults to all active).",
    maxResultsLabel: "Number of listings",
    maxResultsHint:
      "Oráculo searches all selected sources and returns the best matches, preferring the newest.",
    runQueued:
      "Search queued ({n} source(s), up to {max} listings). Oráculo will process shortly.",
    confirmDelete: "Delete?",
    colTitle: "Listing",
    colSource: "Source",
    colOperation: "Operation",
    colCity: "City",
    colBedrooms: "Beds",
    colSqm: "m²",
    colPrice: "Price",
    colLink: "Link",
    opSale: "Sale",
    opRent: "Rent",
    filterAll: "All",
    filterMin: "Min.",
    filterPriceMin: "Min price",
    filterPriceMax: "Max price",
    filterClear: "Clear filters",
    searchInProgress: "Search in progress…",
    searchBusyHint: "Wait until the current search finishes",
  },

  jurisprudencia: {
    menuItem: "Case law",
    browsePageTitle: "Case law",

    agentChatCardLabel: "Case law assistant",

    agentChatPlaceholder: "Type a message and press Send…",
    agentChatHistoryAnalyzeHint:
      "You’re viewing saved results from history. Ask me to review them (e.g. “analyse which ones fit”) and I’ll highlight the relevant judgments in green—no new SAIJ search.",
    agentOpeningGreetingLoading: "Generating a quick greeting with AI…",

    agentChatSend: "Send",
    agentChatClear: "Reset conversation",
    agentChatLoading: "Thinking…",
    searchDoneTitle: "Search completed (assistant)",

    newAgentChat: "New assisted conversation",
    searchHistoryTitle: "Saved search agreements",
    searchHistoryToggle: "Show history ({n})",
    searchHistoryViewResults: "View results",
    searchHistoryNoResultsStored:
      "This entry has no stored results (older searches). Try “Run again”.",
    searchHistoryLegacyBadge: "No snapshot",
    searchHistorySourceQuick: "Quick",
    searchHistorySourceDemanda: "From pleading",
    searchHistorySourceAgent: "Assistant",
    searchHistoryDelete: "Delete",
    searchHistoryDeleteTitle: "Remove from history",
    searchHistoryDeleteConfirm:
      "This saved search and its stored results will be removed. Continue?",
    searchHistoryRerun: "Run again",
    searchRerunDoneHint:
      "Re-ran the saved search from your history. Updated results below.",
    browseQuickAiSummary: "Quick AI search (single message)",

    browseQuickAiResultsHint:
      "Quick search: judgment list from the index (no relevance review until you ask).",

    browseAiPlaceholder:
      "E.g.: CSJN rulings on moral damages in traffic accidents in recent years",
    browseAiButton: "Search with AI",

    adminSaijApiDebugTitle: "SAIJ request debug (admins only)",
    adminSaijApiDebugIntro:
      "Includes wire q, facet string f, GET resultados.jsp URL, and when fallback runs the POST to /busqueda (fields and application/x-www-form-urlencoded body).",

    browseColTitle: "Title",
    browseColJurisdiction: "Jurisdiction",
    browseColTribunal: "Court / body",
    browseColDate: "Date",
    browseColTipoFallo: "Judgment type",

    browseColSnippet: "Excerpt",

    browseColLink: "Link",

    pageTitle: "Assistant for case law search",
    pageIntro:
      "This module is ExportAI’s assistant for Argentina’s SAIJ (legislation, judgments, summaries, opinions, doctrine). Direct automated search is currently focused on national case law; from an Escrito (MEV pleading record, technical model name «Demanda») you can run that AI-assisted search from the document text.",
    pageHintDemanda:
      "On an «Escrito» record, use the SAIJ-related search: it opens the same assistant chat as Jurisprudence, with your pleading text in context so you can refine before running the search.",

    searchRelated: "Search related case law (SAIJ)",
    modalTitle: "SAIJ search from pleading",
    escritoJurisModalIntro:
      "Chat with the assistant like on Jurisprudence: your pleading text is already in context. When you agree on what to look for, the assistant runs the SAIJ search and results appear below.",
    escritoJurisShortContextHint:
      "Little text was loaded from the pleading; you can still steer the assistant with your messages.",
    escritoJurisGreetingLoading: "Preparing the assistant…",
    escritoJurisFallbackGreeting:
      "Hi. I already have your pleading loaded—tell me what case law you want or which angles matter most.",
    loading: "Searching…",

    aiRelevantBadge: "Relevant (AI)",
    stopAgentTurn: "Stop",
    turnStoppedByUser:
      "You stopped the operation. Results already on screen are kept: you can pick links and save, or try again later.",
    chatErrorNetworkOrSaij:
      "We could not finish (network issue or the SAIJ site did not respond properly). This is usually overload or slowness on the official saij.gob.ar index, not a permanent ExportAI failure. Retry in a few minutes, try off-peak hours, or use Stop and a narrower search.",
    chatErrorTimeoutSaij:
      "The request timed out. When SAIJ is very slow, searches or analysis can hit the time limit; that does not mean your pleading or request is wrong. Try again later, overnight, or fetch fewer results.",

    progress: {},
    error: "The search could not be completed.",

    emptyDemandPopupTitle: "No pleading text to analyze",
    emptyDemandPopupText:
      "There is no useful text in «Full text» or the drafting sections, or nothing is saved on the server. Enter or save the record and try again.",
    emptyDemandPlantillaTitle: "No text to analyze",
    emptyDemandPlantillaText:
      "A template is selected but there is no drafting text, no useful plain-text snapshot on the record, or the template could not be loaded. Save the record (to refresh plain text), ensure the template has a body, or fill «Full text» or another section and try again.",

    hint: "Judgments from the public SAIJ index. If you ask for analysis, the server downloads a text fragment from each result URL and the AI uses it with the title and excerpt (still a snippet—read the full judgment on the official site). Verify every citation on saij.gob.ar before using it in a pleading.",
    whyThisResult: "Why this result appears",
    noRelevantAfterGather:
      "After two SAIJ passes, the AI did not find enough documents it considers clearly aligned with your request (cap {asked} relevant items; got {got}). Try rephrasing in the chat or use manual search.",
    relevanceGatherSummary:
      "Showing {n} result(s) the AI considers relevant (cap {target}; there may be fewer).",
    saijSumarioId: "SAIJ summary no.",
    aiNotes: "Notes:",
    queriesUsed: "AI-suggested queries",
    noResults: "No documents matched those queries.",
    openDoc: "View on SAIJ",
    selectAllWithUrl: "Select all (with link)",
    selectNone: "Clear selection",
    selectRowsHint:
      "Select results whose links you want to store on the record. They are added to «Case law references» without duplicating URLs.",
    noUrlForRow: "No SAIJ URL for this result.",
    saveToDemanda: "Save links to pleading",
    saving: "Saving…",
    saveOk: "Added {n} link(s) to case law references.",
    saveError:
      "Could not save links. Do you have permission to edit Escrito records (demanda.manage)?",
    dashboardShortcutTitle: "Case law",
    dashboardShortcutBody:
      "Search judgments and summaries with keywords, an assistant that narrows topic and scope, or detailed filters. Review your history and re-run a query whenever you need it.",
    dashboardShortcutCta: "Open case law",
  },

  mev: {
    dashboardShortcutTitle: "MEV — Cases",
    dashboardShortcutBody:
      "Look up court cases with the assistant, a one-line quick search, or manual filters by court and criteria. Results appear in a table and you can reopen past searches from history.",
    dashboardShortcutCta: "Open MEV",
    browsePageTitle: "Virtual Filing Desk (SCBA)",
    browseNavAria: "MEV screen sections",
    browseNavAssistant: "MEV search assistant",
    browseNavQuick: "Quick search",
    browseNavAmbito: "Change MEV scope",

    browseNavAmbitoActiveTitle:
      "An MEV scope is selected. Open this tab to see the summary or change it.",
    browseNavHistory: "Search history",
    browseNavHistoryEmpty: "No searches in your history yet.",
    browseNavAmbitoNotReady:
      "MEV access is not set up yet. Open the «MEV search assistant» tab and follow the chat steps.",
    browseNavAmbitoChangeAction: "Change scope (restart assistant)",
    browseNavAmbitoFootnote:
      "You will pick tribunal, department and forums again as on the portal. The assistant conversation restarts.",
    browseNavQuickNeedAmbito:
      "Finish MEV scope setup in the «MEV search assistant» tab first; then you can use quick search.",

    browseAiPlaceholder:
      "E.g. cases with carátula Pérez in the First Civil Chamber Presidency from the last month",

    searchHistoryViewResults: "View results",
    searchHistoryNoResultsStored: "No saved cases for this entry.",
    searchHistoryLegacyBadge: "No snapshot",
    searchHistorySourceQuick: "Quick",
    searchHistorySourceManual: "Manual",
    searchHistorySourceAgent: "Assistant",
    searchHistorySourceDefault: "Default list",
    gridColAmbito: "MEV scope",
    gridColDepartamento: "Judicial dept.",
    gridAmbitoSCJ: "Supreme Court (SCJ)",
    gridAmbitoLPC: "Criminal appeals (LPC)",
    gridAmbitoPZ: "Justice of the Peace (PZ)",
    gridAmbitoCC: "Judicial department (CC)",
    gridFueroFamilia: "Family forum",
    gridFueroPenal: "Criminal forum",
    gridDeptoCode: "Dept. {code}",
    searchHistoryDelete: "Delete",
    searchHistoryDeleteTitle: "Remove from history",
    searchHistoryDeleteConfirm: "This history entry will be removed. Continue?",
    searchHistoryRerun: "Run again",
    searchDoneTitle: "Search complete",
    newAgentChat: "New assistant chat",

    agentChatIntro:
      "I help you pick the MEV scope (Supreme Court, Casación, Justice of the Peace, judicial department), forums, court/office and search type. By default we show up to 30 cases in the grid (you can ask for more, up to 200, in the chat). When ready, I run the query.",
    agentCardIntroSetup:
      "First we set up MEV access like on the portal: tap the options I suggest. After your user is validated, I’ll ask whether to save this in the browser for next time.",
    agentAmbitoSearchModeQuestion:
      "On this MEV screen you have the usual search by court and caption, and your saved lists. How should we set up access from here?",
    agentAmbitoSearchModeGeneral: "General search (courts and caption)",
    agentAmbitoSearchModeMisListas: "Inside a saved list (My sets)",
    agentAmbitoSetListQuestion: "Which list should we use?",
    agentSaveAmbitoQuestion:
      "Save this access configuration in this browser? Next time you’ll get quick search with the same scope and fewer questions at the start.",
    agentSaveAmbitoQuestionWithSavedList:
      "Save MEV access and the list you picked (“{list}”) in this browser? Next time you’ll open with the same scope and list; filter by caption in the grid or ask the assistant.",
    agentSaveAmbitoQuestionWithSavedListNoLabel:
      "Save MEV access with the list you picked in this browser? Next time you’ll open with the same scope and list; filter by caption in the grid or ask the assistant.",
    agentSaveAmbitoYes: "Yes, save",
    agentSaveAmbitoNo: "No, just this time",
    agentSaveAmbitoThanks:
      "Saved in this browser — next time quick search will use the same scope. What are you looking for? Tell me in this chat (caption, court, case type, etc.) and we’ll continue from here.",
    agentSaveAmbitoThanksWithSavedList:
      "Done — scope and list are saved. Next time you land here directly; filter by caption in the list or type in the chat. What are you looking for?",
    agentNoSaveAmbitoAck:
      "Understood — only for this session; if you close the tab you’ll set up scope again. What are you looking for? Type it in this chat and we’ll continue.",
    agentChatPlaceholder:
      "E.g. García in La Plata, labour court, only «en letra»",
    agentChatSend: "Send",
    agentChatClear: "Reset conversation",
    agentChatLoading: "Thinking…",
    agentChatAbortTurn: "Stop search",
    quickSearchAbort: "Stop search",
    quickSearchLabel: "Quick search (one message)",
    quickSearchHint:
      "One message: the AI builds the JSON and queries MEV immediately. The grid shows at most 30 cases (fixed for quick search). Use the assistant and say how many rows you want (up to 200) to see more.",
    initialSetupHint:
      "Loading courts/offices for manual filters and the AI prompt. The MEV case list is not fetched until you search or use the button to load the module default list.",

    loadingListHint: "Fetching cases from MEV…",
    progress: {},
    agentOpeningGreetingLoading:
      "Generating a quick greeting with AI (may take a few seconds)…",
    personalCredsToggleHide: "Hide",
    personalCredsToggleShow: "Show",
    personalCredsTitle: "Your MEV portal login",
    personalCredsIntro:
      "You can use your own MEV (mev.scba.gov.ar) username and password. If saved, searches from this screen use that account instead of the one set by an admin in the module.",
    personalCredsBadgeOn: "Personal credentials active",
    personalCredsBadgeOff: "Using module account only",
    personalCredsUsuarioMasked: "Saved username",
    personalCredsPasswordMasked: "Password",
    personalCredsUsuario: "MEV username",
    personalCredsUsuarioPhUpdate: "Leave blank to keep current username",
    personalCredsPassword: "MEV password",
    personalCredsPasswordPhNew: "Password",
    personalCredsPasswordPhUpdate: "New password (optional)",
    personalCredsSave: "Save",
    personalCredsDelete: "Remove my connection",
    personalCredsDeleteTitle: "Remove personal credentials",
    personalCredsDeleteText:
      "MEV requests will go back to using only the module configuration account (if any).",
    personalCredsDeleteConfirm: "Remove",
    personalCredsFootnote:
      "Your password is stored encrypted on the server: it cannot be retrieved or shown here. Only the first two letters of the username are shown, with dots for the password.",
    personalCredsMissingTitle: "Missing fields",
    personalCredsMissingText: "Enter MEV username and password to save.",
    personalCredsSaved: "Credentials saved",
    personalCredsSavedImportText:
      "Your MEV connection is ready. You can import all your cases from «My Sets» right now.",
    personalCredsSavedImportButton: "Import",
    personalCredsSavedLaterButton: "Not now",
    personalCredsDeleted: "Personal credentials removed",
    importFromMySets: "Import cases from my sets",
    importFromMySetsLoading: "Reading sets and loading cases from MEV…",
    importFromMySetsConfirm:
      "Your MEV sets list will be read and matching cases will be imported. Each imported case will store the set name in the type field. This can take a while depending on how many cases you have in My Sets.",
    importFromMySetsStep1: "Sign in to the MEV portal with your user.",
    importFromMySetsStep2: "Read all sets from «My Sets» and their cases.",
    importFromMySetsStep3:
      "Import each case and assign its type from the set name.",
    importFromMySetsMayTakeMinutes: "This may take a few minutes.",
    importFromMySetsWorkingTitle: "Importing cases from My Sets…",
    importFromMySetsProgress1: "Connecting to MEV and opening My Sets…",
    importFromMySetsProgress2: "Reading sets and listing cases…",
    importFromMySetsProgress3: "Importing cases into the system…",
    importFromMySetsProgress4: "Assigning case type from set names…",
    importFromMySetsProgressCount:
      "Imported {imported}, failed {failed}. Processed {processed} of {total}…",
    importFromMySetsCancel: "Cancel import",
    importFromMySetsCancelledTitle: "Import cancelled",
    importFromMySetsCancelledText:
      "Import from My Sets was cancelled. You can start it again whenever you want.",
    importFromMySetsConfirmButton: "Import now",
    importFromMySetsDoneTitle: "Import completed",
    importFromMySetsNeedLoginTitle: "Sign in to MEV first",
    importFromMySetsNeedLoginText:
      "To import cases from «My Sets», first save your MEV username and password on this screen.",
    importFromMySetsError: "Could not import from your sets",
    personalCredsError: "Could not complete the action",
  },
  aiAboutMe: {
    title: "What the AI knows about you",
    open: "See everything it knows about you",
    teaserEmpty: "Getting to know you",
    teaserBusiest: "busiest on {day}",
    teaserDays: "{n} days",
    seeMore: "See more",
    configure: "Set up your AI",
    loading: "Looking at how you work…",
    empty: "It is still getting to know you: as you use the system, you will see here how you work and how it can help.",
    lead: "It learned from {days} of your working days: you touched {records} records, created {created} and updated {edited}.",
    start: "You usually start",
    end: "You usually finish",
    busiestDay: "Your busiest day",
    busiestHour: "Your peak hour",
    heatmapTitle: "When you work",
    heatCell: "{day} at {hour}: {n}",
    modelsTitle: "What you work with",
    created: "Created: {n}",
    edited: "Changes: {n}",
    looked: "Views: {n}",
    actions: "Actions: {n}",
    reportsTitle: "Reports you look at",
    reportOpened: "Opened: {n}",
    habitsTitle: "What you always do",
    daily: "Almost every day, around {hour}, {what}.",
    weekly: "On {day}, around {hour}, {what}.",
    sequence: "When you create a {from} record, within the next hour you usually create a {to} one.",
    what: {
      create: "you create new {model} records",
      edit: "you update {model} records",
      look: "you review {model}",
    },
    whatReport: "you open the report “{name}”",
    whatAction: "{action} for {model}",
    evidenceDays: "{n} of {of} days",
    evidenceWeeks: "{n} of {of} weeks",
    evidenceTimes: "{n} of {of} times",
    actionNames: {
      email_send: "you send emails",
      email_trigger_run: "you send emails",
      pdf_generate: "you generate PDFs",
      document_print: "you print documents",
      document_excel: "you export to Excel",
      list_excel_export: "you export to Excel",
      model_action: "you use action buttons",
      record_delete: "you delete records",
      record_delete_permanent: "you delete records",
      record_bulk_archive: "you archive records",
      record_restore: "you restore records",
      record_bulk_delete: "you delete records",
      record_bulk_unarchive: "you unarchive records",
      record_bulk_restore: "you restore records",
      record_apply_collect: "you apply collections",
      file_upload: "you upload files",
      copy_shipping_expenses: "you copy expenses",
      other: "you use actions",
    },
    weekdays: { 1: "Monday", 2: "Tuesday", 3: "Wednesday", 4: "Thursday", 5: "Friday", 6: "Saturday", 7: "Sunday" },
    weekdaysPlural: { 1: "Mondays", 2: "Tuesdays", 3: "Wednesdays", 4: "Thursdays", 5: "Fridays", 6: "Saturdays", 7: "Sundays" },
    weekdaysShort: { 1: "Mo", 2: "Tu", 3: "We", 4: "Th", 5: "Fr", 6: "Sa", 7: "Su" },
    cta: "Your assistant can do all of this for you: just ask in the chat, like you would ask a colleague.",
    ctaButton: "Ask the assistant",
    footer: "Based on what you did in the system over the last {days} days; it updates by itself. Only you can see it.",
  },
  aiHub: {
    shortcutExample: "For example: when I say “send me the report” on a Monday morning, I want this week's pending collections summary.",
    noChatHintAdmin: "Tap one to open that screen. With the chat turned on, the assistant does it for you (System features → Artificial intelligence).",
    noChatHintUser: "Tap one to open that screen. With the chat turned on, the assistant does it for you: ask an administrator.",
    peekAll: "Set up your AI",
    todayHint: "Tap one and the assistant does it in the chat.",
    topButton: "Artificial intelligence",
    title: "Artificial intelligence",
    subtitle: "What the AI suggests, what it learned and how you want it to work with you.",
    openChat: "Open the chat",
    unavailable: "AI is not enabled for your user.",
    todayTitle: "Today's suggestions",
    todayEmpty: "Nothing to suggest today.",
    adviceOff: "Daily tips are turned off for this company.",
    includedFree: "Included (free)",
    promptTitle: "Assistant instructions",
    promptHelp: "What the assistant knows about the company and how it should work. It applies to all users. Careful: this is your AI's brain. Only write things about the company here, not personal preferences or how you want it to talk to you: that is what shortcuts and custom tips are for.",
    promptOriginalBadge: "Original",
    promptCustomBadge: "Edited",
    promptEditedBy: "by {name} on {date}",
    promptOriginalChanged: "The original instructions were updated after they were edited and may include new rules. Review them or go back to the original.",
    promptReset: "Back to original",
    promptResetConfirm: "Go back to the original instructions? The edits will be lost.",
    promptAdminOnly: "Only an administrator can change them.",
    promptUnavailable: "The assistant is not enabled for this company yet.",
    customHelp: "Tell it what you want it to keep an eye on. Every morning it checks on its own, without you asking, and leaves what it found in “Today's suggestions”. For example: “let me know about shipments arriving this week without documents”.",
    shortcutsTitle: "Shortcuts",
    shortcutsHelp: "Your own words for when you write in the chat: explain once what you mean by a phrase and it understands it every time you use it. It does nothing on its own.",
    shortcutAdd: "Add",
    shortcutDeleteConfirm: "Delete this shortcut?",
    knowledgeTitle: "What it learned",
    knowledgeAdd: "Teach it something",
    knowledgeTermExample: "Term",
    knowledgeContentExample: "What it means in your company",
    modelTitle: "AI model",
    modelPerMessage: "{usd} per message",
    modelHelp: "The model that thinks and replies in the chat. It changes how well it understands and how much each message costs, not what it knows about the company: that is in the assistant instructions.",
    modelTipsTitle: "How to choose",
    modelTipCapableTitle: "More capable:",
    modelTipCapable: "better with long or ambiguous requests and multi-step entries, and reads scanned PDFs and photos. Each message costs more.",
    modelTipCheapTitle: "Cheaper:",
    modelTipCheap: "enough for simple questions, like “how many shipments arrive this week”. DeepSeek reads text PDFs, but not scanned ones or images.",
    modelTipSavingTitle: "Saving mode:",
    modelTipSaving: "the agent fetches less data at each step and each message is about 20% cheaper. If answers get worse, turn it off.",
    modelTipBilling: "The price per message is approximate: you pay for actual usage. The change applies to the whole company from the next message.",
    modelTipAdvice: "Daily tips and custom tips use their own model: this does not change them.",
    chatOffAdmin: "Needs the chat turned on: turn it on here",
    chatOffUser: "Needs the chat turned on: ask an administrator",
  },
  aiSection: {
    title: "Artificial intelligence",
    included: "Included",
    chatTitle: "Chat with your AI assistant",
    chatDescription:
      "Ask the assistant for what you need and it does it in the system: search, create or update records, read PDFs and images. Before saving anything it shows what it will enter and waits for your confirmation. It lives in the bubble at the bottom right and in /chat; it also answers the support chat.",
    adviceTitle: "Daily tips from your assistant",
    adviceDescription:
      "Every morning, when greeting each user, your assistant analyzes their activity and history and leaves the tips it finds to start the day: what is pending, what was left halfway and the reports they usually check.",
    adviceNoChat:
      "Without the chat, tips are still shown and open the right screen; for the assistant to do the work, the chat is needed.",
    customTitle: "Custom tips",
    customDescription:
      "Each user tells the assistant what to keep an eye on, e.g. “let me know about shipments arriving this week without documents”. Every morning the assistant checks on its own, without being asked, and leaves the result as one more tip.",
    customFree: "{count} per user, free.",
    customExtraLabel: "Allow more custom tips per user",
    customExtraHint: "From each user's third one, usage is billed: tokens with the same margin as the chat.",
    customUsageMonth: "Custom tips this month",
    customUsageFree: "included: {count} built",
    customUsagePaid: "paid: {count} built = ${amount}",
    customManage: "My custom tips",
    customUnavailable: "Custom tips are not available for your company yet.",
    customNoDeepseek: "Custom tips need the DeepSeek API key in Settings.",
    widgetsTitle: "AI widgets",
    widgetsDescription: "Dashboard widgets that bring you information and questions tailored to your company.",
    widgetsQuestions: "Questions: specific questions about how you work, to adjust the system to it.",
  },
  telegramAiBilling: {
      title: "AI Agent",
      description:
        "Assistant that acts in the system: the AI Agent chat (the bubble at the bottom right and /chat) and the support chat. Without this module, the support chat only answers technical questions.",
      botSetupTitle: "Bot setup",
      botSetupHint:
        "Create the bot manually in @BotFather (/newbot), copy the token, and paste it below. Then register the webhook.",
      modelTitle: "AI model",
      modelDefault: "default",
      modelColModel: "Model",
      modelColTypical: "Price per message",
      modelTypicalReal: "actual, {count} messages",
      modelTypicalEstimate: "estimate",
      modelSavingLabel: "Saving mode",
      modelSavingHint: "The agent fetches less data per step and reads PDFs as text: each message costs about 20% less. If answers get worse, turn it off.",
      modelHint: "Approximate price of one message to the agent. More capable models handle complex requests better; cheaper ones are enough for simple questions. DeepSeek reads PDFs that contain text (not scanned ones) and can't see images. The change applies from the next message.",
      modelSaved: "Model saved",
      modelPerMessage: "per message",
      usageToday: "Usage today",
      usageTodayHint: "AI Agent tokens (all channels) counted today.",
      usageMonth: "Current month",
      usageMonthHint:
        "After the trial, monthly AI Agent token usage is billed from recorded consumption.",
      usageMonthByChannel: "Breakdown by channel",
      channelSupport: "in-app chat",
      channelTelegram: "Telegram",
      usageEstimated: "estimated",
      tokens: "tokens",
      trialNoCharge: "free trial",
      payPerUse: "Pay per use (tokens)",
      swalTrial: "For 7 days you can use the AI Agent with no token charges.",
      swalPricing:
        "After that, each month is billed from tokens consumed (model input + output).",
      activated: "AI Agent enabled. Configure Telegram and authorized users if needed.",
      deactivated: "AI Agent disabled in billing.",
  },
  settings: {
    tabGeneral: "General",
    telegramParametersTab: "Telegram parameters",
  },
  twoFactor: {
    title: "Google Authenticator",
    enabled: "On: signing in asks for the code on your phone.",
    disabled: "Off: you sign in with your password only.",
    activate: "Turn on",
    deactivate: "Turn off",
    confirm: "Confirm",
    cancel: "Cancel",
    stepInstall: "Install Google Authenticator on your phone.",
    stepScan: "In the app, tap «+» and scan this QR code (or enter the key manually).",
    stepConfirm: "Type the 6-digit code shown in the app.",
    manualKey: "Key for manual entry",
    codePlaceholder: "6-digit code",
    codeRequired: "Type the Google Authenticator code.",
    invalidCode: "Incorrect code.",
    loginHint: "Type the 6-digit code from Google Authenticator.",
    backToPassword: "Back",
    disableHint: "To turn it off, type a current code from the app.",
    enabledOk: "Google Authenticator turned on",
    genericError: "The operation could not be completed.",
    adminReset: "Remove 2FA",
    adminResetHint: "For someone who lost their phone: they turn it back on from My profile.",
    adminResetConfirm: "{name} will be able to sign in with just the password until they turn Google Authenticator back on.",
  },
  telegramAi: {
    menuItem: "AI Agent",
    title: "AI Agent",
    telegramParametersTitle: "Telegram parameters",
    settingsBotManagedInBilling:
      "The Telegram bot (@Exportaibot or your own) is configured under Billing → System Features → AI Agent.",
    botSectionTitle: "Telegram bot",
    botSectionHint:
      "By default all tenants use @Exportaibot. You can use your own bot (name and avatar in BotFather) via “Change bot”.",
    platformBotBadge: "Platform bot",
    customBotBadge: "Custom bot",
    platformBotNotConfigured:
      "@Exportaibot has no token on the server yet. Contact platform support.",
    changeBot: "Change bot",
    changeBotTitle: "Use your own Telegram bot",
    changeBotStepsHtml:
      "<ol class=\"text-start small mb-0 ps-3\"><li>Open <a href=\"https://t.me/BotFather\" target=\"_blank\" rel=\"noopener noreferrer\"><strong>@BotFather</strong></a> on Telegram.</li><li>Send <code>/newbot</code> and follow the steps.</li><li>Copy the <strong>token</strong> BotFather gives you.</li><li>Paste it below and confirm.</li></ol>",
    changeBotTokenPlaceholder: "Paste the BotFather token",
    changeBotTokenRequired: "Enter the bot token.",
    changeBotConfirm: "Save",
    changeBotSuccess: "Your bot @{username} is now active on Telegram.",
    revertToPlatformBot: "Back to @{username}",
    revertToPlatformBotTitle: "Switch back to platform bot?",
    revertToPlatformBotText:
      "Your custom bot will be removed and you will use @{username} on Telegram again. Authorized Telegram users are unchanged.",
    revertToPlatformBotDone: "You are back on @{username}.",
    customWebhookRegistered: "Webhook registered:",
    webhookPublicBaseHintCustomBot:
      "Only for a custom bot when the API is not public: HTTPS base (e.g. ngrok) used when saving the token in AI Agent.",
    loading: "Loading…",
    moduleInactive:
      "Activate “AI Agent” under System modules for this tenant.",
    publicWebhookMissing:
      "Could not build a public webhook URL (missing host). Paste your tunnel HTTPS base in the optional field when registering, or set API_PUBLIC_URL / TELEGRAM_AI_PUBLIC_WEBHOOK_BASE on the server.",
    publicBaseFromRequest:
      "The webhook URL uses this request’s public API host (same as the app’s API). If Telegram cannot reach it, set API_PUBLIC_URL to the canonical HTTPS API base.",
    enabled: "Telegram assistant enabled",
    allowlistEmpty:
      "No authorized Telegram users are configured. Each user must set their @username in My profile; then select users here.",
    allowlistEmptyBilling:
      "No authorized Telegram users are configured. Users set their @username in My profile under Billing → System Features → AI Agent (Telegram bot only, not the in-app support chat).",
    allowedUserIds: "Authorized Telegram users",
    allowedUsersPlaceholder: "Search by name or email…",
    allowedUsersHint:
      "Telegram bot only: choose who may message the bot. Does not restrict the web support chat. The same Telegram @ cannot be used for two users.",
    allowlistMissingTelegramHint:
      "These users are authorized but have no Telegram username in My profile (they cannot use the bot until it is set):",
    profileUsername: "Telegram username",
    profileUsernamePlaceholder: "username (without @)",
    profileUsernameHint:
      "Your Telegram @username so the bot can recognize you. Required to be on the authorized Telegram users list.",
    noTelegramOnProfile: "no Telegram username on profile",
    allowlistDuplicateTitle: "Duplicate Telegram @",
    allowlistDuplicateText:
      "Two or more selected users share the same Telegram @ ({usernames}). Each authorized user needs a distinct @ in My profile.",
    skippedNoTelegramProfile:
      "Some selected users have no Telegram username on their profile and were not synced",
    botToken: "Bot token (BotFather)",
    botTokenKeep: "Leave blank to keep the current token",
    webhookUrl: "Webhook URL",
    webhookUrlPreview: "Webhook URL preview",
    webhookPublicBaseOptional: "Public HTTPS base (optional)",
    webhookPublicBasePlaceholder: "https://xxxx.ngrok-free.app",
    webhookPublicBaseHint:
      "E.g. ngrok to your local API (https, no trailing slash). Save with “Save”; required to enable “Register webhook” if the server is not public.",
    save: "Save",
    registerWebhook: "Register webhook with Telegram",
    registerWebhookNeedToken:
      "Configure and save the bot token before registering the webhook.",
    registerWebhookNeedUrl:
      "Enter a valid public HTTPS base (optional field) or use a public API URL; the webhook preview must not be empty.",
    saved: "Settings saved.",
    registerOk: "Webhook registered.",
    myRules: "My rules",
    myRulesHint:
      "Rules the AI applies in support chat (and on Telegram when AI Agent is enabled). You can also add them with «Remember this:» in chat. Shared with all users.",
    myRulesEmpty: "No saved rules yet.",
    myRulesAddLabel: "New rule",
    myRulesAddPlaceholder: "E.g. when I say MF I mean Masterfood",
    myRulesAddButton: "Add rule",
    myRulesSaved: "Rule saved.",
    myRulesDeleted: "Rule removed.",
    myRulesDeleteTitle: "Delete this rule?",
    myRulesDeleteText: "The AI will stop using it in future messages.",
    aiCaptureExportTitle: "AI assistant diagnostics",
    aiCaptureExportHint:
      "Download a JSON with all rounds from the same AI pipeline (web support chat, Telegram, and external API) from the last {days} days for this tenant. Share it with support or Cursor to debug issues.",
    aiCaptureExportTenant: "Tenant: {tenant}",
    aiCaptureExportCount: "Rounds stored in this period: {count}",
    aiCaptureExportButton: "Export diagnostics JSON",
    aiCaptureExportDone: "File downloaded.",
  },
  outlook: {
    profileTitle: "Outlook",
    mailboxOf: "Mailbox of",
    myMailbox: "Mine",
    mailboxOfUser: "Mailbox connected by the user:",
    readOnlyMailbox:
      "You are looking at another user's mailbox: you can read and analyse it, but replies go out from its owner's mailbox.",
    mailTitle: "Outlook mail",
    connectedAs: "Connected as",
    notConnected: "No Outlook account linked.",
    connect: "Connect Outlook",
    disconnect: "Disconnect",
    disconnectConfirm: "Disconnect your Outlook account?",
    unlink: "Unlink account",
    unlinkConfirm: "This deletes the stored Outlook link so you can connect the account again from scratch. Continue?",
    unreadableTokens: "An Outlook account is linked, but the system can no longer use its credentials. Unlink it and connect again.",
    sync: "Sync",
    syncDone: "Sync: {created} new, {updated} updated.",
    oauthNotConfigured: "An admin must set Client ID, secret and redirect URI under Settings → Outlook.",
    loading: "Loading…",
    clientId: "Client ID (Azure)",
    clientSecret: "Client secret",
    redirectUri: "Redirect URI",
    tenantId: "Tenant ID",
    settingsHint: "Register the app in Azure AD and use the same redirect URI (e.g. https://your-domain/outlook/oauth/callback).",
    saved: "Outlook settings saved.",
    oauthSuccess: "Outlook connected successfully.",
    oauthInvalid: "Invalid or expired OAuth callback.",
    allTypes: "All",
    received: "Received",
    sent: "Sent",
    unreadOnly: "Unread only",
    noEmails: "No synced emails.",
    selectEmail: "Select an email from the list.",
    from: "From",
    to: "To",
    tags: "Tags",
    reply: "Reply",
    replyPlaceholder: "Write your reply…",
    sendReply: "Send reply",
    replyAll: "Reply all",
    sentOk: "Sent",
    tagsHint: "Set keywords per tag (email_tags list). Applied when syncing or creating emails.",
    noTags: "No tags yet. Create the first one above, then set its keywords.",
    addTag: "Add tag",
    tagName: "Tag name",
    tagNamePlaceholder: "e.g. Urgent, Client X",
    keywordsPlaceholder: "keyword1, keyword2, …",
    proposedKeywords: "Proposals",
    autoKeywords: "Auto keywords",
    notifyTelegram: "Notify via Telegram when an email with this tag is received",
    noProposals: "No proposals (you need tagged emails first).",
    acceptProposals: "Accept proposals",
    tagsPanelTitle: "Outlook email tags",
    showingRange: "Showing {from}–{to} of {total}",
    newer: "Newer",
    older: "Older",
    analysisRobot: "What the analysis found",
    analysisUnverified: "Detected but no record to link it to",
    analyzePage: "Analyze this page",
    analyzePageConfirm:
      "{count} emails will be analyzed, one by one. Each one queries the AI and applies what it finds.",
    analyzePageAlready: "{count} of them were already analyzed: they will be re-analyzed with the current rules.",
    analyzePageProgress: "Analyzing {done} of {total}…",
    analyzePageDone: "Analyzed {done} of {total}. {failed} failed.",
    analyzeStopping: "Stopping…",
    warnNoRecord: "The milestone was detected, but the contract the email mentions is not in the system.",
    warnNoRecordAmbiguous: "The milestone was detected, but there are {count} possible contracts and none stands out: left unlinked.",
    warnNoShipment: "Could not link it to any shipment of contract {record}.",
    warnShipmentSuggested: "Shipment \"{shipment}\" was left as a suggestion: it needs manual confirmation.",
    warnUnverified: "{tags}: could not verify the email was with the party the tag requires.",
    warningsTitle: "Why it is incomplete",
    searchPlaceholder: "Search emails…",
    searchClear: "Clear search",
    firstPage: "Go to first page",
    lastPage: "Go to last page",
    pageNumber: "Page number",
    analysisRemoved: "Tags removed",
    analysisRejected: "Discarded by the AI",
    tagDirection: "Email direction",
    tagDirectionAny: "Any (received and sent)",
    tagDirectionReceived: "Received only",
    tagDirectionSent: "Sent only",
    clearTagFilter: "Clear filter",
    tagCounterparty: "Party that must be in the email",
    tagCounterpartyAny: "Any party of the record",
    tagCounterpartyHint:
      "Requires that party of the contract to take part in the email, as sender or recipient. Whether the email is incoming or outgoing is decided separately by \"Email direction\". Without a linked record the tag is not applied.",
    openLinkedRecord: "Open the linked record",
    openLinkedContact: "Open the contact",
    closeEmail: "Close and back to list",
    analyze: "Analyze",
    analyzeHint: "Finds which record and contact the email belongs to, and tags it.",
    analysisRecord: "Linked to",
    analysisContact: "Contact",
    analysisTags: "Tags",
    analysisConfidence: "Confidence",
    analysisAttachments: "Attachments read",
    analysisShipment: "Shipment",
    openLinkedShipment: "Open the shipment",
    confirmShipmentHint: "Suggested shipment: click to confirm it",
    confirmShipmentTitle: "Is this the shipment?",
    confirmShipmentAction: "Yes, that's it",
    analysisShipmentPending: "not applied: {reason}",
    analysisAttachmentsNone: "none could be read (a scan?)",
    deleteTagTitle: "Delete tag",
    deleteTagConfirm: "This deletes \u00ab{tag}\u00bb and removes it from the emails that had it. It cannot be undone.",
    deleteTagDone: "Removed from {count} email(s).",
    tabMail: "Mail",
    etd: "ETD",
    bookingNumber: "Booking",
    vessel: "Vessel",
    extracted: "Data from the email",
    tabKeywords: "Keywords",
    tagKeywordsTitle: "Keywords",
    tagFromAi: "decided by the AI from the content, no keyword matched",
    tagWithoutKeywords: "This tag has no keywords yet: add them in the Keywords tab",
    keywordsTabHint:
      "The keywords the system uses to recognise what each email is about. If an email should have been tagged and was not, add here the word or phrase that gives it away: separate them with commas and save.",
    tabConfig: "Settings",
    aiDescription: "When it applies (for the AI)",
    aiDescriptionPlaceholder: "E.g. the sender confirms the down payment was already paid",
    detection: {
      title: "Email detection",
      hint: "Rules used to link each incoming email to a record and tag it. Exact rules run first; the AI only picks among the candidates they leave.",
      enabled: "Enable detection",
      targetLegend: "Record to link",
      targetModel: "Model",
      codeField: "Code field",
      codePattern: "Code pattern",
      numberField: "Number field",
      numberPattern: "Number pattern",
      referencePattern: "Reference pattern (number with prefix)",
      referencePatternHint:
        "For emails that name the contract with a prefix instead of the full code, such as \"CT 6479\". The group in brackets is the number to look up; it counts as much as the exact code.",
      patternHint: "Regular expressions. The code is the strong match (e.g. 1157/00/26); a bare number (e.g. 1157) is only a weak candidate and needs the contact or the thread to confirm it.",
      signalsLegend: "Supporting signals",
      useThread: "Inherit the link from another email in the same thread",
      useContactCrossCheck: "Cross-check sender/recipient against the record's parties",
      contactRoleFields: "Party fields (references to Contact)",
      noContactFields: "The selected model has no fields referencing Contact.",
      aiLegend: "AI layer",
      aiEnabled: "Use AI to pick among candidates and detect tags",
      maxAgeHours: "Max age the cron sweeps (hours)",
      maxAgeHoursHint: "The cron only analyzes emails newer than this, so turning it on does not kick off an analysis of the whole mailbox history. Older emails are analyzed by hand with the button. 0 = no limit.",
      autoApply: "What gets applied automatically",
      autoApplyNever: "Nothing: everything waits for validation",
      autoApplyHigh: "Only high-confidence results; the rest stays pending",
      autoApplyHint: "Whatever is not applied automatically is left as a suggestion to review.",
    },
    hasAttachments: "Has attachments",
    openAttachment: "Open",
    downloadAttachment: "Download",
    noAttachmentsList: "No attachments found.",
  },
  Apropiar: "Appropriate",
  Apropiaciones: "Appropriations",
  "Cláusulas PDF": "PDF clauses",
  Envíos: "Shipments",
  "Líneas de posición": "Position lines",
  alisofContactPdfGaps: "{name} is missing in its contact record: {missing}. The PDF will print without it.",
  alisofContactPdfGapAddress: "address",
  alisofContactPdfGapTaxId: "Tax ID (RFC)",
  alisofEmpresaAdminRuleNotice:
    "The seller is from {country}: by the rule the managing company would be {expected}, and this contract has {current}. It is not changed automatically — check whether it should be.",
  alisofApropiarNeedsSave: "Save the contract before appropriating positions.",
  alisofApropiarNeedsPosicionId: "Save the contract so positions have an id before appropriating.",
  alisofApropiarSelectPositions: "Select at least one position.",
  alisofApropiarEnvioTitle: "Appropriate positions",
  alisofApropiarEnvioHint: "Complete the appropriation details for {count} position(s).",
  alisofEnvioGroupTitle: "Appropriation",
  alisofEnviosEmpty: "Appropriations are created when you appropriate positions.",
  alisofEnvioLineasLabel: "Appropriation positions",
  alisofEnvioLineaSinPosicion: "Position not found",
  Invoices: "Invoices",
  alisofFacturaGroupTitle: "Invoice",
  alisofFacturaCobrada: "Collected",
  alisofFacturaPendienteCobro: "Pending collection",
  alisofFacturasEmpty: "Invoices are created when you invoice appropriations.",
  alisofInvoicePdf: "INVOICE PDF",
  alisofFacturaDescripcionHint: "This is the concept: it prints on the invoice, above the bank details.",
  alisofFacturaSinContrato: "Invoice without contract",
  alisofFacturaSinContratoHint: "For advisory services and assigned contracts: customer and amount are entered by hand.",
  alisofSelectPosicion: "Select position {n}",
  alisofIncotermTooltip: "Incoterm agreed in the contract (Base price)",
  alisofApropiadaSinEnvioVinculado: "Appropriated (no linked appropriation)",
  alisofApropiarCreated: "Appropriation created",
  alisofApropiarNPositions: "Appropriate {count} positions",
  alisofAutoAppropriation: "Auto appropriation",
  alisofGroupPositions: "Group positions",
  alisofGroupPositionsConfirm:
    "Pending appropriations will be created by grouping available positions by shipment date. Continue?",
  alisofGroupPositionsNone: "No available positions to group.",
  alisofGroupPositionsDone: "{count} pending appropriation(s) created",
  alisofPositionsInApropiacionesHint:
    "{count} position(s) are already in Appropriations; edit shipment details there.",
  alisofEnvioTabPendiente: "Pending",
  alisofEnvioTabCumplido: "Done",
  alisofEnvioTabTodas: "All",
  alisofEnviosTabEmpty: "No appropriations in this tab.",
  alisofEnvioEstadoPendiente: "Pending",
  alisofEnvioEstadoCumplido: "Done",
  alisofMarkEnvioCumplido: "Mark as done",
  alisofMarkEnvioCumplidoConfirm:
    "Mark this appropriation as done? Linked positions will be set to Done.",
  alisofMarkEnvioCumplidoConfirmN:
    "Mark {count} appropriations as done? Linked positions will be set to Done.",
  alisofMarkEnvioCumplidoDone: "Appropriation marked as done",
  alisofMarkEnvioCumplidoDoneN: "{count} appropriations marked as done",
  alisofCreateApropiacionError: "Could not create the appropriation. Please try again.",
  alisofDeleteApropiacion: "Delete appropriation",
  alisofDeleteApropiacionTitle: "Delete this appropriation?",
  alisofDeleteApropiacionText:
    "The positions will be available to select and appropriate again.",
  alisofDeleteApropiacionDone: "Appropriation deleted",
  alisofDeleteApropiacionError: "Could not delete the appropriation. Please try again.",
  alisofApropiarExisting: "An appropriation already exists for this position",
  alisofVerApropiacion: "View appropriation",
  alisofVerApropiacionNum: "Appropriation {n}",
  alisofPosicionApropiada: "Appropriated",
  alisofHeroLinkedApropiaciones: "Linked appropriations",
  alisofApropiacionViaContrato: "Contract",
  alisofApropiacionViaPosicion: "Position",
  alisofFacturar: "Generate invoice",
  "Encabezado PDF": "PDF header",
  alisofFacturarTitle: "Invoice appropriations",
  alisofFacturarHint: "Total commission amount for {count} selected appropriation(s).",
  alisofFacturarSelectApropiaciones: "Select at least one appropriation.",
  alisofSelectApropiacion: "Select appropriation {n}",
  alisofFacturarCreated: "Invoice recorded",
  alisofEnvioFacturada: "Invoiced",
  alisofFacturarAlreadyFacturada: "One or more appropriations were already invoiced.",
  alisofFacturarNeedsCumplido:
    "Only appropriations marked as Done can be invoiced. Mark as done before invoicing.",
  alisofFacturarNeedsSave: "Save the contract before invoicing appropriations.",
  alisofCreateFacturaError: "Could not record the invoice. Please try again.",
  alisofRegenerarDescripcion: "Regenerate from appropriation",
  alisofFacturaTipoDeCambioRequerido: "Enter the exchange rate for type A invoices.",
  alisofFacturaTipoDeCambioBnaBillete: "BNA banknote sell",
  alisofFacturaTipoDeCambioBnaRefresh: "Refresh rate",
  alisofFacturaTipoDeCambioBnaError: "Could not fetch the BNA exchange rate.",
  alisofDeleteFacturaTitle: "Delete invoice",
  alisofDeleteFacturaText:
    "Delete this invoice? Its appropriations will become available to invoice again.",
  alisofDeleteFacturaError: "Could not delete the invoice. Please try again.",
  "Group by": "Group by",
  "By week": "By week",
  "By month": "By month",
  "By day": "By day",
  notaComercial: {
    noteForm: {
      sectionTitle: "Note data",
      modalTitle: "Commercial note",
      contactRoleLabel: "Contact role",
      contactRoleSupplierHint:
        "On the supplier side the role can be the expense type (Freight, Courrier…). The accounting side is still derived: any role other than Client is the supplier side.",
      contactRoleHint: "Saved with the note; a note created from an expense line takes that line's type.",
      noteKindLabel: "Note type",
      assignmentLabel: "Applied to",
      assignmentTarget: "Target",
      assignmentNone: "No reference (direct to contact)",
      assignmentShipping: "Apply to shipping",
      assignmentProform: "Apply to proforma",
      noCurrency: "No currency",
      commentPlaceholder: "Internal note comment",
      descriptionPlaceholder: "DESCRIPTION text for the PDF (e.g. country of origin / destination)",
      validationTitle: "Missing data",
      validationContact: "Select a contact.",
      currencyMismatchTitle: "Currency does not match",
      currencyMismatch: "The note is in a different currency than the expense it applies to. Create the note in the expense currency, or apply it to another operation.",
      missingFileTitle: "Note without attachment",
      missingFileText: "This note is one the contact issued to us and it has no file attached. Attaching the document is what backs it up.",
      missingFileCancel: "Attach it",
      validationAmount: "Amount must be greater than zero.",
      validationAppliedAmount: "Each application must have an amount greater than zero.",
      appliedNothingPendingTitle: "Expense already paid",
      appliedNothingPendingFor:
        "This note was opened for {contact}, from an expense that is already fully paid: there is no balance left to deduct the note from.",
      appliedNothingPendingOtherContact: "To create a note for another contact, use the",
      appliedNothingPendingSimulatorLink: "commercial notes simulator",
      validationAppliedNothingPending:
        "This expense is already fully paid: there is no balance left to deduct the note from, so it cannot be applied to it.",
      validationAppliedExceeds: "Applied total cannot exceed the note amount.",
      validationShipping: "Select a shipping.",
      validationProform: "Select a proforma.",
      numberLabel: "Number",
      numberLabelCredit: "Number (credit note)",
      numberLabelDebit: "Number (debit note)",
      numberLabelReceived: "Issuer number (optional)",
      numberPlaceholder: "E.g. 2074/2026 (optional)",
      numberPlaceholderReceived: "Number from the note we received",
      numberHint:
        "You can leave it empty and set it later; the system can assign the next automatic number.",
      numberHintCredit:
        "Separate credit sequence: use Generate, or leave empty to assign on save (e.g. 2074/2026).",
      numberHintDebit:
        "Separate debit sequence: use Generate, or leave empty to assign on save.",
      numberHintReceived:
        "Received notes are not auto-numbered; you can enter the issuer's document number.",
      numberGeneratedOnSaveCredit:
        "The credit note number is assigned when you save, from its own sequence.",
      numberGeneratedOnSaveDebit:
        "The debit note number is assigned when you save, from its own sequence.",
      attachFileLabel: "Attach file",
      attachFileHint: "Optional: the note as received, or any supporting document.",
      remainingCreditAlert:
        "A balance of {amount} remains unapplied to a shipment. You can use it on the next order by editing the note and applying it there.",
      creditOnFullyCollectedShippingTitle: "Cannot save the note",
      creditOnFullyCollectedShipping:
        "A note you issue that reduces the outstanding amount cannot be saved when the shipment is already fully settled: the note discounts from what is left, and nothing is left to discount. To claim an extra amount, issue a note that increases the outstanding amount. Notes the other party issues to us — a supplier credit, a client debit we receive — are not checked against the shipment balance.",
      creditExceedsShippingPendingTitle: "Amount exceeds pending",
      creditExceedsShippingPending:
        "A note cannot be saved when the amount applied to the shipment exceeds the outstanding amount it reduces. Reduce the amount, or use a note that increases the outstanding amount if you want to claim the difference.",
      contactNotInOperationTitle: "The note does not belong to this operation",
      contactNotInOperation:
        "A note cannot be applied to an operation its contact does not take part in. A shipment's participants are its client, its supplier and the contacts of its expenses. Pick another operation, or issue the note to the right contact.",
      kindClientCredit: "Our credit to client",
      kindClientDebit: "Our debit to client",
      kindSupplierCredit: "Supplier credit to us",
      kindSupplierDebit: "Supplier debit to us",
    },
    simulator: {
      title: "Commercial notes",
      subtitle: "Simple create + accounting and financial impact simulation",
      simulateImpact: "Simulate impact",
      createNote: "Create commercial note",
      impactTitle: "Impact simulation",
      lastSimulation: "Last simulation: {time}",
      impactEmpty: 'Complete the data and press "Simulate impact".',
      accountStatementCaption: "Current account (Account Statement)",
      currentBalance: "Current final balance",
      simulatedDelta: "Simulated delta",
      projectedBalance: "Projected final balance",
      accountingCaption: "Accounting",
      accountingCurrentTotal: "Current entry total (contact filter)",
      accountingDelta: "Simulated entry delta",
      accountingProjected: "Projected total",
      ruleCaption: "Rule applied for this simulation",
      financeCaption: "Finance (on applied reference)",
      collectedCurrent: "Current collected",
      collectedProjected: "Projected collected",
      balanceCurrent: "Current balance",
      balanceProjected: "Projected balance",
      invoiceCurrent: "Current invoice",
      invoiceProjected: "Projected invoice",
      financeEmpty: "No shipping/proforma reference: operation finance totals are not simulated.",
      recentTitle: "Latest commercial notes",
      recentEmpty: "No recent notes.",
      simulationFailed: "Could not simulate impact.",
      createFailed: "Could not create the note.",
      createdTitle: "Commercial note created",
      createdNumber: "Number",
      createdKind: "Note type",
      createdApplied: "Applied to operations",
      createdRemaining: "Not applied",
      createdNumberPending: "No number (assigned by the issuer)",
      openNote: "Open note",
      editNote: "Edit note",
      recentNumber: "Number",
      recentActions: "Actions",
    },
    pending: {
      badgeTitle: "Unapplied commercial notes: {count} — balance {amount}",
      badgeLine: "{name}: {amount}",
      badgeHint: "Click to see the detail",
      popupTitle: "Pending commercial notes",
      popupSubtitle: "{count} unapplied note(s) — total balance {amount}",
      popupMore: "And {count} more. Open the list to see them all.",
      popupOpenList: "See all",
      popupClose: "Close",
      ofTotal: "of",
      kindCredit: "Credit",
      kindDebit: "Debit",
    },
    pdf: {
      openButton: "Commercial note PDF",
      openTitle: "Open commercial note PDF",
    },
    unapply: {
      iconTitle: "Remove this note from the operation",
      confirmTitle: "Remove the note from the operation?",
      confirmText:
        "«{note}» will be removed from {operation}. The note itself is not deleted: its balance goes back to being available.",
      confirmButton: "Remove",
      errorTitle: "Could not remove the note",
      errorGeneric: "The note could not be removed from the operation. Please try again.",
      thisShipping: "this shipment",
    },
    assign: {
      buttonClient: "Assign client note",
      buttonSupplier: "Assign supplier note",
      tooltip: "This contact has {count} note(s) with balance. Apply one to this operation instead of creating another.",
    },
    offerOnCreate: {
      moduleConfigLabel: "Offer commercial notes when choosing a client or supplier",
      moduleConfigHelp:
        "When enabled, choosing the client of a Proforma or the supplier of a shipping proposes their commercial notes with available balance (any currency). It runs both on create and when changing the contact of an existing record; merely opening a record triggers nothing.",
      title: "Available commercial notes",
      subtitleClient:
        "This client has commercial notes with balance. You can apply one to the proforma.",
      subtitleSupplier:
        "This supplier gave us commercial notes with balance. You can apply one to the shipping.",
      kindCredit: "Credit",
      kindDebit: "Debit",
      totalAmount: "Total amount",
      availableBalance: "Available balance",
      applyAmount: "Amount to apply",
      skip: "Cancel",
      confirm: "Confirm",
      applyErrorTitle: "Could not apply the note",
      applyErrorExceeds: "The amount exceeds the note's available balance.",
      applyErrorGeneric: "The operation was created, but the commercial note could not be linked.",
    },
  },
  exchangeRates: {
    columns: {
      rate: "Exch. rate",
      rateHint: "Operation exchange rate: click to see the official rate or set your own",
      converted: "In {currency}",
      totalConverted: "Total in {currency}",
      systemCurrency: "System currency",
      convertedHint: "With the operation exchange rate: 1 {from} = {rate} {to}",
      mixed: "Several",
      mixedHint: "Each shipping has its own exchange rate: see and change it on each shipping's row or from the shipping",
      sharedHint: "This is the exchange rate of several shippings: change it on each shipping's row or from the shipping",
    },
    expenseChange: {
      title: "Expense currency change",
      question: "The expense was <strong>{amount} {from}</strong>. How do you want to save it in {to}?",
      convert: "Convert to {amount} {currency}",
      keep: "Keep {amount} {currency}",
      rateHint: "Operation exchange rate: 1 {from} = {rate} {to}. «Keep» is for when the currency was wrong and the amount was already in {to}.",
      hasPayments: "This expense already has <strong>{applied} {from}</strong> in <strong>«Applied / requested»</strong> (payments applied).<br><br>The currency was changed to {currency}, but <strong>«Amount»</strong> is not converted: it stays at <strong>{amount} {currency}</strong>, so it does not differ from what was applied in payments.<br><br>If the correct amount in {currency} is different, fix «Amount» and the payments that make up «Applied / requested».",
      missingRate: "There is no exchange rate to convert: the amount stays at {amount} {currency}.",
    },
    source: {
      bcra: "Official BCRA",
      frankfurter: "Official Frankfurter (ECB)",
      manual: "Custom",
      frozen: "Frozen",
      settings: "Settings rate",
      missing: "No rate",
    },
    modal: {
      title: "Exchange rate {from} → {to}",
      officialOf: "rate of {date}",
      noOfficial: "There is no official rate stored for this currency.",
      operationRate: "Operation exchange rate ({from} → {to})",
      unlockHint: "Unlock to set a custom rate for this operation",
      lockHint: "Lock again without changes",
      customHint: "The rate you enter applies to the whole operation and does not follow the official one.",
      setBy: "Set by {name} on {date}",
      frozenHint: "The operation is finished (collected and paid): the official rate of {date} was frozen.",
      restoreOfficial: "Back to official",
      cancel: "Cancel",
      save: "Save",
      saveError: "The exchange rate could not be saved.",
    },
  },
};
